/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * Improve API
 * BuildWitt Improve Service API
 * OpenAPI spec version: 1.0
 */
import { customInstance } from '../axios-instance';
export interface AuthorCohortDto {
  /** Cohort ID */
  id: number;
  /** Cohort title */
  title: string;
  /** External ID (GUID) */
  externalId: string;
}

/**
 * Privacy setting
 * @nullable
 */
export type CreateCourseResponsePrivacy = typeof CreateCourseResponsePrivacy[keyof typeof CreateCourseResponsePrivacy] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateCourseResponsePrivacy = {
  cohort: 'cohort',
  global: 'global',
} as const;

/**
 * Author cohort
 * @nullable
 */
export type CreateCourseResponseAuthorCohort = AuthorCohortDto | null;

export interface CreateCourseResponse {
  /** Course ID */
  id: number;
  /** URL-friendly slug */
  slug: string;
  /** Course title */
  title: string;
  /**
   * Course description
   * @nullable
   */
  description?: string | null;
  /**
   * Difficulty level
   * @nullable
   */
  courseLevel?: string | null;
  /**
   * Content type
   * @nullable
   */
  contentType?: string | null;
  /**
   * Privacy setting
   * @nullable
   */
  privacy?: CreateCourseResponsePrivacy;
  /** Linear progression enabled */
  linearProgression: boolean;
  /** Show curriculum on product page */
  showCurriculumOnProductPage: boolean;
  /**
   * Published timestamp (null = draft)
   * @nullable
   */
  publishedAt?: string | null;
  /** Created timestamp */
  createdAt: string;
  /** Updated timestamp */
  updatedAt: string;
  /** Number of modules in course */
  moduleCount: number;
  /**
   * Author cohort
   * @nullable
   */
  authorCohort?: CreateCourseResponseAuthorCohort;
}

/**
 * Privacy setting
 */
export type CourseSearchResultDtoPrivacy = typeof CourseSearchResultDtoPrivacy[keyof typeof CourseSearchResultDtoPrivacy];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CourseSearchResultDtoPrivacy = {
  cohort: 'cohort',
  global: 'global',
} as const;

export type CourseSearchResultDtoLocalizationsItem = { [key: string]: unknown };

/**
 * @nullable
 */
export type CourseSearchResultDtoAuthorCohort = AuthorCohortDto | null;

export interface CourseSearchResultDto {
  id: number;
  title: string;
  slug: string;
  locale: string;
  contentType: string;
  /** Privacy setting */
  privacy: CourseSearchResultDtoPrivacy;
  /** @nullable */
  externalId?: string | null;
  /** @nullable */
  featuredImage?: string | null;
  localizations: CourseSearchResultDtoLocalizationsItem[];
  /** @nullable */
  authorCohort?: CourseSearchResultDtoAuthorCohort;
  /** @nullable */
  userEnrollmentType?: string | null;
  /** @nullable */
  userProgressPercentage?: number | null;
  totalDurationSeconds: number;
  /** @nullable */
  watchedDurationSeconds?: number | null;
  /** @nullable */
  remainingDurationSeconds?: number | null;
  /** @nullable */
  courseProgress?: number | null;
}

/**
 * Course count per contentType across all pages (not just the current page)
 */
export type SearchCoursesResponseCategoryCounts = {[key: string]: number};

export interface SearchCoursesResponse {
  data: CourseSearchResultDto[];
  page: number;
  pageSize: number;
  totalCount: number;
  /** Course count per contentType across all pages (not just the current page) */
  categoryCounts: SearchCoursesResponseCategoryCounts;
}

export interface ModuleReference {
  /** Module ID */
  id: number;
  /** Module slug */
  slug: string;
  /** Module title */
  title: string;
  /**
   * Module subtitle
   * @nullable
   */
  subtitle?: string | null;
  /**
   * Published timestamp
   * @nullable
   */
  publishedAt?: string | null;
}

/**
 * Module details
 * @nullable
 */
export type CurriculumItemDtoModule = ModuleReference | null;

export interface CurriculumItemDto {
  /** Curriculum item ID */
  id: number;
  /** Course ID */
  courseId: number;
  /** Lesson ID */
  moduleId: number;
  /** Module type (always "lesson") */
  moduleType: string;
  /** Order in curriculum */
  order: number;
  /** Indentation level for nested structure */
  level: number;
  /** Whether progression is required */
  progression: boolean;
  /**
   * Module details
   * @nullable
   */
  module?: CurriculumItemDtoModule;
}

export interface GetCurriculumItemsResponse {
  /** List of curriculum items */
  items: CurriculumItemDto[];
}

export interface CourseModuleDto {
  /** Lesson ID */
  id: number;
  /** Module type (always "lesson") */
  __type: string;
  /** Module title */
  title: string;
  /** URL-friendly slug */
  slug: string;
  /**
   * Subtitle
   * @nullable
   */
  subtitle?: string | null;
  /**
   * Content/description
   * @nullable
   */
  content?: string | null;
  /** Whether progression is enabled for this module */
  progression: boolean;
  /** Whether this module is complete (always false for curriculum listing) */
  complete: boolean;
  /**
   * Published timestamp (null = draft)
   * @nullable
   */
  publishedAt?: string | null;
}

export interface GetCourseModulesResponse {
  /** List of course modules */
  modules: CourseModuleDto[];
}

/**
 * Attribute to filter
 */
export type CourseLessonAttributeFilterDtoField = typeof CourseLessonAttributeFilterDtoField[keyof typeof CourseLessonAttributeFilterDtoField];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CourseLessonAttributeFilterDtoField = {
  title: 'title',
  updatedAt: 'updatedAt',
  videoDuration: 'videoDuration',
  languages: 'languages',
} as const;

/**
 * Filter operator: co=contains, eq=equals, ne=not, sw=startsWith, ew=endsWith, pr=not null, gt/lt/ge/le for numeric/date
 */
export type CourseLessonAttributeFilterDtoOperator = typeof CourseLessonAttributeFilterDtoOperator[keyof typeof CourseLessonAttributeFilterDtoOperator];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CourseLessonAttributeFilterDtoOperator = {
  co: 'co',
  eq: 'eq',
  ne: 'ne',
  sw: 'sw',
  ew: 'ew',
  pr: 'pr',
  gt: 'gt',
  lt: 'lt',
  ge: 'ge',
  le: 'le',
} as const;

export interface CourseLessonAttributeFilterDto {
  /** Attribute to filter */
  field?: CourseLessonAttributeFilterDtoField;
  /** Value to match (not required for operator "pr") */
  value?: string;
  /** Filter operator: co=contains, eq=equals, ne=not, sw=startsWith, ew=endsWith, pr=not null, gt/lt/ge/le for numeric/date */
  operator?: CourseLessonAttributeFilterDtoOperator;
}

/**
 * How to combine multiple attribute filters
 */
export type CourseLessonFiltersDtoOperator = typeof CourseLessonFiltersDtoOperator[keyof typeof CourseLessonFiltersDtoOperator];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CourseLessonFiltersDtoOperator = {
  and: 'and',
  or: 'or',
} as const;

export interface CourseLessonFiltersDto {
  /** How to combine multiple attribute filters */
  operator?: CourseLessonFiltersDtoOperator;
  /** Attribute filter conditions */
  conditions?: CourseLessonAttributeFilterDto[];
}

/**
 * Video duration in seconds
 * @nullable
 */
export type CourseLessonDtoVideoDuration = { [key: string]: unknown } | null;

export interface CourseLessonDto {
  /** Lesson ID */
  id: number;
  /** Lesson title */
  title: string;
  /** Lesson slug */
  slug: string;
  /**
   * Video duration in seconds
   * @nullable
   */
  videoDuration: CourseLessonDtoVideoDuration;
  /** Supported language codes */
  languages: string[];
  /** Updated timestamp */
  updatedAt: string;
  /** Created timestamp */
  createdAt: string;
}

export interface ListCourseLessonsResponse {
  /** List of lessons */
  data: CourseLessonDto[];
  /** Total number of lessons */
  total: number;
  /** Current page number */
  page: number;
  /** Page size */
  pageSize: number;
}

/**
 * Attribute to filter
 */
export type CourseQuizAttributeFilterDtoField = typeof CourseQuizAttributeFilterDtoField[keyof typeof CourseQuizAttributeFilterDtoField];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CourseQuizAttributeFilterDtoField = {
  title: 'title',
  updatedAt: 'updatedAt',
  languages: 'languages',
} as const;

/**
 * Filter operator: co=contains, eq=equals, ne=not, sw=startsWith, ew=endsWith, pr=not null, gt/lt/ge/le for numeric/date
 */
export type CourseQuizAttributeFilterDtoOperator = typeof CourseQuizAttributeFilterDtoOperator[keyof typeof CourseQuizAttributeFilterDtoOperator];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CourseQuizAttributeFilterDtoOperator = {
  co: 'co',
  eq: 'eq',
  ne: 'ne',
  sw: 'sw',
  ew: 'ew',
  pr: 'pr',
  gt: 'gt',
  lt: 'lt',
  ge: 'ge',
  le: 'le',
} as const;

export interface CourseQuizAttributeFilterDto {
  /** Attribute to filter */
  field?: CourseQuizAttributeFilterDtoField;
  /** Value to match (not required for operator "pr") */
  value?: string;
  /** Filter operator: co=contains, eq=equals, ne=not, sw=startsWith, ew=endsWith, pr=not null, gt/lt/ge/le for numeric/date */
  operator?: CourseQuizAttributeFilterDtoOperator;
}

/**
 * How to combine multiple attribute filters
 */
export type CourseQuizFiltersDtoOperator = typeof CourseQuizFiltersDtoOperator[keyof typeof CourseQuizFiltersDtoOperator];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CourseQuizFiltersDtoOperator = {
  and: 'and',
  or: 'or',
} as const;

export interface CourseQuizFiltersDto {
  /** How to combine multiple attribute filters */
  operator?: CourseQuizFiltersDtoOperator;
  /** Attribute filter conditions */
  conditions?: CourseQuizAttributeFilterDto[];
}

/**
 * Video duration in seconds
 * @nullable
 */
export type CourseQuizDtoVideoDuration = { [key: string]: unknown } | null;

export interface CourseQuizDto {
  /** Quiz ID */
  id: number;
  /** Quiz title */
  title: string;
  /** Quiz slug */
  slug: string;
  /**
   * Video duration in seconds
   * @nullable
   */
  videoDuration: CourseQuizDtoVideoDuration;
  /** Supported language codes */
  languages: string[];
  /** Updated timestamp */
  updatedAt: string;
  /** Created timestamp */
  createdAt: string;
}

export interface ListCourseQuizzesResponse {
  /** List of quizzes */
  data: CourseQuizDto[];
  /** Total number of quizzes */
  total: number;
  /** Current page number */
  page: number;
  /** Page size */
  pageSize: number;
}

/**
 * Attribute to filter
 */
export type CourseEnrollmentAttributeFilterDtoField = typeof CourseEnrollmentAttributeFilterDtoField[keyof typeof CourseEnrollmentAttributeFilterDtoField];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CourseEnrollmentAttributeFilterDtoField = {
  firstname: 'firstname',
  lastname: 'lastname',
  email: 'email',
  jobTitle: 'jobTitle',
  jobCategory: 'jobCategory',
  division: 'division',
  supervisorName: 'supervisorName',
  employeeCode: 'employeeCode',
  customFieldValue1: 'customFieldValue1',
  customFieldValue2: 'customFieldValue2',
  customFieldValue3: 'customFieldValue3',
  progress: 'progress',
  enrolled: 'enrolled',
  enrollmentType: 'enrollmentType',
  hireDate: 'hireDate',
  titleStartDate: 'titleStartDate',
  dueDate: 'dueDate',
  assignedOn: 'assignedOn',
} as const;

/**
 * Operator: co=contains, eq/is=equals, ne=not equals, sw/ew=starts/ends with, pr=present, gt/lt/ge/le for progress and date fields
 */
export type CourseEnrollmentAttributeFilterDtoOperator = typeof CourseEnrollmentAttributeFilterDtoOperator[keyof typeof CourseEnrollmentAttributeFilterDtoOperator];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CourseEnrollmentAttributeFilterDtoOperator = {
  co: 'co',
  eq: 'eq',
  ne: 'ne',
  sw: 'sw',
  ew: 'ew',
  pr: 'pr',
  gt: 'gt',
  lt: 'lt',
  ge: 'ge',
  le: 'le',
  is: 'is',
} as const;

export interface CourseEnrollmentAttributeFilterDto {
  /** Attribute to filter */
  field?: CourseEnrollmentAttributeFilterDtoField;
  /** Value to match. For `progress`, numeric string (e.g. "100"). For `enrolled`, "true" or "false". For `enrollmentType`, string (same operators as name/email). For `hireDate`, `titleStartDate`, `dueDate`, `assignedOn`, ISO date string. Not required for operator `pr`. */
  value?: string;
  /** Operator: co=contains, eq/is=equals, ne=not equals, sw/ew=starts/ends with, pr=present, gt/lt/ge/le for progress and date fields */
  operator?: CourseEnrollmentAttributeFilterDtoOperator;
}

/**
 * Combine conditions
 */
export type CourseEnrollmentFiltersDtoOperator = typeof CourseEnrollmentFiltersDtoOperator[keyof typeof CourseEnrollmentFiltersDtoOperator];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CourseEnrollmentFiltersDtoOperator = {
  and: 'and',
  or: 'or',
} as const;

export interface CourseEnrollmentFiltersDto {
  /** Combine conditions */
  operator?: CourseEnrollmentFiltersDtoOperator;
  conditions?: CourseEnrollmentAttributeFilterDto[];
}

/**
 * Job title
 * @nullable
 */
export type CourseEnrollmentDtoJobTitle = { [key: string]: unknown } | null;

/**
 * Job category
 * @nullable
 */
export type CourseEnrollmentDtoJobCategory = { [key: string]: unknown } | null;

/**
 * Division
 * @nullable
 */
export type CourseEnrollmentDtoDivision = { [key: string]: unknown } | null;

/**
 * Hire date
 * @nullable
 */
export type CourseEnrollmentDtoHireDate = { [key: string]: unknown } | null;

/**
 * Title start date
 * @nullable
 */
export type CourseEnrollmentDtoTitleStartDate = { [key: string]: unknown } | null;

/**
 * Supervisor name
 * @nullable
 */
export type CourseEnrollmentDtoSupervisorName = { [key: string]: unknown } | null;

/**
 * Custom field value 1
 * @nullable
 */
export type CourseEnrollmentDtoCustomFieldValue1 = { [key: string]: unknown } | null;

/**
 * Custom field value 2
 * @nullable
 */
export type CourseEnrollmentDtoCustomFieldValue2 = { [key: string]: unknown } | null;

/**
 * Custom field value 3
 * @nullable
 */
export type CourseEnrollmentDtoCustomFieldValue3 = { [key: string]: unknown } | null;

/**
 * Employee code
 * @nullable
 */
export type CourseEnrollmentDtoEmployeeCode = { [key: string]: unknown } | null;

/**
 * Enrollment ID if enrolled
 * @nullable
 */
export type CourseEnrollmentDtoEnrollmentId = { [key: string]: unknown } | null;

/**
 * Course enrollment progress (0-100)
 * @nullable
 */
export type CourseEnrollmentDtoProgress = { [key: string]: unknown } | null;

/**
 * Enrollment type
 * @nullable
 */
export type CourseEnrollmentDtoEnrollmentType = { [key: string]: unknown } | null;

/**
 * Latest lesson due date for this course enrollment (from lesson enrollments), same source as enrolled-courses dueOn
 * @nullable
 */
export type CourseEnrollmentDtoDueDate = { [key: string]: unknown } | null;

/**
 * Date user was enrolled
 * @nullable
 */
export type CourseEnrollmentDtoAssignedOn = { [key: string]: unknown } | null;

export interface CourseEnrollmentDto {
  /** User ID */
  id: number;
  /** User first name */
  firstname: string;
  /** User last name */
  lastname: string;
  /** User email */
  email: string;
  /**
   * Job title
   * @nullable
   */
  jobTitle: CourseEnrollmentDtoJobTitle;
  /**
   * Job category
   * @nullable
   */
  jobCategory: CourseEnrollmentDtoJobCategory;
  /**
   * Division
   * @nullable
   */
  division: CourseEnrollmentDtoDivision;
  /**
   * Hire date
   * @nullable
   */
  hireDate: CourseEnrollmentDtoHireDate;
  /**
   * Title start date
   * @nullable
   */
  titleStartDate: CourseEnrollmentDtoTitleStartDate;
  /**
   * Supervisor name
   * @nullable
   */
  supervisorName: CourseEnrollmentDtoSupervisorName;
  /**
   * Custom field value 1
   * @nullable
   */
  customFieldValue1: CourseEnrollmentDtoCustomFieldValue1;
  /**
   * Custom field value 2
   * @nullable
   */
  customFieldValue2: CourseEnrollmentDtoCustomFieldValue2;
  /**
   * Custom field value 3
   * @nullable
   */
  customFieldValue3: CourseEnrollmentDtoCustomFieldValue3;
  /**
   * Employee code
   * @nullable
   */
  employeeCode: CourseEnrollmentDtoEmployeeCode;
  /** Is the user enrolled in this course */
  enrolled: boolean;
  /**
   * Enrollment ID if enrolled
   * @nullable
   */
  enrollmentId: CourseEnrollmentDtoEnrollmentId;
  /**
   * Course enrollment progress (0-100)
   * @nullable
   */
  progress: CourseEnrollmentDtoProgress;
  /**
   * Enrollment type
   * @nullable
   */
  enrollmentType: CourseEnrollmentDtoEnrollmentType;
  /**
   * Latest lesson due date for this course enrollment (from lesson enrollments), same source as enrolled-courses dueOn
   * @nullable
   */
  dueDate: CourseEnrollmentDtoDueDate;
  /**
   * Date user was enrolled
   * @nullable
   */
  assignedOn: CourseEnrollmentDtoAssignedOn;
}

export interface ListCourseEnrollmentsResponse {
  /** List of enrollment records */
  data: CourseEnrollmentDto[];
  /** Total number of records (for pagination) */
  total: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  pageSize: number;
}

export interface FeaturedImageDto {
  /** File ID */
  id: number;
  /** File URL */
  url: string;
  /** File name */
  name: string;
  /** MIME type */
  mime: string;
}

/**
 * Privacy setting
 * @nullable
 */
export type CourseResponsePrivacy = typeof CourseResponsePrivacy[keyof typeof CourseResponsePrivacy] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CourseResponsePrivacy = {
  cohort: 'cohort',
  global: 'global',
} as const;

/**
 * Author cohort details
 * @nullable
 */
export type CourseResponseAuthorCohort = AuthorCohortDto | null;

/**
 * Featured image details
 * @nullable
 */
export type CourseResponseFeaturedImage = FeaturedImageDto | null;

export interface CourseResponse {
  /** Course ID */
  id: number;
  /** URL-friendly slug */
  slug: string;
  /** Course title */
  title: string;
  /**
   * Course description
   * @nullable
   */
  description?: string | null;
  /**
   * Course content (HTML)
   * @nullable
   */
  content?: string | null;
  /**
   * Difficulty level
   * @nullable
   */
  courseLevel?: string | null;
  /**
   * Content type
   * @nullable
   */
  contentType?: string | null;
  /**
   * Privacy setting
   * @nullable
   */
  privacy?: CourseResponsePrivacy;
  /** Linear progression enabled */
  linearProgression: boolean;
  /** Show curriculum on product page */
  showCurriculumOnProductPage: boolean;
  /** Number of modules */
  moduleCount: number;
  /** Number of enrollments */
  enrollmentCount: number;
  /** Enrollments attributed to the course author cohort (matches Strapi cohort-scoped enrollment count) */
  cohortAuthoredEnrollmentCount: number;
  /** Enrollments where the learner is a member of the requesting Training Admin owner cohort (Strapi cohortMembersEnrollmentCount) */
  cohortMembersEnrollmentCount: number;
  /** Number of completions */
  completionCount: number;
  /** Whether this course is blacklisted for the current cohort */
  isBlacklisted: boolean;
  /**
   * Video URL
   * @nullable
   */
  videoUrl?: string | null;
  /**
   * Certification duration in days
   * @nullable
   */
  certificationDuration?: number | null;
  /**
   * Personal development hours
   * @nullable
   */
  personalDevelopmentHours?: number | null;
  /**
   * Continuing education units
   * @nullable
   */
  continuingEducationUnits?: number | null;
  /**
   * Time estimate in hours
   * @nullable
   */
  timeEstimateHours?: number | null;
  /** Locale (language code) */
  locale?: string;
  /**
   * Author cohort details
   * @nullable
   */
  authorCohort?: CourseResponseAuthorCohort;
  /**
   * Featured image details
   * @nullable
   */
  featuredImage?: CourseResponseFeaturedImage;
  /**
   * Published timestamp (null = draft)
   * @nullable
   */
  publishedAt?: string | null;
  /** Available content locales for this course (from this and linked localizations) */
  availableLocales?: string[];
  /** Created timestamp */
  createdAt: string;
  /** Updated timestamp */
  updatedAt: string;
  /** Job categories for recommended weighting (Job Training) */
  jobCategory?: string[];
  /** Work categories for recommended weighting (Job Training) */
  workCategory?: string[];
}

export interface UserCourseEnrollmentDto {
  /** Enrollment ID */
  enrollmentId: number;
  /** Enrollment type */
  enrollmentType: string;
  /** Progress percentage (0-100) */
  progress: number;
  /**
   * Completion timestamp
   * @nullable
   */
  completedAt?: string | null;
  /**
   * Start timestamp
   * @nullable
   */
  startedAt?: string | null;
}

/**
 * User enrollment data (null if not enrolled)
 * @nullable
 */
export type CourseDetailsDtoEnrollment = UserCourseEnrollmentDto | null;

export interface CourseDetailsDto {
  /** Course ID */
  id: number;
  /** URL-friendly slug */
  slug: string;
  /** Course title */
  title: string;
  /**
   * Course description
   * @nullable
   */
  description?: string | null;
  /**
   * Difficulty level
   * @nullable
   */
  courseLevel?: string | null;
  /**
   * Content type
   * @nullable
   */
  contentType?: string | null;
  /**
   * Thumbnail URL
   * @nullable
   */
  thumbnailUrl?: string | null;
  /** Linear progression enabled */
  linearProgression: boolean;
  /** Total number of lessons */
  totalLessons: number;
  /** Total number of quizzes */
  totalQuizzes: number;
  /**
   * Estimated duration in minutes
   * @nullable
   */
  estimatedDuration?: number | null;
  /**
   * User enrollment data (null if not enrolled)
   * @nullable
   */
  enrollment?: CourseDetailsDtoEnrollment;
  /** Created timestamp */
  createdAt: string;
  /** Updated timestamp */
  updatedAt: string;
}

export interface GetCourseDetailsResponse {
  course: CourseDetailsDto;
}

/**
 * Module type
 */
export type CurriculumModuleDtoType = typeof CurriculumModuleDtoType[keyof typeof CurriculumModuleDtoType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CurriculumModuleDtoType = {
  lesson: 'lesson',
  quiz: 'quiz',
  survey: 'survey',
} as const;

export interface CurriculumModuleDto {
  /** Module ID (lesson or quiz ID) */
  id: number;
  /** Module type */
  type: CurriculumModuleDtoType;
  /** URL-friendly slug */
  slug: string;
  /** Module title */
  title: string;
  /** Order in curriculum */
  order: number;
  /**
   * Video duration in seconds
   * @nullable
   */
  duration?: number | null;
  /**
   * Video thumbnail URL
   * @nullable
   */
  videoThumbnailUrl?: string | null;
  /** User is enrolled in this module */
  enrolled: boolean;
  /**
   * Enrollment ID if enrolled
   * @nullable
   */
  enrollmentId?: number | null;
  /** Module is completed */
  complete: boolean;
  /**
   * Completion timestamp
   * @nullable
   */
  completedAt?: string | null;
  /** Module is locked (linear progression) */
  isLocked: boolean;
  /**
   * Passing score for quiz (0-100)
   * @nullable
   */
  passingScore?: number | null;
  /**
   * User score for quiz (0-100)
   * @nullable
   */
  userScore?: number | null;
}

export interface GetCourseCurriculumResponse {
  items: CurriculumModuleDto[];
  /** Total number of curriculum items */
  totalItems: number;
  /** Number of completed items */
  completedItems: number;
  /** Progress percentage (0-100) */
  progressPercent: number;
}

export interface LessonQuizDto {
  /** Quiz ID */
  id: number;
  /** Quiz slug */
  slug: string;
  /** Quiz title */
  title: string;
  /** Number of questions */
  questionCount?: number;
}

export interface LessonFileDto {
  /** File ID */
  id: number;
  /** File name */
  name: string;
  /** File URL */
  url: string;
  /** File size in bytes */
  size?: number;
  /** MIME type */
  mime?: string;
}

/**
 * Attached quiz (if any)
 * @nullable
 */
export type GetLessonForCourseResponseQuiz = LessonQuizDto | null;

export interface GetLessonForCourseResponse {
  /** Lesson ID */
  id: number;
  /** URL-friendly slug */
  slug: string;
  /** Lesson title */
  title: string;
  /**
   * Lesson subtitle
   * @nullable
   */
  subtitle?: string | null;
  /**
   * Lesson content (HTML)
   * @nullable
   */
  content?: string | null;
  /**
   * Video URL
   * @nullable
   */
  videoUrl?: string | null;
  /**
   * Video type (vimeo, wistia, etc)
   * @nullable
   */
  videoType?: string | null;
  /**
   * Video thumbnail URL
   * @nullable
   */
  videoThumbnailUrl?: string | null;
  /**
   * Video duration in seconds
   * @nullable
   */
  videoDuration?: number | null;
  /**
   * Video transcript URL
   * @nullable
   */
  videoTranscriptUrl?: string | null;
  /**
   * Published timestamp
   * @nullable
   */
  publishedAt?: string | null;
  /**
   * Lesson enrollment ID (if enrolled)
   * @nullable
   */
  enrollmentId?: number | null;
  /** Whether lesson is complete */
  complete: boolean;
  /**
   * Available from date
   * @nullable
   */
  availableFrom?: string | null;
  /**
   * Started at timestamp
   * @nullable
   */
  startedAt?: string | null;
  /**
   * Completed at timestamp
   * @nullable
   */
  completedAt?: string | null;
  /**
   * Video playback position in seconds
   * @nullable
   */
  videoTime?: number | null;
  /**
   * Video length in seconds
   * @nullable
   */
  videoLength?: number | null;
  /**
   * Attached quiz (if any)
   * @nullable
   */
  quiz?: GetLessonForCourseResponseQuiz;
  /** Attached files */
  files?: LessonFileDto[];
  /** Course ID */
  courseId: number;
  /** Course slug */
  courseSlug: string;
}

export interface GetQuizForCourseResponse {
  /** Quiz ID */
  id: number;
  /** URL-friendly slug */
  slug: string;
  /** Quiz title */
  title: string;
  /**
   * Quiz subtitle
   * @nullable
   */
  subtitle?: string | null;
  /**
   * Quiz content/instructions (HTML)
   * @nullable
   */
  content?: string | null;
  /** Number of questions in the quiz */
  questionCount: number;
  /**
   * Score required to pass (percentage)
   * @nullable
   */
  scoreRequired?: number | null;
  /** Whether to randomize question order */
  randomizeOrder: boolean;
  /**
   * Limit of questions to serve (null = all)
   * @nullable
   */
  servedQuestionLimit?: number | null;
  /** Whether to reveal correct answers after submission */
  revealAnswers: boolean;
  /**
   * Published timestamp
   * @nullable
   */
  publishedAt?: string | null;
  /**
   * Quiz enrollment ID (if enrolled)
   * @nullable
   */
  enrollmentId?: number | null;
  /** Whether quiz is complete (passed) */
  complete: boolean;
  /**
   * Available from date
   * @nullable
   */
  availableFrom?: string | null;
  /**
   * Started at timestamp
   * @nullable
   */
  startedAt?: string | null;
  /**
   * Completed at timestamp
   * @nullable
   */
  completedAt?: string | null;
  /**
   * Last score percentage (cached)
   * @nullable
   */
  lastScorePercentage?: number | null;
  /** Course ID */
  courseId: number;
  /** Course slug */
  courseSlug: string;
}

/**
 * Attribute to filter
 */
export type CourseAttributeFilterDtoField = typeof CourseAttributeFilterDtoField[keyof typeof CourseAttributeFilterDtoField];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CourseAttributeFilterDtoField = {
  title: 'title',
  description: 'description',
  slug: 'slug',
  contentType: 'contentType',
  privacy: 'privacy',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  publishedAt: 'publishedAt',
  enrollmentCount: 'enrollmentCount',
  moduleCount: 'moduleCount',
  isBlacklisted: 'isBlacklisted',
  authorCohort: 'authorCohort',
} as const;

/**
 * Filter operator (IOperator): co=contains, eq=equals, is=equals (alias), ne=not, sw=startsWith, ew=endsWith, pr=not null, gt/lt/ge/le, ie/ine, int/in/nin, etc.
 */
export type CourseAttributeFilterDtoOperator = typeof CourseAttributeFilterDtoOperator[keyof typeof CourseAttributeFilterDtoOperator];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CourseAttributeFilterDtoOperator = {
  eq: 'eq',
  ne: 'ne',
  co: 'co',
  sw: 'sw',
  ew: 'ew',
  pr: 'pr',
  gt: 'gt',
  ge: 'ge',
  lt: 'lt',
  le: 'le',
  int: 'int',
  in: 'in',
  nin: 'nin',
  ie: 'ie',
  ine: 'ine',
  is: 'is',
} as const;

export interface CourseAttributeFilterDto {
  /** Attribute to filter */
  field?: CourseAttributeFilterDtoField;
  /** Value to match (not required for operator "pr") */
  value?: string;
  /** Filter operator (IOperator): co=contains, eq=equals, is=equals (alias), ne=not, sw=startsWith, ew=endsWith, pr=not null, gt/lt/ge/le, ie/ine, int/in/nin, etc. */
  operator?: CourseAttributeFilterDtoOperator;
}

/**
 * How to combine multiple attribute filters
 */
export type CourseFiltersDtoOperator = typeof CourseFiltersDtoOperator[keyof typeof CourseFiltersDtoOperator];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CourseFiltersDtoOperator = {
  and: 'and',
  or: 'or',
} as const;

export interface CourseFiltersDto {
  /** How to combine multiple attribute filters */
  operator?: CourseFiltersDtoOperator;
  /** Attribute filter conditions */
  conditions?: CourseAttributeFilterDto[];
}

export interface ListCoursesResponse {
  /** List of courses */
  data: CourseResponse[];
  /** Total number of courses matching filters */
  totalCount: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  pageSize: number;
  /** Total number of pages */
  totalPages: number;
  /** Whether there is a next page */
  hasNextPage: boolean;
  /** Whether there is a previous page */
  hasPreviousPage: boolean;
}

export interface DeleteCourseResponse {
  /** Course ID */
  id: number;
  /** Whether the course was deleted */
  deleted: boolean;
  /** Whether this was a hard delete (permanent) */
  hardDeleted: boolean;
  /** Human-readable message */
  message: string;
}

export interface ToggleCourseBlacklistRequest {
  /** Whether to blacklist (true) or remove from blacklist (false) */
  state: boolean;
}

export interface ToggleCourseBlacklistResponse {
  /** Current blacklist state after toggle */
  isBlacklisted: boolean;
}

/**
 * Enrollment type. Determines how the course appears in the training feed.
 */
export type BulkEnrollBodyEnrollmentType = typeof BulkEnrollBodyEnrollmentType[keyof typeof BulkEnrollBodyEnrollmentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BulkEnrollBodyEnrollmentType = {
  learner: 'learner',
  'auto-assign-schedule': 'auto-assign-schedule',
  'prioritize-schedule': 'prioritize-schedule',
  'due-date-schedule': 'due-date-schedule',
  'strapi-admin': 'strapi-admin',
} as const;

export interface BulkEnrollBody {
  /** User IDs to enroll */
  userIds: number[];
  /** Enrollment type. Determines how the course appears in the training feed. */
  enrollmentType?: BulkEnrollBodyEnrollmentType;
  /** ISO 8601 date (YYYY-MM-DD). Required when enrollmentType is "due-date-schedule"; optional when "prioritize-schedule" (including default); must be omitted for other enrollment types. */
  dueDate?: string;
}

export interface PostEnrollUsersInCourseError {
  /** User ID */
  userId: number;
  /** Error message */
  message: string;
}

export interface PostEnrollUsersInCourseResponse {
  /** Enrollment IDs */
  enrollmentIds: number[];
  /** Errors */
  errors: PostEnrollUsersInCourseError[];
}

/**
 * Enrollment type for all enrolled users.
 */
export type EnrollCohortInCourseBodyEnrollmentType = typeof EnrollCohortInCourseBodyEnrollmentType[keyof typeof EnrollCohortInCourseBodyEnrollmentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnrollCohortInCourseBodyEnrollmentType = {
  'auto-assign-schedule': 'auto-assign-schedule',
  'prioritize-schedule': 'prioritize-schedule',
  'due-date-schedule': 'due-date-schedule',
} as const;

export interface EnrollCohortInCourseBody {
  /** Cohort ID to enroll (active users only) */
  cohortId: number;
  /** Enrollment type for all enrolled users. */
  enrollmentType?: EnrollCohortInCourseBodyEnrollmentType;
  /** ISO 8601 date (YYYY-MM-DD). Required when enrollmentType is "due-date-schedule"; optional when "prioritize-schedule" (including default); must be omitted for other enrollment types. */
  dueDate?: string;
}

export interface EnrollCohortInCourseResponse {
  /** Whether the operation is in progress (async) */
  inProgress: boolean;
  /** Count of users to be enrolled (when inProgress is true) */
  userCount?: number;
}

export interface ManageDueDatesBody {
  /** User IDs whose course due dates to manage */
  userIds: number[];
  /** ISO 8601 date (YYYY-MM-DD). Present = set/change the due date; omitted = clear it. Cannot be in the past. */
  dueDate?: string;
}

export interface BulkCompleteCourseBody {
  /** User IDs whose lessons should be completed */
  userIds: number[];
}

export interface BulkCompleteCourseResponse {
  /** Whether the operation is in progress (async) */
  inProgress: boolean;
  /** Count of users to be completed (when inProgress is true) */
  userCount?: number;
}

export interface BulkUnenrollBody {
  /** User IDs to unenroll */
  userIds: number[];
}

export interface PostUnenrollUsersInCourseResponse {
  /** Successfully unenrolled user IDs */
  unenrolledUserIds: string[];
  /** Errors */
  errors: string[];
}

/**
 * Attribute to filter
 */
export type PlaylistAttributeFilterDtoField = typeof PlaylistAttributeFilterDtoField[keyof typeof PlaylistAttributeFilterDtoField];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlaylistAttributeFilterDtoField = {
  title: 'title',
} as const;

/**
 * Filter operator (IOperator): co=contains, eq=equals, is=equals (alias), ne=not, sw=startsWith, ew=endsWith, pr=not null, gt/lt/ge/le, ie/ine, int/in/nin, etc.
 */
export type PlaylistAttributeFilterDtoOperator = typeof PlaylistAttributeFilterDtoOperator[keyof typeof PlaylistAttributeFilterDtoOperator];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlaylistAttributeFilterDtoOperator = {
  eq: 'eq',
  ne: 'ne',
  co: 'co',
  sw: 'sw',
  ew: 'ew',
  pr: 'pr',
  gt: 'gt',
  ge: 'ge',
  lt: 'lt',
  le: 'le',
  int: 'int',
  in: 'in',
  nin: 'nin',
  ie: 'ie',
  ine: 'ine',
  is: 'is',
} as const;

export interface PlaylistAttributeFilterDto {
  /** Attribute to filter */
  field?: PlaylistAttributeFilterDtoField;
  /** Value to match (not required for operator "pr") */
  value?: string;
  /** Filter operator (IOperator): co=contains, eq=equals, is=equals (alias), ne=not, sw=startsWith, ew=endsWith, pr=not null, gt/lt/ge/le, ie/ine, int/in/nin, etc. */
  operator?: PlaylistAttributeFilterDtoOperator;
}

/**
 * How to combine multiple attribute filters
 */
export type PlaylistFiltersDtoOperator = typeof PlaylistFiltersDtoOperator[keyof typeof PlaylistFiltersDtoOperator];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlaylistFiltersDtoOperator = {
  and: 'and',
  or: 'or',
} as const;

export interface PlaylistFiltersDto {
  /** How to combine multiple attribute filters */
  operator?: PlaylistFiltersDtoOperator;
  /** Attribute filter conditions */
  conditions?: PlaylistAttributeFilterDto[];
}

export interface PlaylistListItemDto {
  /** Playlist ID */
  id: number;
  /** Playlist title */
  title: string;
  /**
   * URL slug
   * @nullable
   */
  slug?: string | null;
  /** Number of courses in playlist */
  courseCount: number;
  /** Number of enrolled users */
  enrollmentCount: number;
  /**
   * Published date
   * @nullable
   */
  publishedAt?: string | null;
  /** Created date */
  createdAt: string;
  /** Updated date */
  updatedAt: string;
}

export interface ListPlaylistsResponse {
  /** List of playlists */
  data: PlaylistListItemDto[];
  /** Current page */
  page: number;
  /** Page size */
  pageSize: number;
  /** Total count */
  totalCount: number;
}

export interface PlaylistCourseDto {
  /** Course ID */
  id: number;
  /** Course title */
  title: string;
  /**
   * Course slug
   * @nullable
   */
  slug?: string | null;
  /** Updated timestamp */
  updatedAt: string;
  /** Available content locales for this course (from this and linked localizations) */
  availableLocales: string[];
}

export interface PlaylistDetailDto {
  /** Playlist ID */
  id: number;
  /** Playlist title */
  title: string;
  /**
   * URL slug
   * @nullable
   */
  slug?: string | null;
  /**
   * Content/description
   * @nullable
   */
  content?: string | null;
  /**
   * Published date
   * @nullable
   */
  published_at?: string | null;
  /** Created date */
  created_at: string;
  /** Updated date */
  updated_at: string;
  /** Courses in playlist */
  curriculum: PlaylistCourseDto[];
  /**
   * Certification ID
   * @nullable
   */
  certification_id?: string | null;
  /**
   * Certification name
   * @nullable
   */
  certification_name?: string | null;
}

export interface CreatePlaylistBody {
  /**
   * Playlist title
   * @maxLength 255
   */
  title: string;
  /** Content/description */
  content?: string;
  /** List of course IDs in order */
  courseIds?: number[];
  /**
   * Certification ID
   * @nullable
   */
  certificationId?: string | null;
}

export interface CreatePlaylistResponse {
  /** Playlist ID */
  id: number;
  /** Playlist title */
  title: string;
  /**
   * URL slug
   * @nullable
   */
  slug?: string | null;
  /**
   * Content/description
   * @nullable
   */
  content?: string | null;
  /** Created date */
  createdAt: string;
  /** Updated date */
  updatedAt: string;
}

export interface UpdatePlaylistBody {
  /**
   * Playlist title
   * @maxLength 255
   */
  title?: string;
  /** Content/description */
  content?: string;
  /** List of course IDs in order */
  courseIds?: number[];
  /**
   * Certification ID
   * @nullable
   */
  certificationId?: string | null;
}

export interface UpdatePlaylistResponse {
  /** Playlist ID */
  id: number;
  /** Playlist title */
  title: string;
  /**
   * URL slug
   * @nullable
   */
  slug?: string | null;
  /**
   * Content/description
   * @nullable
   */
  content?: string | null;
  /** Updated date */
  updatedAt: string;
}

/**
 * Duration unit
 * @nullable
 */
export type PlaylistCertificationDtoDurationUnit = { [key: string]: unknown } | null;

/**
 * Duration period
 * @nullable
 */
export type PlaylistCertificationDtoDurationPeriod = { [key: string]: unknown } | null;

export interface PlaylistCertificationDto {
  /** Certification ID */
  id: string;
  /** Certification status */
  certificationStatus: string;
  /** Certification name */
  name: string;
  /**
   * Description
   * @nullable
   */
  description?: string | null;
  /**
   * Certification code
   * @nullable
   */
  certificationCode?: string | null;
  /**
   * Logo URL
   * @nullable
   */
  logoUrl?: string | null;
  /** Granting entity name */
  grantingEntityName: string;
  /** Granting entity ID */
  grantingEntityId: string;
  /** Created by */
  createdBy: string;
  /** Number of employees awarded */
  employeesAwarded: number;
  /** Whether certification is read-only */
  isReadOnly: boolean;
  /** Whether certification was recently added */
  isRecentlyAdded: boolean;
  /** Created at timestamp */
  createdAt: string;
  /**
   * Duration unit
   * @nullable
   */
  durationUnit?: PlaylistCertificationDtoDurationUnit;
  /**
   * Duration period
   * @nullable
   */
  durationPeriod?: PlaylistCertificationDtoDurationPeriod;
}

/**
 * User job title
 * @nullable
 */
export type PlaylistEnrollmentDtoJobTitle = { [key: string]: unknown } | null;

/**
 * User job category
 * @nullable
 */
export type PlaylistEnrollmentDtoJobCategory = { [key: string]: unknown } | null;

/**
 * User division
 * @nullable
 */
export type PlaylistEnrollmentDtoDivision = { [key: string]: unknown } | null;

/**
 * User hire date
 * @nullable
 */
export type PlaylistEnrollmentDtoHireDate = { [key: string]: unknown } | null;

/**
 * User title start date
 * @nullable
 */
export type PlaylistEnrollmentDtoTitleStartDate = { [key: string]: unknown } | null;

/**
 * User supervisor name
 * @nullable
 */
export type PlaylistEnrollmentDtoSupervisorName = { [key: string]: unknown } | null;

/**
 * Custom field value 1
 * @nullable
 */
export type PlaylistEnrollmentDtoCustomFieldValue1 = { [key: string]: unknown } | null;

/**
 * Custom field value 2
 * @nullable
 */
export type PlaylistEnrollmentDtoCustomFieldValue2 = { [key: string]: unknown } | null;

/**
 * Custom field value 3
 * @nullable
 */
export type PlaylistEnrollmentDtoCustomFieldValue3 = { [key: string]: unknown } | null;

/**
 * Employee code
 * @nullable
 */
export type PlaylistEnrollmentDtoEmployeeCode = { [key: string]: unknown } | null;

/**
 * Playlist enrollment id: `group_progress_entries.id` when present (canonical aggregate progress). Otherwise the playlist shell `course_enrollments.id` (group link, no course links).
 * @nullable
 */
export type PlaylistEnrollmentDtoEnrollmentId = { [key: string]: unknown } | null;

/**
 * Playlist progress percentage from `group_progress_entries` when present; otherwise from the playlist shell course enrollment.
 * @nullable
 */
export type PlaylistEnrollmentDtoProgress = { [key: string]: unknown } | null;

/**
 * Enrollment type
 * @nullable
 */
export type PlaylistEnrollmentDtoEnrollmentType = { [key: string]: unknown } | null;

/**
 * Enrollment due date (expires_on)
 * @nullable
 */
export type PlaylistEnrollmentDtoDueDate = { [key: string]: unknown } | null;

/**
 * Date when the user was assigned to the playlist
 * @nullable
 */
export type PlaylistEnrollmentDtoAssignedOn = { [key: string]: unknown } | null;

export interface PlaylistEnrollmentDto {
  /** User ID */
  id: number;
  /** User first name */
  firstname: string;
  /** User last name */
  lastname: string;
  /** User email */
  email: string;
  /**
   * User job title
   * @nullable
   */
  jobTitle: PlaylistEnrollmentDtoJobTitle;
  /**
   * User job category
   * @nullable
   */
  jobCategory: PlaylistEnrollmentDtoJobCategory;
  /**
   * User division
   * @nullable
   */
  division: PlaylistEnrollmentDtoDivision;
  /**
   * User hire date
   * @nullable
   */
  hireDate: PlaylistEnrollmentDtoHireDate;
  /**
   * User title start date
   * @nullable
   */
  titleStartDate: PlaylistEnrollmentDtoTitleStartDate;
  /**
   * User supervisor name
   * @nullable
   */
  supervisorName: PlaylistEnrollmentDtoSupervisorName;
  /**
   * Custom field value 1
   * @nullable
   */
  customFieldValue1: PlaylistEnrollmentDtoCustomFieldValue1;
  /**
   * Custom field value 2
   * @nullable
   */
  customFieldValue2: PlaylistEnrollmentDtoCustomFieldValue2;
  /**
   * Custom field value 3
   * @nullable
   */
  customFieldValue3: PlaylistEnrollmentDtoCustomFieldValue3;
  /**
   * Employee code
   * @nullable
   */
  employeeCode: PlaylistEnrollmentDtoEmployeeCode;
  /** Whether the user is enrolled in the playlist */
  enrolled: boolean;
  /**
   * Playlist enrollment id: `group_progress_entries.id` when present (canonical aggregate progress). Otherwise the playlist shell `course_enrollments.id` (group link, no course links).
   * @nullable
   */
  enrollmentId: PlaylistEnrollmentDtoEnrollmentId;
  /**
   * Playlist progress percentage from `group_progress_entries` when present; otherwise from the playlist shell course enrollment.
   * @nullable
   */
  progress: PlaylistEnrollmentDtoProgress;
  /**
   * Enrollment type
   * @nullable
   */
  enrollmentType: PlaylistEnrollmentDtoEnrollmentType;
  /**
   * Enrollment due date (expires_on)
   * @nullable
   */
  dueDate: PlaylistEnrollmentDtoDueDate;
  /**
   * Date when the user was assigned to the playlist
   * @nullable
   */
  assignedOn: PlaylistEnrollmentDtoAssignedOn;
}

export interface ListPlaylistEnrollmentsResponse {
  /** List of playlist enrollments */
  data: PlaylistEnrollmentDto[];
  /** Total number of enrollments */
  total: number;
  /** Current page number */
  page: number;
  /** Page size */
  pageSize: number;
}

/**
 * Enrollment type. Determines how the playlist appears in the training feed.
 */
export type BulkEnrollPlaylistBodyEnrollmentType = typeof BulkEnrollPlaylistBodyEnrollmentType[keyof typeof BulkEnrollPlaylistBodyEnrollmentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BulkEnrollPlaylistBodyEnrollmentType = {
  'auto-assign-schedule': 'auto-assign-schedule',
  'prioritize-schedule': 'prioritize-schedule',
  'due-date-schedule': 'due-date-schedule',
  learner: 'learner',
} as const;

export interface BulkEnrollPlaylistBody {
  /** User IDs to enroll */
  userIds: number[];
  /** Enrollment type. Determines how the playlist appears in the training feed. */
  enrollmentType?: BulkEnrollPlaylistBodyEnrollmentType;
  /** Due date. Required when enrollmentType is "due-date-schedule", otherwise should be omitted. */
  dueDate?: string;
}

export interface PostEnrollUsersInPlaylistInProgressResponse {
  /** Whether the enrollment process is in progress */
  inProgress: boolean;
}

export interface EnrollCohortInPlaylistBody {
  /** Cohort ID to enroll (active users only) */
  cohortId: number;
}

export interface EnrollCohortInPlaylistResponse {
  /** Whether the operation is in progress (async) */
  inProgress: boolean;
  /** Count of users to be enrolled (when inProgress is true) */
  userCount?: number;
}

export interface BulkCompletePlaylistBody {
  /** User IDs whose lessons should be completed */
  userIds: number[];
}

export interface BulkCompletePlaylistResponse {
  /** Whether the operation is in progress (async) */
  inProgress: boolean;
  /** Count of users to be completed (when inProgress is true) */
  userCount?: number;
}

export interface BulkUnenrollPlaylistBody {
  /** User IDs to unenroll */
  userIds: number[];
}

export interface PostUnenrollUsersInPlaylistInProgressResponse {
  /** Whether the unenrollment process is in progress */
  inProgress: boolean;
}

/**
 * Published at (ISO date string)
 * @nullable
 */
export type ListQuizItemDtoPublishedAt = { [key: string]: unknown } | null;

export interface ListQuizItemDto {
  /** Quiz ID */
  id: number;
  /** Quiz title */
  title: string;
  /**
   * Published at (ISO date string)
   * @nullable
   */
  publishedAt?: ListQuizItemDtoPublishedAt;
  /**
   * Locale code(s)
   * @nullable
   */
  languages?: string[] | null;
}

export interface ListQuizzesResponse {
  /** Quizzes */
  data: ListQuizItemDto[];
  /** Total count */
  totalCount: number;
  /** Current page */
  page: number;
  /** Page size */
  pageSize: number;
}

export interface QuestionOptionDto {
  /** Option ID */
  id: number;
  /** Option text */
  text: string;
  /** Option order */
  order?: number;
}

export interface MatchingItemDto {
  /** Item ID */
  id: number;
  /** Left side text (to match from) */
  left: string;
  /** Right side text (to match to) */
  right?: string;
}

/**
 * Question type
 */
export type QuizQuestionDtoType = typeof QuizQuestionDtoType[keyof typeof QuizQuestionDtoType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuizQuestionDtoType = {
  single_choice: 'single_choice',
  multiple_choice: 'multiple_choice',
  boolean: 'boolean',
  matching_order: 'matching_order',
  text: 'text',
} as const;

export interface QuizQuestionDto {
  /** Question ID (for answer submission) */
  id: number;
  /** Question type */
  type: QuizQuestionDtoType;
  /** Question text */
  text: string;
  /** Question hint */
  hint?: string;
  /** Question explanation (shown after answer) */
  explanation?: string;
  /** Options for choice questions */
  options?: QuestionOptionDto[];
  /** Items for matching/ordering questions */
  items?: MatchingItemDto[];
  /** Order in quiz */
  order: number;
}

export interface GetQuizQuestionsResponse {
  /** Quiz enrollment ID */
  enrollmentId: number;
  /** Quiz ID */
  quizId: number;
  /** Quiz title */
  quizTitle: string;
  /** Questions */
  questions: QuizQuestionDto[];
  /** Total number of questions */
  totalCount: number;
}

/**
 * Answer value. Type depends on question: number for single_choice, number[] for multiple_choice/matching_order, boolean for boolean, string for text.
 */
export type QuizAnswerDtoAnswer = string | number | boolean | number[];

export interface QuizAnswerDto {
  /** Question ID */
  questionId: number;
  /** Answer value. Type depends on question: number for single_choice, number[] for multiple_choice/matching_order, boolean for boolean, string for text. */
  answer: QuizAnswerDtoAnswer;
}

export interface SubmitQuizBody {
  /** Answers to submit */
  answers: QuizAnswerDto[];
}

/**
 * User answer (type depends on question type)
 */
export type MarkedAnswerDtoUserAnswer = string | number | boolean | number[];

/**
 * Correct answer (if revealAnswers is true)
 */
export type MarkedAnswerDtoCorrectAnswer = string | number | boolean | number[];

export interface MarkedAnswerDto {
  /** Question ID */
  questionId: number;
  /** Whether the answer was correct */
  correct: boolean;
  /** User answer (type depends on question type) */
  userAnswer?: MarkedAnswerDtoUserAnswer;
  /** Correct answer (if revealAnswers is true) */
  correctAnswer?: MarkedAnswerDtoCorrectAnswer;
  /** Explanation (if available) */
  explanation?: string;
}

export interface SubmitQuizResponse {
  /** Whether the submission was successful */
  success: boolean;
  /** Quiz result ID */
  resultId: number;
  /** Quiz enrollment ID */
  enrollmentId: number;
  /** Whether the user passed the quiz */
  passed: boolean;
  /** Score percentage (0-100) */
  scorePercentage: number;
  /** Number of correct answers */
  correctCount: number;
  /** Number of incorrect answers */
  incorrectCount: number;
  /** Total number of questions */
  totalQuestions: number;
  /** Required score to pass (percentage) */
  requiredScore?: number;
  /** Marked answers (included if revealAnswers is true) */
  markedAnswers?: MarkedAnswerDto[];
  /** Whether the course is now complete as a result */
  courseCompleted: boolean;
}

/**
 * Subtitle
 */
export type CreateQuizBodySubtitle = { [key: string]: unknown };

/**
 * HTML content
 */
export type CreateQuizBodyContent = { [key: string]: unknown };

/**
 * Pass threshold (score required)
 */
export type CreateQuizBodyScoreRequired = { [key: string]: unknown };

/**
 * Randomize question order
 */
export type CreateQuizBodyRandomiseOrder = { [key: string]: unknown };

export type CreateQuizBodyCompositionItem = { [key: string]: unknown };

export interface CreateQuizBody {
  /**
   * Quiz title
   * @maxLength 255
   */
  title: string;
  /** Subtitle */
  subtitle?: CreateQuizBodySubtitle;
  /** HTML content */
  content?: CreateQuizBodyContent;
  /** Pass threshold (score required) */
  scoreRequired?: CreateQuizBodyScoreRequired;
  /** Randomize question order */
  randomiseOrder?: CreateQuizBodyRandomiseOrder;
  /** Question composition (ordered array of { id, __type, title? }) */
  composition?: CreateQuizBodyCompositionItem[];
}

export interface CreateQuizResponse {
  /** Created quiz ID */
  id: number;
}

/**
 * URL slug
 */
export type QuizDetailDtoSlug = { [key: string]: unknown };

/**
 * Subtitle
 */
export type QuizDetailDtoSubtitle = { [key: string]: unknown };

/**
 * HTML content
 */
export type QuizDetailDtoContent = { [key: string]: unknown };

/**
 * Pass threshold (score required)
 */
export type QuizDetailDtoScoreRequired = { [key: string]: unknown };

/**
 * Randomize question order
 */
export type QuizDetailDtoRandomiseOrder = { [key: string]: unknown };

/**
 * Question composition (order, question refs)
 */
export type QuizDetailDtoComposition = { [key: string]: unknown };

/**
 * Published at (ISO date string)
 */
export type QuizDetailDtoPublishedAt = { [key: string]: unknown };

/**
 * Locale code
 */
export type QuizDetailDtoLocale = { [key: string]: unknown };

/**
 * Created at (ISO date string)
 * @nullable
 */
export type QuizDetailDtoCreatedAt = { [key: string]: unknown } | null;

/**
 * Last updated at (ISO date string)
 * @nullable
 */
export type QuizDetailDtoUpdatedAt = { [key: string]: unknown } | null;

/**
 * Display name of user who created the quiz
 * @nullable
 */
export type QuizDetailDtoCreatedBy = { [key: string]: unknown } | null;

/**
 * Display name of user who last saved or published the quiz
 * @nullable
 */
export type QuizDetailDtoUpdatedBy = { [key: string]: unknown } | null;

export interface QuizDetailDto {
  /** Quiz ID */
  id: number;
  /** Quiz title */
  title: string;
  /** URL slug */
  slug?: QuizDetailDtoSlug;
  /** Subtitle */
  subtitle?: QuizDetailDtoSubtitle;
  /** HTML content */
  content?: QuizDetailDtoContent;
  /** Pass threshold (score required) */
  scoreRequired?: QuizDetailDtoScoreRequired;
  /** Randomize question order */
  randomiseOrder?: QuizDetailDtoRandomiseOrder;
  /** Question composition (order, question refs) */
  composition?: QuizDetailDtoComposition;
  /** Published at (ISO date string) */
  publishedAt?: QuizDetailDtoPublishedAt;
  /** Locale code */
  locale?: QuizDetailDtoLocale;
  /**
   * Created at (ISO date string)
   * @nullable
   */
  createdAt?: QuizDetailDtoCreatedAt;
  /**
   * Last updated at (ISO date string)
   * @nullable
   */
  updatedAt?: QuizDetailDtoUpdatedAt;
  /**
   * Display name of user who created the quiz
   * @nullable
   */
  createdBy?: QuizDetailDtoCreatedBy;
  /**
   * Display name of user who last saved or published the quiz
   * @nullable
   */
  updatedBy?: QuizDetailDtoUpdatedBy;
}

export interface QuestionSlimDto {
  /** Question ID */
  id: number;
  /** Question type (table name) */
  __type: string;
  /** Question title */
  title: string;
}

/**
 * All questions available (keyed by table name)
 */
export type QuizWithQuestionsDtoQuestions = {[key: string]: QuestionSlimDto[]};

export interface QuizWithQuestionsDto {
  /** Quiz ID */
  id: number;
  /** Quiz title */
  title: string;
  /**
   * URL slug
   * @nullable
   */
  slug?: string | null;
  /**
   * Subtitle
   * @nullable
   */
  subtitle?: string | null;
  /**
   * HTML content
   * @nullable
   */
  content?: string | null;
  /**
   * Pass threshold (score required)
   * @nullable
   */
  scoreRequired?: number | null;
  /**
   * Randomize question order
   * @nullable
   */
  randomiseOrder?: boolean | null;
  /** Question composition (array of question refs) */
  composition?: QuestionSlimDto[];
  /** All questions available (keyed by table name) */
  questions: QuizWithQuestionsDtoQuestions;
  /**
   * Published at (ISO date string)
   * @nullable
   */
  publishedAt?: string | null;
  /**
   * Locale code
   * @nullable
   */
  locale?: string | null;
}

export interface SearchQuestionsBody {
  /** Search term for question title */
  searchTerm?: string;
  /** Filter by question type (table name) */
  questionType?: string;
}

export interface SearchQuestionsResponse {
  /** Boolean choice questions */
  boolean_choice_questions?: QuestionSlimDto[];
  /** Single choice questions */
  single_choice_questions?: QuestionSlimDto[];
  /** Multiple choice questions */
  multiple_choice_questions?: QuestionSlimDto[];
  /** Drag to order questions */
  drag_to_order_questions?: QuestionSlimDto[];
  /** Fill the blank questions */
  fill_the_blank_questions?: QuestionSlimDto[];
  /** Matching order questions */
  matching_order_questions?: QuestionSlimDto[];
  /** Text questions */
  text_questions?: QuestionSlimDto[];
}

/**
 * Target table / question kind
 */
export type CreateQuestionBodyQuestionType = typeof CreateQuestionBodyQuestionType[keyof typeof CreateQuestionBodyQuestionType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateQuestionBodyQuestionType = {
  boolean_choice_questions: 'boolean_choice_questions',
  single_choice_questions: 'single_choice_questions',
  multiple_choice_questions: 'multiple_choice_questions',
} as const;

export interface CreateQuestionBody {
  /** Target table / question kind */
  questionType: CreateQuestionBodyQuestionType;
  /** Question title */
  title: string;
  /** Optional hint */
  hint?: string;
  /** Correct answer for true/false */
  answer?: boolean;
  /** Answer options */
  options?: string[];
  correctAnswer?: string;
  correctAnswers?: string[];
}

export interface CreateQuestionResponse {
  id: number;
  /** Prisma table name, e.g. single_choice_questions */
  __type: string;
  title: string;
}

/**
 * Subtitle
 */
export type UpdateQuizBodySubtitle = { [key: string]: unknown };

/**
 * HTML content
 */
export type UpdateQuizBodyContent = { [key: string]: unknown };

/**
 * Pass threshold (score required)
 */
export type UpdateQuizBodyScoreRequired = { [key: string]: unknown };

/**
 * Randomize question order
 */
export type UpdateQuizBodyRandomiseOrder = { [key: string]: unknown };

export type UpdateQuizBodyCompositionItem = { [key: string]: unknown };

/**
 * ISO 8601 publish time; set to publish. Omit to leave unchanged; null to unpublish.
 * @nullable
 */
export type UpdateQuizBodyPublishedAt = { [key: string]: unknown } | null;

/**
 * Locale code (e.g. en, es)
 */
export type UpdateQuizBodyLocale = { [key: string]: unknown };

export interface UpdateQuizBody {
  /**
   * Quiz title
   * @maxLength 255
   */
  title?: string;
  /** Subtitle */
  subtitle?: UpdateQuizBodySubtitle;
  /** HTML content */
  content?: UpdateQuizBodyContent;
  /** Pass threshold (score required) */
  scoreRequired?: UpdateQuizBodyScoreRequired;
  /** Randomize question order */
  randomiseOrder?: UpdateQuizBodyRandomiseOrder;
  /** Question composition (ordered array of { id, __type, title? }) */
  composition?: UpdateQuizBodyCompositionItem[];
  /**
   * ISO 8601 publish time; set to publish. Omit to leave unchanged; null to unpublish.
   * @nullable
   */
  publishedAt?: UpdateQuizBodyPublishedAt;
  /** Locale code (e.g. en, es) */
  locale?: UpdateQuizBodyLocale;
}

/**
 * URL slug
 */
export type UpdateQuizResponseSlug = { [key: string]: unknown };

/**
 * Subtitle
 */
export type UpdateQuizResponseSubtitle = { [key: string]: unknown };

/**
 * HTML content
 */
export type UpdateQuizResponseContent = { [key: string]: unknown };

/**
 * Pass threshold (score required)
 */
export type UpdateQuizResponseScoreRequired = { [key: string]: unknown };

/**
 * Randomize question order
 */
export type UpdateQuizResponseRandomiseOrder = { [key: string]: unknown };

/**
 * Question composition (order, question refs)
 */
export type UpdateQuizResponseComposition = { [key: string]: unknown };

/**
 * Published at (ISO date string)
 */
export type UpdateQuizResponsePublishedAt = { [key: string]: unknown };

/**
 * Locale code
 */
export type UpdateQuizResponseLocale = { [key: string]: unknown };

/**
 * Created at (ISO date string)
 * @nullable
 */
export type UpdateQuizResponseCreatedAt = { [key: string]: unknown } | null;

/**
 * Last updated at (ISO date string)
 * @nullable
 */
export type UpdateQuizResponseUpdatedAt = { [key: string]: unknown } | null;

/**
 * Display name of user who created the quiz
 * @nullable
 */
export type UpdateQuizResponseCreatedBy = { [key: string]: unknown } | null;

/**
 * Display name of user who last saved or published the quiz
 * @nullable
 */
export type UpdateQuizResponseUpdatedBy = { [key: string]: unknown } | null;

export interface UpdateQuizResponse {
  /** Quiz ID */
  id: number;
  /** Quiz title */
  title: string;
  /** URL slug */
  slug?: UpdateQuizResponseSlug;
  /** Subtitle */
  subtitle?: UpdateQuizResponseSubtitle;
  /** HTML content */
  content?: UpdateQuizResponseContent;
  /** Pass threshold (score required) */
  scoreRequired?: UpdateQuizResponseScoreRequired;
  /** Randomize question order */
  randomiseOrder?: UpdateQuizResponseRandomiseOrder;
  /** Question composition (order, question refs) */
  composition?: UpdateQuizResponseComposition;
  /** Published at (ISO date string) */
  publishedAt?: UpdateQuizResponsePublishedAt;
  /** Locale code */
  locale?: UpdateQuizResponseLocale;
  /**
   * Created at (ISO date string)
   * @nullable
   */
  createdAt?: UpdateQuizResponseCreatedAt;
  /**
   * Last updated at (ISO date string)
   * @nullable
   */
  updatedAt?: UpdateQuizResponseUpdatedAt;
  /**
   * Display name of user who created the quiz
   * @nullable
   */
  createdBy?: UpdateQuizResponseCreatedBy;
  /**
   * Display name of user who last saved or published the quiz
   * @nullable
   */
  updatedBy?: UpdateQuizResponseUpdatedBy;
}

export interface DeleteQuizResponse {
  /** Deleted quiz ID */
  quizId: number;
  /** True if hard delete was performed */
  hardDelete: boolean;
}

/**
 * Attribute to filter
 */
export type LessonAttributeFilterDtoField = typeof LessonAttributeFilterDtoField[keyof typeof LessonAttributeFilterDtoField];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LessonAttributeFilterDtoField = {
  title: 'title',
  updatedAt: 'updatedAt',
  publishedAt: 'publishedAt',
  videoDuration: 'videoDuration',
  languages: 'languages',
} as const;

/**
 * Filter operator: co=contains, eq=equals, ne=not, sw=startsWith, ew=endsWith, pr=not null, gt/lt/ge/le for numeric/date
 */
export type LessonAttributeFilterDtoOperator = typeof LessonAttributeFilterDtoOperator[keyof typeof LessonAttributeFilterDtoOperator];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LessonAttributeFilterDtoOperator = {
  co: 'co',
  eq: 'eq',
  ne: 'ne',
  sw: 'sw',
  ew: 'ew',
  pr: 'pr',
  gt: 'gt',
  lt: 'lt',
  ge: 'ge',
  le: 'le',
} as const;

export interface LessonAttributeFilterDto {
  /** Attribute to filter */
  field?: LessonAttributeFilterDtoField;
  /** Value to match (not required for operator "pr") */
  value?: string;
  /** Filter operator: co=contains, eq=equals, ne=not, sw=startsWith, ew=endsWith, pr=not null, gt/lt/ge/le for numeric/date */
  operator?: LessonAttributeFilterDtoOperator;
}

/**
 * How to combine multiple attribute filters
 */
export type LessonFiltersDtoOperator = typeof LessonFiltersDtoOperator[keyof typeof LessonFiltersDtoOperator];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LessonFiltersDtoOperator = {
  and: 'and',
  or: 'or',
} as const;

export interface LessonFiltersDto {
  /** How to combine multiple attribute filters */
  operator?: LessonFiltersDtoOperator;
  /** Attribute filter conditions */
  conditions?: LessonAttributeFilterDto[];
}

export interface ListLessonItemDto {
  /** Lesson ID */
  id: number;
  /** Lesson title */
  title: string;
  /** URL-friendly slug */
  slug: string;
  /**
   * Video duration in seconds
   * @nullable
   */
  videoDuration?: number | null;
  /** Last updated */
  updatedAt: string;
  /**
   * Published date (null = draft)
   * @nullable
   */
  publishedAt?: string | null;
  /** Supported locale codes (e.g. ["en", "es-419"]) */
  languages: string[];
  /**
   * Enrollment count (if available)
   * @nullable
   */
  enrollmentCount?: number | null;
}

export interface ListLessonsResponse {
  /** Lessons */
  data: ListLessonItemDto[];
  /** Total count */
  totalCount: number;
  /** Current page */
  page: number;
  /** Page size */
  pageSize: number;
  /** Total pages */
  totalPages: number;
  /** Has next page */
  hasNextPage: boolean;
  /** Has previous page */
  hasPreviousPage: boolean;
}

/**
 * Cohort title
 */
export type LessonSearchAuthorCohortDtoTitle = { [key: string]: unknown };

export interface LessonSearchAuthorCohortDto {
  /** Cohort ID */
  id: number;
  /** Cohort title */
  title: LessonSearchAuthorCohortDtoTitle;
}

/**
 * Video duration in seconds
 * @nullable
 */
export type LessonSearchResultVideoDuration = { [key: string]: unknown } | null;

/**
 * Author cohort (shared by)
 * @nullable
 */
export type LessonSearchResultAuthorCohort = LessonSearchAuthorCohortDto | null;

export interface LessonSearchResult {
  /** Lesson ID */
  id: number;
  /** Module type (always "lesson") */
  type: string;
  /** Lesson title */
  title: string;
  /** URL-friendly slug */
  slug: string;
  /**
   * Published timestamp (null = draft)
   * @nullable
   */
  publishedAt?: string | null;
  /**
   * Last updated timestamp
   * @nullable
   */
  updatedAt?: string | null;
  /**
   * Video duration in seconds
   * @nullable
   */
  videoDuration?: LessonSearchResultVideoDuration;
  /** Supported locale codes (e.g. ["en", "es-419"]) */
  languages: string[];
  /**
   * Author cohort (shared by)
   * @nullable
   */
  authorCohort?: LessonSearchResultAuthorCohort;
  /** Number of enrollments for this lesson */
  enrollmentCount: number;
}

export interface SearchLessonsResponse {
  /** List of matching lessons */
  data: LessonSearchResult[];
  /** Total count of lessons matching filters */
  totalCount: number;
  /** Current page (1-indexed) */
  page: number;
  /** Page size */
  pageSize: number;
}

export interface UploadedFileDto {
  /** File ID from database */
  id: number;
  /** Original filename */
  name: string;
  /** File URL in Azure Storage */
  url: string;
  /** MIME type */
  mime: string;
  /** File size in KB */
  size: number;
}

export interface UploadFilesResponse {
  /** Uploaded files with IDs for use in existingFileIds */
  files: UploadedFileDto[];
}

/**
 * ISO 8601 publish time. Omit or set null to create as draft; set to a timestamp (e.g. now) to create published.
 * @nullable
 */
export type PostLessonBodyPublishedAt = { [key: string]: unknown } | null;

export interface PostLessonBody {
  /** Lesson title */
  title: string;
  /** URL-friendly slug (auto-generated if not provided) */
  slug?: string;
  /** Lesson subtitle */
  subtitle?: string;
  /** Lesson content (HTML/Markdown) */
  content?: string;
  /** Video URL */
  videoUrl?: string;
  /** Video type (e.g., "youtube", "vimeo", "azure") */
  videoType?: string;
  /** Video thumbnail URL */
  videoThumbnailUrl?: string;
  /** Video duration in seconds */
  videoDuration?: number;
  /** Video transcript URL */
  videoTranscriptUrl?: string;
  /** Drip enrollment offset in days */
  dripEnrollmentOffset?: number;
  /** Due date offset in days */
  dueDateOffset?: number;
  /** Available from date */
  availableFrom?: string;
  /** External ID for integrations */
  externalId?: string;
  /** Author cohort ID (auto-assigned from user if not provided) */
  authorCohortId?: number;
  /** Quiz ID to link to this lesson */
  quizId?: number;
  /**
   * Optional URLs to support learning
   * @maxItems 50
   */
  links?: string[];
  /** Existing file IDs to attach to this lesson (from uploads) */
  existingFileIds?: number[];
  /**
   * ISO 8601 publish time. Omit or set null to create as draft; set to a timestamp (e.g. now) to create published.
   * @nullable
   */
  publishedAt?: PostLessonBodyPublishedAt;
}

/**
 * Linked quiz (shapeshift shape)
 * @nullable
 */
export type LessonResponseQuiz = LessonQuizDto | null;

export interface LessonResponse {
  /** Lesson ID */
  id: number;
  /** URL-friendly slug */
  slug: string;
  /** Lesson title */
  title: string;
  /**
   * Lesson subtitle
   * @nullable
   */
  subtitle?: string | null;
  /**
   * Lesson content
   * @nullable
   */
  content?: string | null;
  /**
   * Video URL
   * @nullable
   */
  videoUrl?: string | null;
  /**
   * Video type
   * @nullable
   */
  videoType?: string | null;
  /**
   * Video thumbnail URL
   * @nullable
   */
  videoThumbnailUrl?: string | null;
  /**
   * Video duration in seconds
   * @nullable
   */
  videoDuration?: number | null;
  /**
   * Video transcript URL
   * @nullable
   */
  videoTranscriptUrl?: string | null;
  /**
   * Drip enrollment offset in days
   * @nullable
   */
  dripEnrollmentOffset?: number | null;
  /**
   * Due date offset in days
   * @nullable
   */
  dueDateOffset?: number | null;
  /**
   * Available from date
   * @nullable
   */
  availableFrom?: string | null;
  /**
   * Published timestamp (null = draft)
   * @nullable
   */
  publishedAt?: string | null;
  /** Created timestamp */
  createdAt: string;
  /** Updated timestamp */
  updatedAt: string;
  /**
   * Linked quiz ID
   * @nullable
   */
  quizId?: number | null;
  /**
   * Optional URLs to support learning
   * @nullable
   */
  links?: string[] | null;
  /**
   * Attached files
   * @nullable
   */
  files?: LessonFileDto[] | null;
  /**
   * Linked quiz (shapeshift shape)
   * @nullable
   */
  quiz?: LessonResponseQuiz;
}

/**
 * Published timestamp (ISO string); null = draft
 */
export type PutLessonBodyPublishedAt = { [key: string]: unknown };

/**
 * Quiz ID to link (null to unlink)
 */
export type PutLessonBodyQuizId = { [key: string]: unknown };

export interface PutLessonBody {
  /** Lesson title */
  title?: string;
  /** URL-friendly slug */
  slug?: string;
  /** Lesson subtitle */
  subtitle?: string;
  /** Lesson content (HTML/Markdown) */
  content?: string;
  /** Video URL */
  videoUrl?: string;
  /** Video type */
  videoType?: string;
  /** Video thumbnail URL */
  videoThumbnailUrl?: string;
  /** Video duration in seconds */
  videoDuration?: number;
  /** Video transcript URL */
  videoTranscriptUrl?: string;
  /** Drip enrollment offset in days */
  dripEnrollmentOffset?: number;
  /** Due date offset in days */
  dueDateOffset?: number;
  /** Available from date */
  availableFrom?: string;
  /** Published timestamp (ISO string); null = draft */
  publishedAt?: PutLessonBodyPublishedAt;
  /** Quiz ID to link (null to unlink) */
  quizId?: PutLessonBodyQuizId;
  /**
   * Optional URLs to support learning
   * @maxItems 50
   */
  links?: string[];
  /** Existing file IDs to attach (replaces current attachments) */
  existingFileIds?: number[];
}

export interface DeleteLessonResponse {
  /** Deleted lesson ID */
  id: number;
  /** True if hard delete was performed */
  hardDelete: boolean;
}

export interface CompleteLessonBody {
  /** Final video playback position in seconds */
  videoTime?: number;
  /** Total video length in seconds */
  videoLength?: number;
}

/**
 * Total leaderboard points earned from this completion (lesson and course awards combined), or null when none were recorded
 * @nullable
 */
export type CompleteLessonResponseAwardedPoints = { [key: string]: unknown } | null;

export interface CompleteLessonResponse {
  /** Whether the lesson was successfully completed */
  success: boolean;
  /** Lesson enrollment ID */
  enrollmentId: number;
  /** Completion timestamp */
  completedAt: string;
  /** Whether the parent course was completed as a result */
  courseCompleted: boolean;
  /** Whether the streak was incremented by this completion */
  isStreakChanged?: boolean;
  /** Current streak in days (when isStreakChanged is true) */
  streakDays?: number;
  /** Whether streak is paused (show resume prompt) */
  isStreakPaused?: boolean;
  /**
   * Total leaderboard points earned from this completion (lesson and course awards combined), or null when none were recorded
   * @nullable
   */
  awardedPoints?: CompleteLessonResponseAwardedPoints;
}

export interface SaveVideoTimeBody {
  /** Video playback position in seconds */
  time: number;
  /** Total video length in seconds */
  videoLength?: number;
}

export interface SaveVideoTimeResponse {
  /** Whether the video time was saved successfully */
  success: boolean;
  /** Updated video time in seconds */
  videoTime: number;
}

export interface BulkCompleteBody {
  /** User ID whose lessons are being completed */
  userId: number;
  /** Lesson enrollment IDs to mark as complete */
  lessonEnrollmentIds: number[];
  /** Completion date for the lessons */
  date: string;
  /** Timezone for date calculations */
  timezone?: string;
}

export interface BulkCompleteResponse {
  /** Successfully completed enrollment IDs */
  completedIds: number[];
  /** Errors for failed completions */
  errors: string[];
}

export interface InitBrightcoveBody {
  fileName: string;
}

export interface CompleteBrightcoveBody {
  videoId: string;
  videoUrl: string;
  /**
   * Lesson ID (use for lessons)
   * @minimum 1
   */
  lessonId?: number;
  /**
   * Announcement ID (use for announcements)
   * @minimum 1
   */
  announcementId?: number;
}

export interface QueryBrightcoveBody {
  videoId: string;
}

export interface EnsureAccountBody {
  /** IANA timezone from the client (e.g. America/Chicago) */
  timezone?: string;
}

export interface OwnedCohortDto {
  /** Cohort ID */
  id: number;
  /** Cohort title */
  title: string;
}

export interface MemberedCohortDto {
  /** Cohort ID */
  id: number;
  /** Cohort title */
  title: string;
  /** Comments enabled */
  comments?: boolean;
}

/**
 * Preferred language
 */
export type GetMeResponsePreferredLanguage = typeof GetMeResponsePreferredLanguage[keyof typeof GetMeResponsePreferredLanguage];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetMeResponsePreferredLanguage = {
  en: 'en',
  'es-419': 'es-419',
} as const;

/**
 * Owned cohort (for admins)
 * @nullable
 */
export type GetMeResponseOwnedCohort = OwnedCohortDto | null;

/**
 * Membered cohort
 * @nullable
 */
export type GetMeResponseMemberedCohort = MemberedCohortDto | null;

export interface GetMeResponse {
  /** User ID */
  id: number;
  /** Email */
  email: string;
  /** Username */
  username: string;
  /**
   * First name
   * @nullable
   */
  firstname?: string | null;
  /**
   * Last name
   * @nullable
   */
  lastname?: string | null;
  /**
   * Profile image URL
   * @nullable
   */
  profileImage?: string | null;
  /**
   * Job title
   * @nullable
   */
  jobTitle?: string | null;
  /**
   * Job category
   * @nullable
   */
  jobCategory?: string | null;
  /**
   * Organization ID
   * @nullable
   */
  organisationId?: string | null;
  /**
   * Phone number
   * @nullable
   */
  phone?: string | null;
  /**
   * Timezone
   * @nullable
   */
  timezone?: string | null;
  /**
   * Division
   * @nullable
   */
  division?: string | null;
  /**
   * Experience level
   * @nullable
   */
  experienceLevel?: string | null;
  /**
   * Supervisor name
   * @nullable
   */
  supervisorName?: string | null;
  /**
   * Bio
   * @nullable
   */
  bio?: string | null;
  /**
   * Website
   * @nullable
   */
  website?: string | null;
  /** Preferred language */
  preferredLanguage: GetMeResponsePreferredLanguage;
  /** In-app notifications enabled */
  notifyInApp: boolean;
  /** Email notifications enabled */
  notifyEmail: boolean;
  /** Daily skills reminder enabled */
  dailySkillsReminder: boolean;
  /** Overdue skills reminder enabled */
  overDueSkilsReminder: boolean;
  /**
   * When the user last completed a lesson (ISO date-time). Used to show "completed all for today" when feed is empty.
   * @nullable
   */
  latestLessonCompletedAt?: string | null;
  /**
   * Owned cohort (for admins)
   * @nullable
   */
  ownedCohort?: GetMeResponseOwnedCohort;
  /**
   * Membered cohort
   * @nullable
   */
  memberedCohort?: GetMeResponseMemberedCohort;
  /**
   * Organization name from cohort
   * @nullable
   */
  organizationName?: string | null;
  /**
   * Custom field value 1
   * @nullable
   */
  customFieldValue1?: string | null;
  /**
   * Custom field value 2
   * @nullable
   */
  customFieldValue2?: string | null;
  /**
   * Custom field value 3
   * @nullable
   */
  customFieldValue3?: string | null;
  /**
   * Employee code
   * @nullable
   */
  employeeCode?: string | null;
}

export interface WhoAmIResponseDto {
  /** PropelAuth user ID */
  userId: number;
  /** User email address */
  email: string;
  /** User first name */
  firstName?: string;
  /** User last name */
  lastName?: string;
  /** Organization ID */
  orgId?: string;
  /** Organization name */
  orgName?: string;
  /** User roles */
  roles: string[];
  /** User permissions */
  permissions: string[];
  /** Has Training::Admin role */
  hasTrainingAdminAccess: boolean;
  /** Has Training::Student role */
  hasTrainingStudentAccess: boolean;
  /** Has BuildWitt:Admin role */
  isBuildWittAdmin: boolean;
  /** Employee ID from Identity Service */
  employeeId?: string;
  /** Job title */
  jobTitle?: string;
  /** Job category */
  jobCategory?: string;
  /** Experience level */
  experienceLevel?: string;
  /** Supervisor name */
  supervisorName?: string;
  /** Supervisor ID */
  supervisorId?: string;
  /** Division */
  division?: string;
  /** Phone number */
  phone?: string;
  /** Invitation status */
  invitationStatus?: string;
  /** Work category */
  workCategory?: string;
}

/**
 * Module thumbnail override
 * @nullable
 */
export type ScheduledModuleDtoModuleThumbnailOverride = { [key: string]: unknown } | null;

/**
 * Course
 */
export type ScheduledModuleDtoCourse = { [key: string]: unknown };

/**
 * Feed tier
 */
export type ScheduledModuleDtoFeedTier = typeof ScheduledModuleDtoFeedTier[keyof typeof ScheduledModuleDtoFeedTier];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ScheduledModuleDtoFeedTier = {
  'due-date': 'due-date',
  admin: 'admin',
  self: 'self',
  auto: 'auto',
  unknown: 'unknown',
} as const;

export interface ScheduledModuleDto {
  /** Type */
  type: string;
  /**
   * Video URL
   * @nullable
   */
  videoUrl?: string | null;
  /**
   * Video type
   * @nullable
   */
  videoType?: string | null;
  /**
   * Files
   * @nullable
   */
  files?: string[] | null;
  /**
   * Links
   * @nullable
   */
  links?: string[] | null;
  /**
   * Video thumbnail URL
   * @nullable
   */
  videoThumbnailUrl?: string | null;
  /**
   * Video time
   * @nullable
   */
  videoTime?: number | null;
  /**
   * Video length
   * @nullable
   */
  videoLength?: number | null;
  /** ID */
  id: number;
  /** Slug */
  slug: string;
  /**
   * __type
   * @nullable
   */
  __type?: string | null;
  /**
   * Published at
   * @nullable
   */
  publishedAt?: string | null;
  /** Title */
  title: string;
  /**
   * Available from
   * @nullable
   */
  availableFrom?: string | null;
  /** Subtitle */
  subtitle: string;
  /** Complete */
  complete: boolean;
  /** Content */
  content: string;
  /**
   * Drip enrollment offset
   * @nullable
   */
  dripEnrollmentOffset?: number | null;
  /**
   * Progression
   * @nullable
   */
  progression?: boolean | null;
  /**
   * Started at
   * @nullable
   */
  startedAt?: string | null;
  /**
   * Finished at
   * @nullable
   */
  finishedAt?: string | null;
  /**
   * Module thumbnail override
   * @nullable
   */
  moduleThumbnailOverride?: ScheduledModuleDtoModuleThumbnailOverride;
  /** Course */
  course: ScheduledModuleDtoCourse;
  /** Course enrollment type */
  courseEnrollmentType: string;
  /** Enrollment type */
  enrollmentType: string;
  /** Module type */
  moduleType: string;
  /** Due date */
  dueDate: string;
  /** Enrollment ID */
  enrollmentId: number;
  /**
   * Duration
   * @nullable
   */
  duration?: number | null;
  /** Feed tier */
  feedTier: ScheduledModuleDtoFeedTier;
  /** Whether this lesson was completed today */
  isCompleted: boolean;
  /** Whether this lesson is locked due to linear progression */
  isLocked: boolean;
  /** Order of this lesson in the course curriculum (for stable feed ordering) */
  curriculumOrder?: number;
}

export interface GetFeedResponse {
  /** Scheduled modules */
  items: ScheduledModuleDto[];
}

export interface EnrolledCourseDto {
  /** Course ID */
  id: number;
  /** Course title */
  title: string;
  /** Course slug */
  slug: string;
  /**
   * Course description
   * @nullable
   */
  description?: string | null;
  /**
   * Featured image URL
   * @nullable
   */
  featuredImage?: string | null;
  /**
   * Course level
   * @nullable
   */
  courseLevel?: string | null;
  /**
   * Content type
   * @nullable
   */
  contentType?: string | null;
  /** Total course duration in seconds */
  totalDuration: number;
  /** Remaining duration in seconds */
  remainingDurationSeconds: number;
  /** Enrollment ID */
  enrollmentId: number;
  /** Enrollment type */
  enrollmentType: string;
  /**
   * Due date
   * @nullable
   */
  dueOn?: string | null;
  /**
   * Progress percentage
   * @nullable
   */
  progress?: number | null;
  /**
   * Number of modules in course
   * @nullable
   */
  moduleCount?: number | null;
  /** Enrolled date */
  enrolledOn: string;
  /**
   * Started date
   * @nullable
   */
  startedAt?: string | null;
  /**
   * Completed date
   * @nullable
   */
  completedAt?: string | null;
}

export interface GetEnrolledCoursesResponse {
  /** Enrolled courses */
  items: EnrolledCourseDto[];
  /** Total count */
  totalCount: number;
}

export interface CourseSummaryDto {
  id: number;
  title: string;
  slug: string;
}

export type RecentActivityItemDtoType = typeof RecentActivityItemDtoType[keyof typeof RecentActivityItemDtoType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RecentActivityItemDtoType = {
  lesson: 'lesson',
} as const;

export interface RecentActivityItemDto {
  id: number;
  title: string;
  slug: string;
  type: RecentActivityItemDtoType;
  /** @nullable */
  videoUrl: string | null;
  /** @nullable */
  videoThumbnailUrl: string | null;
  /** @nullable */
  videoDuration: number | null;
  completedAt: string;
  course: CourseSummaryDto;
}

export interface GetUserRecentActivityResponse {
  data: RecentActivityItemDto[];
  totalCount: number;
  page: number;
  pageSize: number;
}

export interface CoursePlaylistRefDto {
  id: number;
  /** @nullable */
  title?: string | null;
}

export interface ActiveCourseDto {
  id: number;
  title: string;
  slug: string;
  /** @nullable */
  description: string | null;
  /** @nullable */
  contentType: string | null;
  /** @nullable */
  courseLevel: string | null;
  /** @nullable */
  featuredImage: string | null;
  enrollmentId: number;
  enrollmentType: string;
  /** @nullable */
  assignedOn: string | null;
  /** @nullable */
  dueOn: string | null;
  moduleCount: number;
  completedCount: number;
  /** Progress percentage (0-100) */
  progress: number;
  playlists?: CoursePlaylistRefDto[];
}

export interface GetUserActiveCoursesResponse {
  data: ActiveCourseDto[];
  totalCount: number;
}

export interface UserActivePlaylistDto {
  playlistId: number;
  title: string;
  /** @nullable */
  slug?: string | null;
  enrollmentId: number;
  /** @nullable */
  progress?: number | null;
  /** @nullable */
  enrollmentType?: string | null;
  /** @nullable */
  assignedOn?: string | null;
  /** @nullable */
  dueOn?: string | null;
}

export interface GetUserActivePlaylistsResponse {
  data: UserActivePlaylistDto[];
  totalCount: number;
}

export interface FinishedCourseDto {
  id: number;
  title: string;
  slug: string;
  /** @nullable */
  description: string | null;
  /** @nullable */
  contentType: string | null;
  /** @nullable */
  courseLevel: string | null;
  /** @nullable */
  featuredImage: string | null;
  enrollmentId: number;
  /** @nullable */
  completedAt: string | null;
  moduleCount: number;
  isActive: boolean;
}

export interface GetUserFinishedCoursesResponse {
  data: FinishedCourseDto[];
  totalCount: number;
}

/**
 * Preferred language
 */
export type UpdateSettingsBodyPreferredLanguage = typeof UpdateSettingsBodyPreferredLanguage[keyof typeof UpdateSettingsBodyPreferredLanguage];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateSettingsBodyPreferredLanguage = {
  en: 'en',
  'es-419': 'es-419',
} as const;

export interface UpdateSettingsBody {
  /** Preferred language */
  preferredLanguage?: UpdateSettingsBodyPreferredLanguage;
  /** Enable in-app notifications */
  notifyInApp?: boolean;
  /** Enable email notifications */
  notifyEmail?: boolean;
  /** Enable daily skills reminder */
  dailySkillsReminder?: boolean;
  /** Enable overdue skills reminder */
  overDueSkilsReminder?: boolean;
}

export interface UpdateSettingsResponse {
  /** Success status */
  success: boolean;
  /** Message */
  message: string;
  /** Preferred language */
  preferredLanguage: string;
  /** In-app notifications enabled */
  notifyInApp: boolean;
  /** Email notifications enabled */
  notifyEmail: boolean;
  /** Daily skills reminder enabled */
  dailySkillsReminder: boolean;
  /** Overdue skills reminder enabled */
  overDueSkilsReminder: boolean;
}

/**
 * Subject/title
 * @nullable
 */
export type NotificationLogItemDtoSubject = { [key: string]: unknown } | null;

/**
 * Body (may contain HTML)
 * @nullable
 */
export type NotificationLogItemDtoBody = { [key: string]: unknown } | null;

export interface NotificationLogItemDto {
  /** Notification log id */
  id: number;
  /**
   * Subject/title
   * @nullable
   */
  subject?: NotificationLogItemDtoSubject;
  /**
   * Body (may contain HTML)
   * @nullable
   */
  body?: NotificationLogItemDtoBody;
  /** Whether the user has read this notification */
  read: boolean;
  /** When the notification was created (ISO string) */
  createdAt: string;
}

export interface GetNotificationsResponse {
  data: NotificationLogItemDto[];
  totalCount: number;
  page: number;
  pageSize: number;
}

export interface RegisterNotificationTokenBody {
  /** FCM device token for push notifications */
  token: string;
}

export interface LearnerAssignedAnnouncementDto {
  /** Enrollment id */
  id: number;
  /** Announcement id */
  announcementId: number;
  /**
   * URL slug for learn page
   * @nullable
   */
  slug?: string | null;
  /**
   * Title
   * @nullable
   */
  title?: string | null;
  /**
   * Subtitle
   * @nullable
   */
  subtitle?: string | null;
  /**
   * Content
   * @nullable
   */
  content?: string | null;
  /**
   * Published at (ISO string)
   * @nullable
   */
  publishedAt?: string | null;
  /**
   * Scheduled delivery instant (ISO string); learner UI prefers this for display when set
   * @nullable
   */
  scheduledDeliveryDate?: string | null;
  /** Whether the learner has completed */
  complete: boolean;
  /**
   * Author display name
   * @nullable
   */
  authorName?: string | null;
  /**
   * For announcement type: profileImage
   * @nullable
   */
  profileImage?: string | null;
  /**
   * For announcement type: lastname
   * @nullable
   */
  lastname?: string | null;
  /**
   * For announcement type: firstname
   * @nullable
   */
  firstname?: string | null;
  /**
   * For announcement type: jobTitle
   * @nullable
   */
  jobTitle?: string | null;
  /**
   * For announcement type: videoUrl
   * @nullable
   */
  videoUrl?: string | null;
  /**
   * For announcement type: videoThumbnailUrl
   * @nullable
   */
  videoThumbnailUrl?: string | null;
  /**
   * For announcement type: videoType
   * @nullable
   */
  videoType?: string | null;
  /**
   * Attached files
   * @nullable
   */
  files?: string[] | null;
  /**
   * Links (URLs)
   * @nullable
   */
  links?: string[] | null;
}

export interface GetLearnerAssignedResponse {
  data: LearnerAssignedAnnouncementDto[];
}

export type NotificationItemDtoNotificationType = typeof NotificationItemDtoNotificationType[keyof typeof NotificationItemDtoNotificationType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NotificationItemDtoNotificationType = {
  notification: 'notification',
  announcement: 'announcement',
} as const;

export interface NotificationItemDto {
  id: number;
  /** @nullable */
  subject?: string | null;
  /** @nullable */
  body?: string | null;
  read: boolean;
  /** Created at (ISO string) */
  createdAt: string;
  notificationType: NotificationItemDtoNotificationType;
  /**
   * For announcement type: enrollment id
   * @nullable
   */
  enrollmentId?: number | null;
  /**
   * For announcement type: announcement id
   * @nullable
   */
  announcementId?: number | null;
  /**
   * For announcement type: title
   * @nullable
   */
  title?: string | null;
  /**
   * For announcement type: publishedAt
   * @nullable
   */
  publishedAt?: string | null;
  /**
   * For announcement type: scheduled delivery (ISO string)
   * @nullable
   */
  scheduledDeliveryDate?: string | null;
  /**
   * For announcement type: author username
   * @nullable
   */
  authorName?: string | null;
  /**
   * For announcement type: complete
   * @nullable
   */
  complete?: boolean | null;
  /**
   * For announcement type: profileImage
   * @nullable
   */
  profileImage?: string | null;
  /**
   * For announcement type: lastname
   * @nullable
   */
  lastname?: string | null;
  /**
   * For announcement type: firstname
   * @nullable
   */
  firstname?: string | null;
  /**
   * For announcement type: jobTitle
   * @nullable
   */
  jobTitle?: string | null;
  /**
   * For announcement type: subtitle
   * @nullable
   */
  subtitle?: string | null;
  /**
   * For announcement type: slug
   * @nullable
   */
  slug?: string | null;
  /**
   * For announcement type: videoUrl
   * @nullable
   */
  videoUrl?: string | null;
  /**
   * For announcement type: videoThumbnailUrl
   * @nullable
   */
  videoThumbnailUrl?: string | null;
  /**
   * For announcement type: videoType
   * @nullable
   */
  videoType?: string | null;
  /**
   * For announcement type: attached files
   * @nullable
   */
  files?: string[] | null;
  /**
   * For announcement type: links (URLs)
   * @nullable
   */
  links?: string[] | null;
}

export interface GetLearnerNotificationsResponse {
  data: NotificationItemDto[];
  page: number;
  pageSize: number;
  totalCount: number;
  pageCount: number;
  /** Total count of unread notifications plus non-completed announcements */
  unreadTotalCount: number;
}

export interface GetStreakInfoResponse {
  /** Current streak count */
  streak: number;
  /**
   * Date of last streak update (ISO string)
   * @nullable
   */
  streakDate?: string | null;
  /** Largest streak ever achieved */
  largestStreak: number;
  /**
   * Date when largest streak was achieved (ISO string)
   * @nullable
   */
  largestStreakDate?: string | null;
  /** Whether streak is currently paused */
  isStreakPaused: boolean;
  /** User timezone */
  timezone: string;
  /** Whether the user cohort allows pausing the streak (first membership cohort). If false, pause UI should be disabled and streak is treated as unpaused for display. */
  isPauseStreakEnabled: boolean;
  /** True when today is an organization time-off / away date in the user’s timezone (Identity time-off API). */
  isTodayTimeOff: boolean;
}

export interface UpdateStreakStateBody {
  /** Whether to pause the streak */
  isStreakPaused: boolean;
  incrementStreakIfEligible?: boolean;
}

export interface UpdateStreakStateResponse {
  /** Updated streak pause status */
  isStreakPaused: boolean;
  /** Current streak count after this operation */
  streak: number;
}

/**
 * Attribute to filter
 */
export type UserAttributeFilterDtoField = typeof UserAttributeFilterDtoField[keyof typeof UserAttributeFilterDtoField];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserAttributeFilterDtoField = {
  firstname: 'firstname',
  lastname: 'lastname',
  email: 'email',
  jobTitle: 'jobTitle',
  jobCategory: 'jobCategory',
  division: 'division',
  supervisorName: 'supervisorName',
  streak: 'streak',
  overdue: 'overdue',
  completedModules: 'completedModules',
  createdAt: 'createdAt',
  customFieldValue1: 'customFieldValue1',
  customFieldValue2: 'customFieldValue2',
  customFieldValue3: 'customFieldValue3',
  employeeCode: 'employeeCode',
  hireDate: 'hireDate',
  titleStartDate: 'titleStartDate',
} as const;

/**
 * Filter operator: co=contains, eq=equals, ne=not, sw=startsWith, ew=endsWith, pr=not null, gt=>gt, lt=>lt, ge=>gte, le=>lte (for numeric/date)
 */
export type UserAttributeFilterDtoOperator = typeof UserAttributeFilterDtoOperator[keyof typeof UserAttributeFilterDtoOperator];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserAttributeFilterDtoOperator = {
  co: 'co',
  eq: 'eq',
  ne: 'ne',
  sw: 'sw',
  ew: 'ew',
  pr: 'pr',
  gt: 'gt',
  lt: 'lt',
  ge: 'ge',
  le: 'le',
  em: 'em',
} as const;

export interface UserAttributeFilterDto {
  /** Attribute to filter */
  field?: UserAttributeFilterDtoField;
  /** Value to match (not required for operator "pr") */
  value?: string;
  /** Filter operator: co=contains, eq=equals, ne=not, sw=startsWith, ew=endsWith, pr=not null, gt=>gt, lt=>lt, ge=>gte, le=>lte (for numeric/date) */
  operator?: UserAttributeFilterDtoOperator;
}

/**
 * How to combine multiple attribute filters
 */
export type UserFiltersDtoOperator = typeof UserFiltersDtoOperator[keyof typeof UserFiltersDtoOperator];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserFiltersDtoOperator = {
  and: 'and',
  or: 'or',
} as const;

export interface UserFiltersDto {
  /** How to combine multiple attribute filters */
  operator?: UserFiltersDtoOperator;
  /** Attribute filter conditions */
  conditions?: UserAttributeFilterDto[];
}

/**
 * Phone
 * @nullable
 */
export type UserListDtoPhone = { [key: string]: unknown } | null;

/**
 * Job title
 * @nullable
 */
export type UserListDtoJobTitle = { [key: string]: unknown } | null;

/**
 * Job category
 * @nullable
 */
export type UserListDtoJobCategory = { [key: string]: unknown } | null;

/**
 * Division
 * @nullable
 */
export type UserListDtoDivision = { [key: string]: unknown } | null;

/**
 * Supervisor name
 * @nullable
 */
export type UserListDtoSupervisorName = { [key: string]: unknown } | null;

/**
 * Custom field value 1
 * @nullable
 */
export type UserListDtoCustomFieldValue1 = { [key: string]: unknown } | null;

/**
 * Custom field value 2
 * @nullable
 */
export type UserListDtoCustomFieldValue2 = { [key: string]: unknown } | null;

/**
 * Custom field value 3
 * @nullable
 */
export type UserListDtoCustomFieldValue3 = { [key: string]: unknown } | null;

/**
 * Employee code
 * @nullable
 */
export type UserListDtoEmployeeCode = { [key: string]: unknown } | null;

export interface UserListDto {
  /** User ID */
  id: number;
  /** First name */
  firstname: string;
  /** Last name */
  lastname: string;
  /** Email */
  email: string;
  /**
   * Phone
   * @nullable
   */
  phone: UserListDtoPhone;
  /**
   * Job title
   * @nullable
   */
  jobTitle: UserListDtoJobTitle;
  /**
   * Job category
   * @nullable
   */
  jobCategory: UserListDtoJobCategory;
  /**
   * Division
   * @nullable
   */
  division: UserListDtoDivision;
  /**
   * Hire date (YYYY-MM-DD)
   * @nullable
   */
  hireDate: string | null;
  /**
   * Title start date (YYYY-MM-DD)
   * @nullable
   */
  titleStartDate: string | null;
  /**
   * Supervisor name
   * @nullable
   */
  supervisorName: UserListDtoSupervisorName;
  /** Created at */
  createdAt: string;
  /** Current streak */
  streak: number;
  /** Overdue lessons count */
  overdue: number;
  /** Completed modules/lessons count */
  completedModules: number;
  /** Time spent on training (seconds) */
  timeSpentOnTraining: number;
  /** Whether user is archived */
  archived: boolean;
  /**
   * Custom field value 1
   * @nullable
   */
  customFieldValue1: UserListDtoCustomFieldValue1;
  /**
   * Custom field value 2
   * @nullable
   */
  customFieldValue2: UserListDtoCustomFieldValue2;
  /**
   * Custom field value 3
   * @nullable
   */
  customFieldValue3: UserListDtoCustomFieldValue3;
  /**
   * Employee code
   * @nullable
   */
  employeeCode: UserListDtoEmployeeCode;
}

export interface ListUsersResponse {
  /** List of users */
  data: UserListDto[];
  /** Total count (for pagination) */
  total: number;
  /** Current page (1-based) */
  page: number;
  /** Page size */
  pageSize: number;
}

export interface GetUserByIdResponse {
  /** User ID */
  id: number;
  /** User email */
  email: string;
  /** User first name */
  firstName: string;
  /** User last name */
  lastName: string;
  /** User profile image */
  profileImage: string;
  /** User streak */
  streak: number;
}

export interface FeedItemCourseDto {
  id: number;
  title: string;
  slug: string;
}

export type FeedItemDtoFeedTier = typeof FeedItemDtoFeedTier[keyof typeof FeedItemDtoFeedTier];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FeedItemDtoFeedTier = {
  'due-date': 'due-date',
  admin: 'admin',
  self: 'self',
  auto: 'auto',
  unknown: 'unknown',
} as const;

export interface FeedItemDto {
  id: number;
  slug: string;
  title: string;
  type: string;
  /** @nullable */
  videoUrl?: string | null;
  /** @nullable */
  videoType?: string | null;
  /** @nullable */
  videoThumbnailUrl?: string | null;
  /** @nullable */
  videoDuration?: number | null;
  enrollmentId: number;
  complete: boolean;
  tier: string;
  feedTier: FeedItemDtoFeedTier;
  isLocked: boolean;
  /** Whether this lesson was completed today */
  isCompleted: boolean;
  /** @nullable */
  dueDate?: string | null;
  /**
   * Due calendar date (YYYY-MM-DD) in the request `timezone` — use for display so it matches feed classification
   * @nullable
   */
  dueDateCalendar?: string | null;
  courseEnrollmentType: string;
  course: FeedItemCourseDto;
}

export interface AdminFeedResponse {
  data: FeedItemDto[];
  totalCount: number;
}

export interface GetRecentActivityResponse {
  data: RecentActivityItemDto[];
  totalCount: number;
  page: number;
  pageSize: number;
}

export interface GetActiveCoursesResponse {
  data: ActiveCourseDto[];
  totalCount: number;
}

export interface GetFinishedCoursesResponse {
  data: FinishedCourseDto[];
  totalCount: number;
}

export type RecommendedCourseDtoDescription = { [key: string]: unknown };

export interface RecommendedCourseDto {
  id: number;
  title: string;
  slug: string;
  description?: RecommendedCourseDtoDescription;
  contentType: string;
  score: number;
}

export interface GetRecommendedCoursesResponse {
  data: RecommendedCourseDto[];
  totalCount: number;
}

export interface BulkUnenrollCoursesBody {
  /** Course IDs to unenroll from */
  courseIds: number[];
}

export interface BulkUnenrollCoursesResponse {
  /** Successfully unenrolled course IDs */
  unenrolledCourseIds: number[];
  /** Errors for failed unenrollments */
  errors: string[];
}

/**
 * Cohort title
 */
export type CohortListItemDtoTitle = { [key: string]: unknown };

/**
 * Public library type/provider
 * @nullable
 */
export type CohortListItemDtoPublicLibraryType = { [key: string]: unknown } | null;

/**
 * External ID
 * @nullable
 */
export type CohortListItemDtoExternalId = { [key: string]: unknown } | null;

export interface CohortListItemDto {
  /** Cohort ID */
  id: number;
  /** Cohort title */
  title: CohortListItemDtoTitle;
  /**
   * Public library type/provider
   * @nullable
   */
  publicLibraryType: CohortListItemDtoPublicLibraryType;
  /**
   * External ID
   * @nullable
   */
  externalId: CohortListItemDtoExternalId;
  /** Whether cohort is publicly visible */
  publiclyVisible: boolean;
}

export interface ListCohortsResponse {
  /** Array of cohorts */
  data: CohortListItemDto[];
  /** Total number of cohorts */
  totalCount: number;
  /** Current page number */
  page: number;
  /** Items per page */
  pageSize: number;
  /** Total number of pages */
  totalPages: number;
}

export interface ExtendedAccessDto {
  /** Cohort ID */
  id: number;
  /** Cohort title */
  title: string;
}

/**
 * Custom field name 1
 * @nullable
 */
export type GetCohortSettingsResponseCustomFieldName1 = { [key: string]: unknown } | null;

/**
 * Custom field name 2
 * @nullable
 */
export type GetCohortSettingsResponseCustomFieldName2 = { [key: string]: unknown } | null;

/**
 * Custom field name 3
 * @nullable
 */
export type GetCohortSettingsResponseCustomFieldName3 = { [key: string]: unknown } | null;

/**
 * Is custom field 1 active
 * @nullable
 */
export type GetCohortSettingsResponseIsActiveCustomField1 = { [key: string]: unknown } | null;

/**
 * Is custom field 2 active
 * @nullable
 */
export type GetCohortSettingsResponseIsActiveCustomField2 = { [key: string]: unknown } | null;

/**
 * Is custom field 3 active
 * @nullable
 */
export type GetCohortSettingsResponseIsActiveCustomField3 = { [key: string]: unknown } | null;

export interface GetCohortSettingsResponse {
  /**
   * Daily lesson limit
   * @minimum 1
   * @maximum 3
   */
  dailyLimit: number;
  /** Training feed auto assignment enabled */
  trainingFeedAutoAssignment: boolean;
  /** Comments enabled */
  comments: boolean;
  /**
   * Course variety
   * @minimum 1
   * @maximum 6
   */
  courseVariety: number;
  /** Publicly visible cohort */
  publiclyVisible: boolean;
  /** Extended access cohorts */
  extendedAccess?: ExtendedAccessDto[];
  /** Pause streak enabled for cohort members */
  isPauseStreakEnabled: boolean;
  /**
   * Custom field name 1
   * @nullable
   */
  customFieldName1?: GetCohortSettingsResponseCustomFieldName1;
  /**
   * Custom field name 2
   * @nullable
   */
  customFieldName2?: GetCohortSettingsResponseCustomFieldName2;
  /**
   * Custom field name 3
   * @nullable
   */
  customFieldName3?: GetCohortSettingsResponseCustomFieldName3;
  /**
   * Is custom field 1 active
   * @nullable
   */
  isActiveCustomField1?: GetCohortSettingsResponseIsActiveCustomField1;
  /**
   * Is custom field 2 active
   * @nullable
   */
  isActiveCustomField2?: GetCohortSettingsResponseIsActiveCustomField2;
  /**
   * Is custom field 3 active
   * @nullable
   */
  isActiveCustomField3?: GetCohortSettingsResponseIsActiveCustomField3;
}

export interface ExtendedAccessInputDto {
  /** Cohort ID */
  id: number;
}

export interface UpdateCohortSettingsBody {
  /**
   * Daily lesson limit (1-3)
   * @minimum 1
   * @maximum 3
   */
  dailyLimit?: number;
  /** Training feed auto assignment enabled */
  trainingFeedAutoAssignment?: boolean;
  /** Clear existing enrollments (when disabling auto assignment) */
  clearExistingEnrollments?: boolean;
  /** Comments enabled */
  comments?: boolean;
  /**
   * Course variety (1-6)
   * @minimum 1
   * @maximum 6
   */
  courseVariety?: number;
  /** Publicly visible cohort */
  publiclyVisible?: boolean;
  /** Extended access cohorts */
  extendedAccess?: ExtendedAccessInputDto[];
  /** Pause streak enabled for cohort members */
  isPauseStreakEnabled?: boolean;
}

export interface UpdateCohortSettingsResponse {
  /** Success status */
  success: boolean;
  /** Success message */
  message: string;
}

export interface GetTilesResponse {
  /** Formatted completed lessons count (e.g., "1.5K" or "500") */
  completedLessons: string;
  /** Formatted completed courses count (e.g., "250") */
  completedCourses: string;
  /** Formatted time in training (e.g., "2 h" or "45 m") */
  timeInTraining: string;
  /** Formatted active users count (e.g., "42") */
  activeUsers: string;
  /** Formatted inactive users count (e.g., "5") */
  inactiveUsers: string;
  /** Formatted users with overdue lessons count (e.g., "8") */
  usersWithOverdueLessons: string;
}

export interface CompletedLessonDto {
  id: number;
  userId: number;
  firstname: string;
  lastname: string;
  /** @nullable */
  email: string | null;
  /** @nullable */
  phone: string | null;
  lesson: string;
  /** Duration in seconds */
  duration: number;
  course: string;
  /** ISO date string */
  completedOn: string;
  enrollmentType: string;
  /** @nullable */
  supervisor: string | null;
  /** @nullable */
  division: string | null;
  /** @nullable */
  status: string | null;
  /** @nullable */
  jobCategory: string | null;
  /** @nullable */
  jobTitle: string | null;
  streak: number;
  /** @nullable */
  customFieldValue1: string | null;
  /** @nullable */
  customFieldValue2: string | null;
  /** @nullable */
  customFieldValue3: string | null;
  /** @nullable */
  employeeCode: string | null;
}

export interface GetCompletedLessonsResponse {
  data: CompletedLessonDto[];
  page: number;
  pageSize: number;
  totalCount: number;
}

export interface ChartDataPoint {
  /** Date range: [date] for daily, [start, end] for weekly */
  date: string[];
  /** Number of lessons completed */
  lessonsCompleted: number;
}

/**
 * Aggregation type
 */
export type GetChartResponseAxisDataType = typeof GetChartResponseAxisDataType[keyof typeof GetChartResponseAxisDataType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetChartResponseAxisDataType = {
  day: 'day',
  weekOfYear: 'weekOfYear',
} as const;

export interface GetChartResponse {
  /** Aggregation type */
  axisDataType: GetChartResponseAxisDataType;
  /** Tick marks for chart axis */
  tickInterval: string[];
  data: ChartDataPoint[];
}

export interface CompletedCourseDto {
  id: number;
  userId: number;
  firstName: string;
  lastName: string;
  /** @nullable */
  email: string | null;
  /** @nullable */
  phone: string | null;
  course: string;
  /** Duration in seconds */
  duration: number;
  /** @nullable */
  contentType: string | null;
  /** ISO date string */
  completedOn: string;
  enrollmentType: string;
  /** @nullable */
  supervisor: string | null;
  /** @nullable */
  division: string | null;
  /** @nullable */
  status: string | null;
  /** @nullable */
  jobCategory: string | null;
  /** @nullable */
  jobTitle: string | null;
  streak: number;
  /**
   * ISO date string
   * @nullable
   */
  lastActive: string | null;
  /** @nullable */
  customFieldValue1: string | null;
  /** @nullable */
  customFieldValue2: string | null;
  /** @nullable */
  customFieldValue3: string | null;
  /** @nullable */
  employeeCode: string | null;
}

export interface GetCompletedCoursesResponse {
  data: CompletedCourseDto[];
  page: number;
  pageSize: number;
  totalCount: number;
}

export interface ActiveUserDto {
  /** User ID */
  userId: number;
  /** First name */
  firstname: string;
  /** Last name */
  lastname: string;
  /**
   * Email address
   * @nullable
   */
  email: string | null;
  /**
   * Phone number
   * @nullable
   */
  phone: string | null;
  /** Time in training (formatted HH:mm) */
  timeInTraining: string;
  /** Number of completed lessons */
  completedLessons: number;
  /** Streak count */
  streak: number;
  /**
   * Last active date (ISO 8601)
   * @nullable
   */
  lastActive: string | null;
  /**
   * Supervisor name
   * @nullable
   */
  supervisor: string | null;
  /**
   * Division
   * @nullable
   */
  division: string | null;
  /**
   * User status
   * @nullable
   */
  status: string | null;
  /**
   * Job category
   * @nullable
   */
  jobCategory: string | null;
  /**
   * Job title
   * @nullable
   */
  jobTitle: string | null;
  /**
   * Custom field value 1
   * @nullable
   */
  customFieldValue1: string | null;
  /**
   * Custom field value 2
   * @nullable
   */
  customFieldValue2: string | null;
  /**
   * Custom field value 3
   * @nullable
   */
  customFieldValue3: string | null;
  /**
   * Employee code
   * @nullable
   */
  employeeCode: string | null;
}

export interface GetActiveUsersResponse {
  /** Current page number (1-indexed) */
  page: number;
  /** Items per page */
  pageSize: number;
  /** Total number of records */
  totalCount: number;
  /** Array of active users */
  data: ActiveUserDto[];
}

export interface InactiveUserDto {
  /** User ID */
  userId: number;
  /** First name */
  firstname: string;
  /** Last name */
  lastname: string;
  /**
   * Email address
   * @nullable
   */
  email: string | null;
  /**
   * Phone number
   * @nullable
   */
  phone: string | null;
  /** Number of overdue lessons */
  overdueLessons: number;
  /**
   * Last active date (ISO 8601)
   * @nullable
   */
  lastActive: string | null;
  /**
   * Supervisor name
   * @nullable
   */
  supervisor: string | null;
  /**
   * Division
   * @nullable
   */
  division: string | null;
  /**
   * User status
   * @nullable
   */
  status: string | null;
  /**
   * Job category
   * @nullable
   */
  jobCategory: string | null;
  /**
   * Job title
   * @nullable
   */
  jobTitle: string | null;
  /**
   * Custom field value 1
   * @nullable
   */
  customFieldValue1: string | null;
  /**
   * Custom field value 2
   * @nullable
   */
  customFieldValue2: string | null;
  /**
   * Custom field value 3
   * @nullable
   */
  customFieldValue3: string | null;
  /**
   * Employee code
   * @nullable
   */
  employeeCode: string | null;
}

export interface GetInactiveUsersResponse {
  /** Current page number (1-indexed) */
  page: number;
  /** Items per page */
  pageSize: number;
  /** Total number of records */
  totalCount: number;
  /** Array of inactive users */
  data: InactiveUserDto[];
}

export interface TimeInTrainingDto {
  /** User ID */
  userId: number;
  /** First name */
  firstname: string;
  /** Last name */
  lastname: string;
  /**
   * Email address
   * @nullable
   */
  email: string | null;
  /**
   * Phone number
   * @nullable
   */
  phone: string | null;
  /** Total watch time (formatted HH:mm) */
  totalWatchTime: string;
  /** Number of completed lessons */
  completedLessons: number;
  /**
   * Supervisor name
   * @nullable
   */
  supervisor: string | null;
  /**
   * Division
   * @nullable
   */
  division: string | null;
  /**
   * User status
   * @nullable
   */
  status: string | null;
  /**
   * Job category
   * @nullable
   */
  jobCategory: string | null;
  /**
   * Job title
   * @nullable
   */
  jobTitle: string | null;
  /**
   * Custom field value 1
   * @nullable
   */
  customFieldValue1: string | null;
  /**
   * Custom field value 2
   * @nullable
   */
  customFieldValue2: string | null;
  /**
   * Custom field value 3
   * @nullable
   */
  customFieldValue3: string | null;
  /**
   * Employee code
   * @nullable
   */
  employeeCode: string | null;
}

export interface GetTimeInTrainingResponse {
  /** Current page number (1-indexed) */
  page: number;
  /** Items per page */
  pageSize: number;
  /** Total number of records */
  totalCount: number;
  /** Array of users with time in training */
  data: TimeInTrainingDto[];
}

export interface OverdueLessonsDto {
  /** User ID */
  userId: number;
  /** First name */
  firstname: string;
  /** Last name */
  lastname: string;
  /**
   * Email address
   * @nullable
   */
  email: string | null;
  /**
   * Phone number
   * @nullable
   */
  phone: string | null;
  /** Number of overdue lessons */
  overdueLessons: number;
  /** Total duration in seconds */
  duration: number;
  /**
   * Last active date (ISO 8601)
   * @nullable
   */
  lastActive: string | null;
  /**
   * Supervisor name
   * @nullable
   */
  supervisor: string | null;
  /**
   * Division
   * @nullable
   */
  division: string | null;
  /**
   * User status
   * @nullable
   */
  status: string | null;
  /**
   * Job category
   * @nullable
   */
  jobCategory: string | null;
  /**
   * Job title
   * @nullable
   */
  jobTitle: string | null;
  /**
   * Custom field value 1
   * @nullable
   */
  customFieldValue1: string | null;
  /**
   * Custom field value 2
   * @nullable
   */
  customFieldValue2: string | null;
  /**
   * Custom field value 3
   * @nullable
   */
  customFieldValue3: string | null;
  /**
   * Employee code
   * @nullable
   */
  employeeCode: string | null;
}

export interface GetOverdueLessonsResponse {
  /** Current page number (1-indexed) */
  page: number;
  /** Items per page */
  pageSize: number;
  /** Total number of records */
  totalCount: number;
  /** Array of users with overdue lessons */
  data: OverdueLessonsDto[];
}

/**
 * Type of report to export
 */
export type StartExportRequestReportType = typeof StartExportRequestReportType[keyof typeof StartExportRequestReportType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StartExportRequestReportType = {
  completedLessons: 'completedLessons',
  completedCourses: 'completedCourses',
  activeUsers: 'activeUsers',
  inactiveUsers: 'inactiveUsers',
  timeInTraining: 'timeInTraining',
  usersWithOverdueLessons: 'usersWithOverdueLessons',
} as const;

/**
 * Sort order
 */
export type StartExportRequestOrder = typeof StartExportRequestOrder[keyof typeof StartExportRequestOrder];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StartExportRequestOrder = {
  asc: 'asc',
  desc: 'desc',
} as const;

export interface StartExportRequest {
  /** Type of report to export */
  reportType: StartExportRequestReportType;
  /** Include archived users */
  archivedUsers?: boolean;
  /** Start date (YYYY-MM-DD) */
  dateFrom: string;
  /** End date (YYYY-MM-DD) */
  dateTo: string;
  /** JSON filter object */
  filters?: string;
  /** Sort order */
  order?: StartExportRequestOrder;
  /** Column to sort by */
  orderBy?: string;
}

export interface StartExportResponse {
  /** Job ID for tracking export progress */
  jobId: string;
  /** Status message */
  message: string;
}

/**
 * Localized hint
 * @nullable
 */
export type LocalizedQuizQuestionDtoHint = { [key: string]: unknown } | null;

/**
 * Localized content/description
 * @nullable
 */
export type LocalizedQuizQuestionDtoContent = { [key: string]: unknown } | null;

export type LocalizedQuizQuestionDtoOptionsItem = { [key: string]: unknown };

export interface LocalizedQuizQuestionDto {
  /** Localized question title/text */
  title?: string;
  /**
   * Localized hint
   * @nullable
   */
  hint?: LocalizedQuizQuestionDtoHint;
  /**
   * Localized content/description
   * @nullable
   */
  content?: LocalizedQuizQuestionDtoContent;
  /**
   * Localized options (same shape as parent options field)
   * @nullable
   */
  options?: LocalizedQuizQuestionDtoOptionsItem[] | null;
  /**
   * Localized fill-the-blank word bank
   * @nullable
   */
  words_to_blank?: string[] | null;
}

export type InlineQuizQuestionDtoOptionsItem = { [key: string]: unknown };

export interface InlineQuizQuestionDto {
  /** The ID of the question (canonical English row) */
  id: number;
  /** The simplified type of the question (e.g., "singleChoice", "booleanChoice") */
  type: string;
  /** The title/text of the question (English) */
  title: string;
  /**
   * Optional hint for the question
   * @nullable
   */
  hint?: string | null;
  /**
   * Optional content/description for the question
   * @nullable
   */
  content?: string | null;
  /**
   * Options for choice-based questions
   * @nullable
   */
  options: InlineQuizQuestionDtoOptionsItem[] | null;
  /**
   * Words to blank for fill-the-blank questions
   * @nullable
   */
  words_to_blank?: string[] | null;
  /**
   * Character limit for text questions
   * @nullable
   */
  characterLimit?: number | null;
  /** Number of answers the learner must select (multiple choice) or blanks to fill (fill the blank). Does not reveal correct values. */
  answerCount?: number;
  /** Localized display copy when a translation exists (use for UI when locale is not en) */
  localized?: LocalizedQuizQuestionDto;
}

export interface GetInlineQuizQuestionsResponse {
  /** Array of quiz questions */
  questions: InlineQuizQuestionDto[];
}

export interface GetInlineQuizLatestResultResponse {
  /** Whether the user has completed (attempted) the quiz at least once */
  completed: boolean;
  /** Array of marked quiz answers */
  markedAnswers: string[];
  /** Number of correct answers */
  correct: number;
  /** Number of incorrect answers */
  incorrect: number;
  /** Required score to pass (percentage) */
  requiredScore: number;
  /** Whether the user passed the quiz */
  pass: boolean;
}

export interface SubmitInlineQuizRequest {
  /** Array of quiz answers submitted by the user */
  answers: QuizAnswerDto[];
}

/**
 * User submitted answer
 * @nullable
 */
export type MarkedQuizAnswerDtoUserAnswer = { [key: string]: unknown } | null;

/**
 * Correct answer(s)
 * @nullable
 */
export type MarkedQuizAnswerDtoCorrectAnswer = { [key: string]: unknown } | null;

export interface MarkedQuizAnswerDto {
  /** Question ID */
  questionId: number;
  /**
   * User submitted answer
   * @nullable
   */
  userAnswer: MarkedQuizAnswerDtoUserAnswer;
  /**
   * Correct answer(s)
   * @nullable
   */
  correctAnswer: MarkedQuizAnswerDtoCorrectAnswer;
  /** Whether the answer was correct */
  isCorrect: boolean;
}

/**
 * Leaderboard points awarded for a perfect score, or null when none were recorded
 * @nullable
 */
export type SubmitInlineQuizResponseAwardedPoints = { [key: string]: unknown } | null;

export interface SubmitInlineQuizResponse {
  /** Quiz result ID */
  quizResultId: number;
  /** Array of marked answers */
  markedAnswers: MarkedQuizAnswerDto[];
  /** Total number of questions */
  totalQuestions: number;
  /** Number of correct answers */
  correctAnswers: number;
  /** Score percentage (0-100) */
  scorePercentage: number;
  /** Whether the user passed (score >= passing score) */
  passed: boolean;
  /** Required passing score (0-100) */
  passingScore: number;
  /**
   * Leaderboard points awarded for a perfect score, or null when none were recorded
   * @nullable
   */
  awardedPoints?: SubmitInlineQuizResponseAwardedPoints;
}

export interface CreateNoteBodyDto {
  /** Note content */
  content: string;
  /**
   * Video timestamp in seconds
   * @nullable
   */
  videoTimestamp?: number | null;
  /** Lesson enrollment ID (from lesson page) */
  lessonEnrollmentId: number;
}

export interface NoteCourseDto {
  /**
   * Course slug
   * @nullable
   */
  slug?: string | null;
  /** Course title */
  title: string;
}

export interface NoteModuleDto {
  /**
   * Module slug
   * @nullable
   */
  slug?: string | null;
  /** Module title */
  title: string;
  /** Module type */
  type: string;
}

/**
 * Associated course information
 * @nullable
 */
export type NoteDtoCourse = NoteCourseDto | null;

/**
 * Associated module information
 * @nullable
 */
export type NoteDtoModule = NoteModuleDto | null;

export interface NoteDto {
  /** Note ID */
  id: number;
  /** Note content */
  content: string;
  /**
   * Video timestamp in seconds
   * @nullable
   */
  videoTimestamp?: number | null;
  /** Created at timestamp */
  createdAt: string;
  /** Updated at timestamp */
  updatedAt: string;
  /**
   * Associated course information
   * @nullable
   */
  course?: NoteDtoCourse;
  /**
   * Associated module information
   * @nullable
   */
  module?: NoteDtoModule;
}

export interface CreateNoteResponseDto {
  /** Success status */
  success: boolean;
  /** Message */
  message: string;
  /** Created note */
  note: NoteDto;
}

export interface SearchNotesResponseDto {
  /** Array of notes */
  notes: NoteDto[];
  /** Total count of notes */
  totalCount: number;
}

export interface UpdateNoteBodyDto {
  /** Note content */
  content: string;
  /**
   * Video timestamp in seconds
   * @nullable
   */
  videoTimestamp?: number | null;
}

export interface UpdateNoteResponseDto {
  /** Success status */
  success: boolean;
  /** Message */
  message: string;
  /** Updated note */
  note: NoteDto;
}

export interface DeleteNoteResponseDto {
  /** Success status */
  success: boolean;
  /** Message */
  message: string;
}

export interface CommentAuthorDto {
  /** User ID */
  id: number;
  /** Display name */
  name: string;
}

export interface CommentDto {
  /** Comment ID */
  id: number;
  /** Comment content */
  content: string;
  /** Author info */
  author: CommentAuthorDto;
  /** Created at */
  createdAt: string;
  /** Number of replies */
  childrenCount: number;
}

export interface SearchCommentsResponseDto {
  /** Comments */
  data: CommentDto[];
  /** Total count */
  totalCount: number;
  /** Current page */
  page: number;
}

export interface CreateCommentBodyDto {
  /** Comment content */
  content: string;
  /** Lesson enrollment ID (from lesson page) */
  lessonEnrollmentId: number;
  /** Parent comment ID for replies */
  threadOf?: number;
}

export interface CreateCommentResponseDto {
  /** Created comment */
  comment: CommentDto;
}

export interface LocaleDto {
  /** Locale ID */
  id: number;
  /** Locale name */
  name: string;
  /** Locale code (e.g., en, es, fr) */
  code: string;
  /** Created timestamp */
  createdAt: string;
  /** Updated timestamp */
  updatedAt: string;
}

export interface GetI18nLocalesResponse {
  /** List of locales */
  data: LocaleDto[];
}

export interface ScheduledReportOverviewDto {
  /** Total watch time in hours */
  'Total Watch Time (hours)'?: number;
  /** Watch time change percentage vs prior month */
  'Watch Time Change %'?: number;
  /** Users with completed lessons in range */
  'Users with Completed Lessons'?: number;
  /** Users with completed lessons change % */
  'Users with Completed Lessons Change %'?: number;
  /** Average watch time in hours */
  'Average Watch Time (hours)'?: number;
  /** Average watch time change % */
  'Average Watch Time Change %'?: number;
  /** Completed lessons count */
  'Completed Lessons'?: number;
  /** Completed lessons change % */
  'Completed Lessons Change %'?: number;
  /** Completed courses count */
  'Completed Courses'?: number;
  /** Completed courses change % */
  'Completed Courses Change %'?: number;
  /** Average streak in days */
  'Average Streak (days)'?: number;
  /** Average streak change % */
  'Average Streak Change %'?: number;
  /** Overdue lessons count */
  'Overdue Lessons'?: number;
  /** Overdue lessons change % */
  'Overdue Lessons Change %'?: number;
  /** Utilization percentage */
  'Utilization %'?: number;
  /** Utilization change % */
  'Utilization Change %'?: number;
}

export interface ScheduledReportTopPerformerDto {
  /** Display name */
  Name?: string;
  /** Profile image URL */
  ProfileImage?: string;
  /** Supervisor name */
  Supervisor?: string;
  /** Division */
  Division?: string;
  /** Completed lessons in period */
  'Completed Lessons This Month'?: number;
  /** Current streak */
  Streak?: number;
}

export interface ScheduledReportUserWithoutRowDto {
  /** Display name */
  Name?: string;
  /** Division */
  Division?: string;
  /** Supervisor */
  Supervisor?: string;
  /**
   * Date of last completion
   * @nullable
   */
  'Date of Last Completion'?: string | null;
}

export interface GetUsersWithoutCompletionsResponseDto {
  /** Page of users */
  data: ScheduledReportUserWithoutRowDto[];
  /** Total count across all pages */
  total: number;
}

/**
 * Team size
 */
export type ScheduledReportDivisionRowDtoTeamSize = number | string;

/**
 * Total lessons completed
 */
export type ScheduledReportDivisionRowDtoTotalLessonCompleted = number | string;

/**
 * Average completed lessons
 */
export type ScheduledReportDivisionRowDtoAvgCompletedLessons = number | string;

/**
 * Overdue lessons
 */
export type ScheduledReportDivisionRowDtoOverdueLessons = number | string;

export interface ScheduledReportDivisionRowDto {
  /** Division name */
  Division?: string;
  /** Team size */
  'Team Size'?: ScheduledReportDivisionRowDtoTeamSize;
  /** Total watch time (hours) */
  'Total Watch Time (hours)'?: number;
  /** Average watch time (hours) */
  'Avg. Watch Time (hours)'?: number;
  /** Total lessons completed */
  'Total Lesson Completed'?: ScheduledReportDivisionRowDtoTotalLessonCompleted;
  /** Average completed lessons */
  'Avg. Completed Lessons'?: ScheduledReportDivisionRowDtoAvgCompletedLessons;
  /** Overdue lessons */
  'Overdue Lessons'?: ScheduledReportDivisionRowDtoOverdueLessons;
}

export interface GetDivisionsResponseDto {
  /** Page of division rows */
  data: ScheduledReportDivisionRowDto[];
  /** Total count across all pages */
  total: number;
}

/**
 * Team size
 */
export type ScheduledReportSupervisorRowDtoTeamSize = number | string;

/**
 * Total completed lessons
 */
export type ScheduledReportSupervisorRowDtoTotalCompletedLessons = number | string;

/**
 * Average completed lessons
 */
export type ScheduledReportSupervisorRowDtoAvgCompletedLessons = number | string;

/**
 * Overdue lessons
 */
export type ScheduledReportSupervisorRowDtoOverdueLessons = number | string;

export interface ScheduledReportSupervisorRowDto {
  /** Supervisor name */
  Supervisor?: string;
  /** Team size */
  'Team Size'?: ScheduledReportSupervisorRowDtoTeamSize;
  /** Total watch time (hours) */
  'Total Watch Time (hours)'?: number;
  /** Average watch time (hours) */
  'Avg. Watch Time (hours)'?: number;
  /** Total completed lessons */
  'Total Completed Lessons'?: ScheduledReportSupervisorRowDtoTotalCompletedLessons;
  /** Average completed lessons */
  'Avg. Completed Lessons'?: ScheduledReportSupervisorRowDtoAvgCompletedLessons;
  /** Overdue lessons */
  'Overdue Lessons'?: ScheduledReportSupervisorRowDtoOverdueLessons;
}

export interface GetSupervisorsResponseDto {
  /** Page of supervisor rows */
  data: ScheduledReportSupervisorRowDto[];
  /** Total count across all pages */
  total: number;
}

export interface GenerateReportBody {
  /**
   * Month (1-12)
   * @minimum 1
   * @maximum 12
   */
  month: number;
  /**
   * Year (2000-2100)
   * @minimum 2000
   * @maximum 2100
   */
  year: number;
  /** Cohort ID (optional; defaults to current user cohort) */
  cohortId?: number;
}

export interface SavedReportMetaDto {
  /** Report ID */
  id: number;
  /** Month (1-12) */
  monthId: number;
  /** Year */
  yearId: number;
  /** Cohort ID */
  cohortId?: number;
  /**
   * When the report was generated
   * @nullable
   */
  generatedTimestamp: string | null;
  /** Human-readable month name */
  monthName: string;
}

export interface ScheduledReportDataDto {
  /** Month name */
  monthName: string;
  /** Account/cohort name */
  accountName: string;
  /** Overview metrics */
  overview?: ScheduledReportOverviewDto;
  /** Top performers */
  topPerformers?: ScheduledReportTopPerformerDto[];
  /** Division insights */
  divisions?: ScheduledReportDivisionRowDto[];
  /** Supervisor insights */
  supervisors?: ScheduledReportSupervisorRowDto[];
  /** Users without completions */
  usersWithout?: ScheduledReportUserWithoutRowDto[];
}

export interface GetSavedReportByIdResponseDto {
  /** Report ID */
  id: number;
  /** Month (1-12) */
  monthId: number;
  /** Year */
  yearId: number;
  /** Cohort ID */
  cohortId?: number;
  /**
   * When the report was generated
   * @nullable
   */
  generatedTimestamp: string | null;
  /** Human-readable month name */
  monthName: string;
  /** Full report payload */
  reportData: ScheduledReportDataDto;
}

export interface DistributionRecipientDto {
  /** Recipient record ID */
  id: number;
  /** User ID */
  userId: number;
  /** Display name */
  name: string;
  /** Email */
  email: string;
  /**
   * Job title
   * @nullable
   */
  jobTitle: string | null;
  /**
   * Division
   * @nullable
   */
  division: string | null;
}

export interface GetDistributionRecipientsResponseDto {
  /** Recipients */
  data: DistributionRecipientDto[];
  /** Total count */
  totalCount: number;
}

export interface AddDistributionRecipientsBody {
  /** User IDs to add as recipients */
  userIds: number[];
}

export interface AddDistributionRecipientsResponseDto {
  /** Status message */
  message: string;
  /** Number of recipients added */
  added: number;
}

export interface RemoveDistributionRecipientResponseDto {
  /** Status message */
  message: string;
}

export interface DeleteSavedReportResponseDto {
  /** Whether the delete succeeded */
  success: boolean;
}

export interface AdminAnnouncementListItemDto {
  id: number;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  slug?: string | null;
  /** @nullable */
  publishedAt?: string | null;
  /** @nullable */
  scheduledDeliveryDate?: string | null;
  /** @nullable */
  delivered?: boolean | null;
  readCount: number;
  audienceCount: number;
  /**
   * Author display name
   * @nullable
   */
  author?: string | null;
}

export interface ListCohortAnnouncementsResponse {
  data: AdminAnnouncementListItemDto[];
  totalCount: number;
  page: number;
  pageSize: number;
}

export interface AnnouncementEnrollmentUserDto {
  /**
   * Set when a learner link + user exists; null if enrollment has no learner rows yet
   * @nullable
   */
  userId?: number | null;
  /** @nullable */
  firstname?: string | null;
  /** @nullable */
  lastname?: string | null;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  jobTitle?: string | null;
  /**
   * From the linked announcement: published_at when set; otherwise scheduled_delivery_date, then created_at (legacy rows).
   * @nullable
   */
  publishedAt?: string | null;
  /** @nullable */
  completedAt?: string | null;
}

export interface GetAnnouncementEnrollmentsResponse {
  data: AnnouncementEnrollmentUserDto[];
  totalCount: number;
  page: number;
  pageSize: number;
}

/**
 * @nullable
 */
export type GetAnnouncementResponseDtoLinks = { [key: string]: unknown } | null;

export type GetAnnouncementResponseDtoFilesItem = { [key: string]: unknown };

export interface GetAnnouncementResponseDto {
  id: number;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  slug?: string | null;
  /** @nullable */
  subtitle?: string | null;
  /** @nullable */
  content?: string | null;
  /** @nullable */
  publishedAt?: string | null;
  /** @nullable */
  scheduledDeliveryDate?: string | null;
  /**
   * publish-immediately | schedule-delivery (from announcements.delivery_type)
   * @nullable
   */
  deliveryType?: string | null;
  /** @nullable */
  delivered?: boolean | null;
  /** @nullable */
  videoUrl?: string | null;
  /** @nullable */
  videoThumbnailUrl?: string | null;
  /** @nullable */
  videoType?: string | null;
  /** @nullable */
  links?: GetAnnouncementResponseDtoLinks;
  /** Attached files (from files_related_morphs; same shape as learner announcement files) */
  files?: GetAnnouncementResponseDtoFilesItem[];
  seenBy: number;
  unseenBy: number;
  /**
   * Author display name
   * @nullable
   */
  author?: string | null;
  /** @nullable */
  firstname?: string | null;
  /** @nullable */
  lastname?: string | null;
  /** @nullable */
  jobTitle?: string | null;
  /** @nullable */
  profileImage?: string | null;
  /**
   * Audience type (all-employees | specific-employees)
   * @nullable
   */
  audienceType?: string | null;
  /** User IDs for specific-employees audience */
  selectedUserIds: number[];
}

/**
 * Video URL (matches announcements.video_url)
 */
export type CreateAnnouncementBodyVideoUrl = { [key: string]: unknown };

/**
 * Video type (matches announcements.video_type)
 */
export type CreateAnnouncementBodyVideoType = { [key: string]: unknown };

export type CreateAnnouncementBodyDeliveryType = typeof CreateAnnouncementBodyDeliveryType[keyof typeof CreateAnnouncementBodyDeliveryType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateAnnouncementBodyDeliveryType = {
  'publish-immediately': 'publish-immediately',
  'schedule-delivery': 'schedule-delivery',
} as const;

export type CreateAnnouncementBodyAudienceType = typeof CreateAnnouncementBodyAudienceType[keyof typeof CreateAnnouncementBodyAudienceType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateAnnouncementBodyAudienceType = {
  'all-employees': 'all-employees',
  'specific-employees': 'specific-employees',
} as const;

export interface CreateAnnouncementBody {
  title?: string;
  subtitle?: string;
  content?: string;
  /** Video URL (matches announcements.video_url) */
  videoUrl?: CreateAnnouncementBodyVideoUrl;
  /** Video type (matches announcements.video_type) */
  videoType?: CreateAnnouncementBodyVideoType;
  scheduledDeliveryDate?: string;
  deliveryType?: CreateAnnouncementBodyDeliveryType;
  audienceType?: CreateAnnouncementBodyAudienceType;
  /** User IDs for specific-employees audience. */
  audienceUserIds?: number[];
  /** External support links (stored in announcements.links as JSON array) */
  links?: string[];
  /** File IDs to attach after upload via lessons upload-file endpoint. */
  existingFileIds?: number[];
}

/**
 * Video URL (matches announcements.video_url)
 */
export type UpdateAnnouncementBodyVideoUrl = { [key: string]: unknown };

/**
 * Video type (matches announcements.video_type)
 */
export type UpdateAnnouncementBodyVideoType = { [key: string]: unknown };

export type UpdateAnnouncementBodyDeliveryType = typeof UpdateAnnouncementBodyDeliveryType[keyof typeof UpdateAnnouncementBodyDeliveryType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateAnnouncementBodyDeliveryType = {
  'publish-immediately': 'publish-immediately',
  'schedule-delivery': 'schedule-delivery',
} as const;

export interface UpdateAnnouncementBody {
  title?: string;
  subtitle?: string;
  content?: string;
  /** Video URL (matches announcements.video_url) */
  videoUrl?: UpdateAnnouncementBodyVideoUrl;
  /** Video type (matches announcements.video_type) */
  videoType?: UpdateAnnouncementBodyVideoType;
  scheduledDeliveryDate?: string;
  deliveryType?: UpdateAnnouncementBodyDeliveryType;
  /** User IDs for specific-employees audience. Replaces the existing audience list. */
  audienceUserIds?: number[];
  /** External support links (stored in announcements.links as JSON array) */
  links?: string[];
  /** Replaces the full set of attached files. Upload files via lessons upload-file, then pass IDs here. Empty array clears all. */
  existingFileIds?: number[];
}

/**
 * @nullable
 */
export type AwardEventResponseDtoName = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type AwardEventResponseDtoDescription = { [key: string]: unknown } | null;

export interface AwardEventResponseDto {
  id: number;
  /** @nullable */
  name?: AwardEventResponseDtoName;
  /** @nullable */
  description?: AwardEventResponseDtoDescription;
  points: number;
}

export interface ListAwardEventsResponseDto {
  items: AwardEventResponseDto[];
}

export interface UserLeaderboardResponseDto {
  userId: number;
  cohortId: number;
  leaderboardPeriodId: number;
  /** Period start (YYYY-MM-DD, UTC) */
  periodStartDate: string;
  /** Period end (YYYY-MM-DD, UTC) */
  periodEndDate: string;
  rank: number;
  totalPoints: number;
  isPositiveRank: boolean;
}

/**
 * @nullable
 */
export type CohortLeaderboardEntryDtoFirstName = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type CohortLeaderboardEntryDtoLastName = { [key: string]: unknown } | null;

/**
 * User profile image URL (`up_users.profile_image`)
 * @nullable
 */
export type CohortLeaderboardEntryDtoProfileImage = { [key: string]: unknown } | null;

/**
 * Only populated when `dataSource` is `leaderboard` (persisted rank movement flag)
 * @nullable
 */
export type CohortLeaderboardEntryDtoIsPositiveRank = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type CohortLeaderboardEntryDtoJobTitle = { [key: string]: unknown } | null;

export interface CohortLeaderboardEntryDto {
  userId: number;
  /** @nullable */
  firstName?: CohortLeaderboardEntryDtoFirstName;
  /** @nullable */
  lastName?: CohortLeaderboardEntryDtoLastName;
  /**
   * User profile image URL (`up_users.profile_image`)
   * @nullable
   */
  profileImage?: CohortLeaderboardEntryDtoProfileImage;
  rank: number;
  totalPoints: number;
  /**
   * Only populated when `dataSource` is `leaderboard` (persisted rank movement flag)
   * @nullable
   */
  isPositiveRank?: CohortLeaderboardEntryDtoIsPositiveRank;
  /** @nullable */
  jobTitle?: CohortLeaderboardEntryDtoJobTitle;
}

export type ListCohortLeaderboardResponseDtoDataSource = typeof ListCohortLeaderboardResponseDtoDataSource[keyof typeof ListCohortLeaderboardResponseDtoDataSource];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ListCohortLeaderboardResponseDtoDataSource = {
  leaderboard: 'leaderboard',
  user_award_events: 'user_award_events',
} as const;

/**
 * Current calendar month period row (always resolved for context when possible)
 * @nullable
 */
export type ListCohortLeaderboardResponseDtoLeaderboardPeriodId = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type ListCohortLeaderboardResponseDtoPeriodStartDate = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type ListCohortLeaderboardResponseDtoPeriodEndDate = { [key: string]: unknown } | null;

export interface ListCohortLeaderboardResponseDto {
  dataSource: ListCohortLeaderboardResponseDtoDataSource;
  cohortId: number;
  /**
   * Current calendar month period row (always resolved for context when possible)
   * @nullable
   */
  leaderboardPeriodId?: ListCohortLeaderboardResponseDtoLeaderboardPeriodId;
  /** @nullable */
  periodStartDate?: ListCohortLeaderboardResponseDtoPeriodStartDate;
  /** @nullable */
  periodEndDate?: ListCohortLeaderboardResponseDtoPeriodEndDate;
  page: number;
  pageSize: number;
  totalCount: number;
  items: CohortLeaderboardEntryDto[];
}

/**
 * Enrollment type. Determines how the course appears in the training feed.
 */
export type PostEnrollUserBodyEnrollmentType = typeof PostEnrollUserBodyEnrollmentType[keyof typeof PostEnrollUserBodyEnrollmentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostEnrollUserBodyEnrollmentType = {
  learner: 'learner',
  'auto-assign-schedule': 'auto-assign-schedule',
  'prioritize-schedule': 'prioritize-schedule',
  'due-date-schedule': 'due-date-schedule',
  'strapi-admin': 'strapi-admin',
} as const;

export interface PostEnrollUserBody {
  /** Course ID */
  courseId: number;
  /** User ID */
  userId: number;
  /** Enrollment type. Determines how the course appears in the training feed. */
  enrollmentType?: PostEnrollUserBodyEnrollmentType;
  /** ISO 8601 date (YYYY-MM-DD). Required when enrollmentType is "due-date-schedule"; optional when "prioritize-schedule" (including default); must be omitted for other enrollment types. */
  dueDate?: string;
}

export interface PostEnrollUserResponse {
  /** Enrollment ID */
  enrollmentId: number;
}

export interface PostEnrollUsersInCourseInProgressResponse {
  /** Enrollment IDs */
  enrollmentIds: number[];
  /** Errors */
  errors: PostEnrollUsersInCourseError[];
  /** In progress */
  inProgress: boolean;
}

export interface PostUnenrollUsersInCourseInProgressResponse {
  /** Successfully unenrolled user IDs */
  unenrolledUserIds: string[];
  /** Errors */
  errors: string[];
  /** In progress */
  inProgress: boolean;
}

export interface PostUnenrollUsersInCourseWebSocketResponse {
  /** Successfully unenrolled user IDs */
  unenrolledUserIds: string[];
  /** Errors */
  errors: string[];
  /** In progress */
  inProgress: boolean;
  /** Whether the operation was successful */
  isSuccessful: boolean;
}

export interface PostEnrollUsersInPlaylistResponse {
  /** Whether the enrollment was successful */
  isSuccessful: boolean;
  /** Error message if enrollment failed */
  errorMessage?: string;
}

export interface PostUnenrollUsersInPlaylistResponse {
  /** Whether the unenrollment was successful */
  isSuccessful: boolean;
  /** Error message if unenrollment failed */
  errorMessage?: string;
}

export interface PostUnenrollUsersInPlaylistWebSocketResponse {
  /** Whether the unenrollment process is in progress */
  inProgress: boolean;
  /** Whether the operation was successful */
  isSuccessful: boolean;
}

export interface NotificationEventDto {
  /** Notification subject/title */
  subject: string;
  /** Notification body/message (may contain HTML) */
  body: string;
}

export interface NotificationEvent {
  data: NotificationEventDto;
}

/**
 * Socket.IO event name for user-targeted pushes (same strings as Bull bridge eventType).
 */
export type SocketIoServerEventNameSchemaEventName = typeof SocketIoServerEventNameSchemaEventName[keyof typeof SocketIoServerEventNameSchemaEventName];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SocketIoServerEventNameSchemaEventName = {
  notification: 'notification',
  completedCourseEnrollments: 'completedCourseEnrollments',
  completedPlaylistEnrollments: 'completedPlaylistEnrollments',
  completedUnenrollments: 'completedUnenrollments',
  completedRescheduleOverdueModules: 'completedRescheduleOverdueModules',
  completedPlaylistBulkComplete: 'completedPlaylistBulkComplete',
  completedCourseBulkComplete: 'completedCourseBulkComplete',
  leaderboardUpdated: 'leaderboardUpdated',
} as const;

export interface SocketIoServerEventNameSchema {
  /** Socket.IO event name for user-targeted pushes (same strings as Bull bridge eventType). */
  eventName: SocketIoServerEventNameSchemaEventName;
}

export interface LessonVideoProgressMessage {
  /** Lesson enrollment ID */
  enrollmentId: number;
  /** Video playback position in seconds */
  progress: number;
}

export type ClientPaginationLimitsMinPageSize = typeof ClientPaginationLimitsMinPageSize[keyof typeof ClientPaginationLimitsMinPageSize];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientPaginationLimitsMinPageSize = {
  NUMBER_1: 1,
} as const;

export type ClientPaginationLimitsMaxAdminListPageSize = typeof ClientPaginationLimitsMaxAdminListPageSize[keyof typeof ClientPaginationLimitsMaxAdminListPageSize];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientPaginationLimitsMaxAdminListPageSize = {
  NUMBER_200: 200,
} as const;

export type ClientPaginationLimitsDefaultCoursesListPageSize = typeof ClientPaginationLimitsDefaultCoursesListPageSize[keyof typeof ClientPaginationLimitsDefaultCoursesListPageSize];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientPaginationLimitsDefaultCoursesListPageSize = {
  NUMBER_20: 20,
} as const;

export type ClientPaginationLimitsDefaultLessonsListPageSize = typeof ClientPaginationLimitsDefaultLessonsListPageSize[keyof typeof ClientPaginationLimitsDefaultLessonsListPageSize];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientPaginationLimitsDefaultLessonsListPageSize = {
  NUMBER_20: 20,
} as const;

export type ClientPaginationLimitsDefaultStandardAdminListPageSize = typeof ClientPaginationLimitsDefaultStandardAdminListPageSize[keyof typeof ClientPaginationLimitsDefaultStandardAdminListPageSize];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientPaginationLimitsDefaultStandardAdminListPageSize = {
  NUMBER_25: 25,
} as const;

export type ClientPaginationLimitsDefaultCohortsListPageSize = typeof ClientPaginationLimitsDefaultCohortsListPageSize[keyof typeof ClientPaginationLimitsDefaultCohortsListPageSize];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientPaginationLimitsDefaultCohortsListPageSize = {
  NUMBER_100: 100,
} as const;

export type ClientPaginationLimitsDefaultSearchCoursesPageSize = typeof ClientPaginationLimitsDefaultSearchCoursesPageSize[keyof typeof ClientPaginationLimitsDefaultSearchCoursesPageSize];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientPaginationLimitsDefaultSearchCoursesPageSize = {
  NUMBER_100: 100,
} as const;

export type ClientPaginationLimitsMaxSearchCoursesPage = typeof ClientPaginationLimitsMaxSearchCoursesPage[keyof typeof ClientPaginationLimitsMaxSearchCoursesPage];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientPaginationLimitsMaxSearchCoursesPage = {
  NUMBER_1000: 1000,
} as const;

export type ClientPaginationLimitsDefaultRecentActivityPageSize = typeof ClientPaginationLimitsDefaultRecentActivityPageSize[keyof typeof ClientPaginationLimitsDefaultRecentActivityPageSize];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientPaginationLimitsDefaultRecentActivityPageSize = {
  NUMBER_10: 10,
} as const;

export type ClientPaginationLimitsDefaultInternalScheduledReportsPageSize = typeof ClientPaginationLimitsDefaultInternalScheduledReportsPageSize[keyof typeof ClientPaginationLimitsDefaultInternalScheduledReportsPageSize];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientPaginationLimitsDefaultInternalScheduledReportsPageSize = {
  NUMBER_10: 10,
} as const;

export type ClientPaginationLimitsAdminUserRecentActivityFetchPageSize = typeof ClientPaginationLimitsAdminUserRecentActivityFetchPageSize[keyof typeof ClientPaginationLimitsAdminUserRecentActivityFetchPageSize];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientPaginationLimitsAdminUserRecentActivityFetchPageSize = {
  NUMBER_100: 100,
} as const;

/**
 * Canonical pagination limits shared across Improve admin list endpoints. Each field mirrors the corresponding export in `src/types/types/pagination.ts`.
 */
export interface ClientPaginationLimits {
  minPageSize?: ClientPaginationLimitsMinPageSize;
  maxAdminListPageSize?: ClientPaginationLimitsMaxAdminListPageSize;
  defaultCoursesListPageSize?: ClientPaginationLimitsDefaultCoursesListPageSize;
  defaultLessonsListPageSize?: ClientPaginationLimitsDefaultLessonsListPageSize;
  defaultStandardAdminListPageSize?: ClientPaginationLimitsDefaultStandardAdminListPageSize;
  defaultCohortsListPageSize?: ClientPaginationLimitsDefaultCohortsListPageSize;
  defaultSearchCoursesPageSize?: ClientPaginationLimitsDefaultSearchCoursesPageSize;
  maxSearchCoursesPage?: ClientPaginationLimitsMaxSearchCoursesPage;
  defaultRecentActivityPageSize?: ClientPaginationLimitsDefaultRecentActivityPageSize;
  defaultInternalScheduledReportsPageSize?: ClientPaginationLimitsDefaultInternalScheduledReportsPageSize;
  adminUserRecentActivityFetchPageSize?: ClientPaginationLimitsAdminUserRecentActivityFetchPageSize;
}

export type RxdControllerGetCourseCurriculumParams = {
/**
 * Content locale (en | es-419)
 */
locale?: string;
};

export type CoursesControllerCreateBodyOne = {
  /** JSON-stringified PostCourseBody */
  data?: string;
  /** Optional featured image file */
  featuredImage?: Blob;
};

export type CoursesControllerCreateBodyTwo = {
  /** JSON-stringified PostCourseBody */
  data?: string;
  /** Optional featured image file */
  featuredImage?: Blob;
};

export type CoursesControllerListParams = {
/**
 * Page number (1-based)
 * @minimum 1
 */
page?: number;
/**
 * Items per page
 * @minimum 1
 * @maximum 200
 */
pageSize?: number;
/**
 * Filter by cohort ID
 */
cohortId?: number;
/**
 * Include courses from extended access cohorts (shared courses)
 */
extendedAccess?: boolean;
/**
 * Only return published courses
 */
publishedOnly?: boolean;
/**
 * Include soft-deleted courses
 */
includeDeleted?: boolean;
/**
 * Sort field
 */
sortBy?: CoursesControllerListSortBy;
/**
 * Sort direction
 */
sortDirection?: CoursesControllerListSortDirection;
/**
 * Filters object with operator (AND/OR) and conditions. Example: {"operator":"and","conditions":[{"field":"title","value":"Safety","operator":"co"}]}
 */
filters?: CourseFiltersDto;
};

export type CoursesControllerListSortBy = typeof CoursesControllerListSortBy[keyof typeof CoursesControllerListSortBy];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CoursesControllerListSortBy = {
  title: 'title',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  publishedAt: 'publishedAt',
  enrollmentCount: 'enrollmentCount',
  moduleCount: 'moduleCount',
  completionCount: 'completionCount',
  contentType: 'contentType',
  authorCohort: 'authorCohort',
} as const;

export type CoursesControllerListSortDirection = typeof CoursesControllerListSortDirection[keyof typeof CoursesControllerListSortDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CoursesControllerListSortDirection = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type CoursesControllerSearchParams = {
/**
 * Search term to filter courses
 */
search?: string;
/**
 * Content locale (one course per family shown; default "en")
 */
locale?: CoursesControllerSearchLocale;
/**
 * Page number (1-indexed)
 * @minimum 1
 * @maximum 1000
 */
page?: number;
/**
 * Number of results per page
 * @minimum 1
 * @maximum 200
 */
pageSize?: number;
};

export type CoursesControllerSearchLocale = typeof CoursesControllerSearchLocale[keyof typeof CoursesControllerSearchLocale];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CoursesControllerSearchLocale = {
  en: 'en',
  'es-419': 'es-419',
} as const;

export type CoursesControllerListLessonsParams = {
/**
 * Page number (1-indexed)
 * @minimum 1
 */
page?: number;
/**
 * Page size
 * @minimum 1
 * @maximum 200
 */
pageSize?: number;
/**
 * Filters object with operator (AND/OR) and conditions.
 */
filters?: CourseLessonFiltersDto;
/**
 * Field to order by
 */
orderBy?: CoursesControllerListLessonsOrderBy;
/**
 * Order direction
 */
orderDirection?: CoursesControllerListLessonsOrderDirection;
};

export type CoursesControllerListLessonsOrderBy = typeof CoursesControllerListLessonsOrderBy[keyof typeof CoursesControllerListLessonsOrderBy];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CoursesControllerListLessonsOrderBy = {
  title: 'title',
  updatedAt: 'updatedAt',
  videoDuration: 'videoDuration',
  courseCurriculumItemOrder: 'courseCurriculumItemOrder',
} as const;

export type CoursesControllerListLessonsOrderDirection = typeof CoursesControllerListLessonsOrderDirection[keyof typeof CoursesControllerListLessonsOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CoursesControllerListLessonsOrderDirection = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type CoursesControllerListQuizzesParams = {
/**
 * Page number (1-indexed)
 * @minimum 1
 */
page?: number;
/**
 * Page size
 * @minimum 1
 * @maximum 200
 */
pageSize?: number;
/**
 * Filters object with operator (AND/OR) and conditions.
 */
filters?: CourseQuizFiltersDto;
/**
 * Field to order by
 */
orderBy?: CoursesControllerListQuizzesOrderBy;
/**
 * Order direction
 */
orderDirection?: CoursesControllerListQuizzesOrderDirection;
};

export type CoursesControllerListQuizzesOrderBy = typeof CoursesControllerListQuizzesOrderBy[keyof typeof CoursesControllerListQuizzesOrderBy];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CoursesControllerListQuizzesOrderBy = {
  title: 'title',
  updatedAt: 'updatedAt',
} as const;

export type CoursesControllerListQuizzesOrderDirection = typeof CoursesControllerListQuizzesOrderDirection[keyof typeof CoursesControllerListQuizzesOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CoursesControllerListQuizzesOrderDirection = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type CoursesControllerListEnrollmentsParams = {
/**
 * Page number (1-based)
 * @minimum 1
 */
page?: number;
/**
 * Items per page
 * @minimum 1
 * @maximum 200
 */
pageSize?: number;
/**
 * Sort field: user columns on `up_users` (e.g. `hireDate`, `titleStartDate`), or `progress` (course %), `dueDate` (latest lesson due for enrollment), `assignedOn` (enrollment `enrolled_on`), `enrollmentType` (enrollment `enrollment_type`). Server may sort computed fields in memory then paginate.
 */
sortBy?: string;
/**
 * Sort direction
 */
sortDirection?: CoursesControllerListEnrollmentsSortDirection;
/**
 * JSON-encoded filters: `{"operator":"and","conditions":[{"field":"firstname","value":"Ada","operator":"co"},{"field":"progress","value":"100","operator":"eq"}]}`. See docs/filtering-and-sorting.md.
 */
filters?: CourseEnrollmentFiltersDto;
};

export type CoursesControllerListEnrollmentsSortDirection = typeof CoursesControllerListEnrollmentsSortDirection[keyof typeof CoursesControllerListEnrollmentsSortDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CoursesControllerListEnrollmentsSortDirection = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type CoursesControllerUpdateBodyOne = {
  /** JSON-stringified PutCourseBody */
  data?: string;
  /** Optional featured image file */
  featuredImage?: Blob;
};

export type CoursesControllerUpdateBodyTwo = {
  /** JSON-stringified PutCourseBody */
  data?: string;
  /** Optional featured image file */
  featuredImage?: Blob;
};

export type CoursesControllerDeleteParams = {
hard: boolean;
};

export type CoursesControllerGetDetailsParams = {
/**
 * Content locale (title, description). Defaults to "en".
 */
locale?: CoursesControllerGetDetailsLocale;
};

export type CoursesControllerGetDetailsLocale = typeof CoursesControllerGetDetailsLocale[keyof typeof CoursesControllerGetDetailsLocale];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CoursesControllerGetDetailsLocale = {
  en: 'en',
  'es-419': 'es-419',
} as const;

export type CoursesControllerGetCurriculumParams = {
/**
 * Content locale (title, etc.). Defaults to "en".
 */
locale?: CoursesControllerGetCurriculumLocale;
};

export type CoursesControllerGetCurriculumLocale = typeof CoursesControllerGetCurriculumLocale[keyof typeof CoursesControllerGetCurriculumLocale];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CoursesControllerGetCurriculumLocale = {
  en: 'en',
  'es-419': 'es-419',
} as const;

export type CoursesControllerGetLessonForCourseParams = {
/**
 * Content locale (title, subtitle, content). Defaults to "en".
 */
locale?: CoursesControllerGetLessonForCourseLocale;
};

export type CoursesControllerGetLessonForCourseLocale = typeof CoursesControllerGetLessonForCourseLocale[keyof typeof CoursesControllerGetLessonForCourseLocale];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CoursesControllerGetLessonForCourseLocale = {
  en: 'en',
  'es-419': 'es-419',
} as const;

export type CoursesControllerGetQuizForCourseParams = {
/**
 * Content locale (title, subtitle, content). Defaults to "en".
 */
locale?: CoursesControllerGetQuizForCourseLocale;
};

export type CoursesControllerGetQuizForCourseLocale = typeof CoursesControllerGetQuizForCourseLocale[keyof typeof CoursesControllerGetQuizForCourseLocale];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CoursesControllerGetQuizForCourseLocale = {
  en: 'en',
  'es-419': 'es-419',
} as const;

export type PlaylistsControllerListPlaylistsParams = {
/**
 * Page number (1-based)
 * @minimum 1
 */
page?: number;
/**
 * Page size
 * @minimum 1
 * @maximum 200
 */
pageSize?: number;
/**
 * Sort field
 */
sortField?: string;
/**
 * Sort direction
 */
sortDirection?: PlaylistsControllerListPlaylistsSortDirection;
/**
 * Filters object with operator (AND/OR) and conditions. Example: {"operator":"and","conditions":[{"field":"title","value":"Safety","operator":"co"}]}
 */
filters?: PlaylistFiltersDto;
};

export type PlaylistsControllerListPlaylistsSortDirection = typeof PlaylistsControllerListPlaylistsSortDirection[keyof typeof PlaylistsControllerListPlaylistsSortDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlaylistsControllerListPlaylistsSortDirection = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type PlaylistsControllerListEnrollmentsParams = {
/**
 * Page number
 * @minimum 0
 */
page?: number;
/**
 * Items per page
 * @minimum 1
 * @maximum 200
 */
pageSize?: number;
/**
 * Field to sort by (server-side). User columns: firstname, lastname, email, etc. Special: enrolled, progress (playlist completion — uses group_progress_entries / shell CE, not up_users.progress).
 */
sortBy?: string;
/**
 * Sort direction: asc or desc
 */
sortDirection?: string;
/**
 * Filter by first name (contains)
 */
firstname?: string;
/**
 * Filter by last name (contains)
 */
lastname?: string;
/**
 * Filter by email (contains)
 */
email?: string;
/**
 * Filter by job title (contains)
 */
jobTitle?: string;
/**
 * Filter by job category (contains)
 */
jobCategory?: string;
/**
 * Filter by division (contains)
 */
division?: string;
/**
 * Filter by custom field 1 (contains)
 */
customFieldValue1?: string;
/**
 * Filter by custom field 2 (contains)
 */
customFieldValue2?: string;
/**
 * Filter by custom field 3 (contains)
 */
customFieldValue3?: string;
/**
 * Filter by employee code (contains)
 */
employeeCode?: string;
/**
 * Filter by enrollment status: true=enrolled, false=not enrolled
 */
enrolled?: boolean;
};

export type QuizzesControllerListParams = {
/**
 * Page number
 * @minimum 1
 */
page?: number;
/**
 * Items per page
 * @minimum 1
 * @maximum 200
 */
pageSize?: number;
/**
 * Search term for title (case-insensitive)
 */
searchTerm?: string;
/**
 * Sort field
 */
orderBy?: QuizzesControllerListOrderBy;
/**
 * Sort direction
 */
orderDirection?: QuizzesControllerListOrderDirection;
/**
 * Include quizzes from extended access cohorts
 */
extendedAccess?: boolean;
/**
 * Filter by publish date on `published_at` (UTC calendar day for value-based operators). Matches MUI date filter operators.
 */
publishedAtOperator?: QuizzesControllerListPublishedAtOperator;
/**
 * Date in YYYY-MM-DD (required when publishedAtOperator is a value-based operator; ignored for isEmpty / isNotEmpty)
 */
publishedAtValue?: string;
};

export type QuizzesControllerListOrderBy = typeof QuizzesControllerListOrderBy[keyof typeof QuizzesControllerListOrderBy];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuizzesControllerListOrderBy = {
  title: 'title',
  updatedAt: 'updatedAt',
} as const;

export type QuizzesControllerListOrderDirection = typeof QuizzesControllerListOrderDirection[keyof typeof QuizzesControllerListOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuizzesControllerListOrderDirection = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type QuizzesControllerListPublishedAtOperator = typeof QuizzesControllerListPublishedAtOperator[keyof typeof QuizzesControllerListPublishedAtOperator];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuizzesControllerListPublishedAtOperator = {
  is: 'is',
  not: 'not',
  after: 'after',
  onOrAfter: 'onOrAfter',
  before: 'before',
  onOrBefore: 'onOrBefore',
  isEmpty: 'isEmpty',
  isNotEmpty: 'isNotEmpty',
} as const;

export type QuizzesControllerDeleteParams = {
hard: string;
};

export type LessonsControllerListParams = {
/**
 * Page number
 * @minimum 1
 */
page?: number;
/**
 * Items per page
 * @minimum 1
 * @maximum 200
 */
pageSize?: number;
/**
 * Filters object with operator (AND/OR) and conditions.
 */
filters?: LessonFiltersDto;
/**
 * Sort field
 */
orderBy?: LessonsControllerListOrderBy;
/**
 * Sort direction
 */
orderDirection?: LessonsControllerListOrderDirection;
/**
 * Include lessons from extended access cohorts
 */
extendedAccess?: boolean;
};

export type LessonsControllerListOrderBy = typeof LessonsControllerListOrderBy[keyof typeof LessonsControllerListOrderBy];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LessonsControllerListOrderBy = {
  title: 'title',
  updatedAt: 'updatedAt',
  publishedAt: 'publishedAt',
  videoDuration: 'videoDuration',
} as const;

export type LessonsControllerListOrderDirection = typeof LessonsControllerListOrderDirection[keyof typeof LessonsControllerListOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LessonsControllerListOrderDirection = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type LessonsControllerSearchParams = {
/**
 * Search term for title (case-insensitive)
 */
searchTerm?: string;
/**
 * Include lessons from extended access cohorts
 */
extendedAccess?: boolean;
/**
 * Page (1-indexed)
 */
page?: number;
/**
 * Page size
 * @minimum 1
 * @maximum 200
 */
pageSize?: number;
/**
 * Sort field
 */
orderBy?: LessonsControllerSearchOrderBy;
/**
 * Sort direction
 */
order?: LessonsControllerSearchOrder;
/**
 * JSON filter model: { operator: "and"|"or", conditions: [{ attribute, operator, value }] }. Attribute "languages" is mapped to "locale".
 */
filters?: string;
};

export type LessonsControllerSearchOrderBy = typeof LessonsControllerSearchOrderBy[keyof typeof LessonsControllerSearchOrderBy];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LessonsControllerSearchOrderBy = {
  title: 'title',
  updatedAt: 'updatedAt',
  publishedAt: 'publishedAt',
  videoDuration: 'videoDuration',
} as const;

export type LessonsControllerSearchOrder = typeof LessonsControllerSearchOrder[keyof typeof LessonsControllerSearchOrder];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LessonsControllerSearchOrder = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type LessonsControllerUploadFileBody = {
  /** File to upload */
  file?: Blob;
};

export type LessonsControllerDeleteParams = {
hard: string;
};

export type UserControllerGetFeedParams = {
/**
 * Start date (e.g. today)
 */
startDate: string;
/**
 * Timezone
 */
timezone: string;
/**
 * Content locale (title, subtitle, content). Defaults to "en".
 */
locale?: UserControllerGetFeedLocale;
};

export type UserControllerGetFeedLocale = typeof UserControllerGetFeedLocale[keyof typeof UserControllerGetFeedLocale];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserControllerGetFeedLocale = {
  en: 'en',
  'es-419': 'es-419',
} as const;

export type UserControllerGetScheduledLessonsParams = {
startDate: string;
/**
 * Inclusive end day in timezone.
 */
endDate: string;
timezone: string;
locale?: UserControllerGetScheduledLessonsLocale;
};

export type UserControllerGetScheduledLessonsLocale = typeof UserControllerGetScheduledLessonsLocale[keyof typeof UserControllerGetScheduledLessonsLocale];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserControllerGetScheduledLessonsLocale = {
  en: 'en',
  'es-419': 'es-419',
} as const;

export type UserControllerGetUpcomingLessonsParams = {
/**
 * Calendar day for the request (context / legacy). Scheduled dues in the pool use `dueFromDay` when set, otherwise this day’s start in `timezone`.
 */
startDate: string;
/**
 * Lower bound for **scheduled** lessons: include incomplete lessons with no due date, or `due_date` on/after the start of this calendar day in `timezone`. Omit to use `startDate`. The aggregated feed passes the **next** calendar day after the feed day so same-day dues stay in the scheduled query only.
 */
dueFromDay?: string;
/**
 * Timezone
 */
timezone: string;
/**
 * Max number of items to return; when omitted, cohort daily limit is used
 */
limit?: number;
/**
 * Content locale (title, subtitle, content). Defaults to "en".
 */
locale?: UserControllerGetUpcomingLessonsLocale;
};

export type UserControllerGetUpcomingLessonsLocale = typeof UserControllerGetUpcomingLessonsLocale[keyof typeof UserControllerGetUpcomingLessonsLocale];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserControllerGetUpcomingLessonsLocale = {
  en: 'en',
  'es-419': 'es-419',
} as const;

export type UserControllerGetEnrolledCoursesParams = {
/**
 * Include completed enrollments
 */
includeCompleted?: boolean;
/**
 * Include soft deleted enrollments
 */
includeSoftDeleted?: boolean;
/**
 * Content locale (title, description). Defaults to "en".
 */
locale?: UserControllerGetEnrolledCoursesLocale;
};

export type UserControllerGetEnrolledCoursesLocale = typeof UserControllerGetEnrolledCoursesLocale[keyof typeof UserControllerGetEnrolledCoursesLocale];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserControllerGetEnrolledCoursesLocale = {
  en: 'en',
  'es-419': 'es-419',
} as const;

export type UserControllerGetOverdueLessonsParams = {
/**
 * Reference date for overdue calculation
 */
date: string;
/**
 * Timezone for date calculations
 */
timezone?: string;
/**
 * Content locale (title, subtitle, content). Defaults to "en".
 */
locale?: UserControllerGetOverdueLessonsLocale;
/**
 * `overdue` (default): incomplete lessons with due date before the calendar day. `due_today`: incomplete, unlocked lessons due on that calendar day (start of day inclusive, next day exclusive, in timezone).
 */
window?: UserControllerGetOverdueLessonsWindow;
};

export type UserControllerGetOverdueLessonsLocale = typeof UserControllerGetOverdueLessonsLocale[keyof typeof UserControllerGetOverdueLessonsLocale];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserControllerGetOverdueLessonsLocale = {
  en: 'en',
  'es-419': 'es-419',
} as const;

export type UserControllerGetOverdueLessonsWindow = typeof UserControllerGetOverdueLessonsWindow[keyof typeof UserControllerGetOverdueLessonsWindow];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserControllerGetOverdueLessonsWindow = {
  overdue: 'overdue',
  due_today: 'due_today',
} as const;

export type UserControllerGetRecentActivityParams = {
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 * @maximum 200
 */
pageSize?: number;
/**
 * Content locale (lesson and course titles). Defaults to "en".
 */
locale?: UserControllerGetRecentActivityLocale;
};

export type UserControllerGetRecentActivityLocale = typeof UserControllerGetRecentActivityLocale[keyof typeof UserControllerGetRecentActivityLocale];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserControllerGetRecentActivityLocale = {
  en: 'en',
  'es-419': 'es-419',
} as const;

export type UserControllerGetActiveCoursesParams = {
/**
 * Content locale (title, description). Defaults to "en".
 */
locale?: UserControllerGetActiveCoursesLocale;
};

export type UserControllerGetActiveCoursesLocale = typeof UserControllerGetActiveCoursesLocale[keyof typeof UserControllerGetActiveCoursesLocale];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserControllerGetActiveCoursesLocale = {
  en: 'en',
  'es-419': 'es-419',
} as const;

export type UserControllerGetFinishedCoursesParams = {
/**
 * Content locale (title, description). Defaults to "en".
 */
locale?: UserControllerGetFinishedCoursesLocale;
};

export type UserControllerGetFinishedCoursesLocale = typeof UserControllerGetFinishedCoursesLocale[keyof typeof UserControllerGetFinishedCoursesLocale];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserControllerGetFinishedCoursesLocale = {
  en: 'en',
  'es-419': 'es-419',
} as const;

export type UserControllerGetNotificationsParams = {
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 */
pageSize?: number;
};

export type UserControllerGetAnnouncementsAssignedParams = {
/**
 * IANA timezone string (e.g. America/New_York)
 */
timezone?: string;
};

export type UserControllerGetAnnouncementsNotificationsParams = {
page?: number;
pageSize?: number;
};

export type UsersControllerListParams = {
/**
 * Page number (1-based)
 * @minimum 1
 */
page?: number;
/**
 * Items per page
 * @minimum 1
 * @maximum 200
 */
pageSize?: number;
/**
 * Sort field
 */
sortBy?: UsersControllerListSortBy;
/**
 * Sort direction
 */
sortDirection?: UsersControllerListSortDirection;
/**
 * Filters object with operator (AND/OR) and conditions. Example: {"operator":"AND","conditions":[{"field":"firstname","value":"John","operator":"co"}]}
 */
filters?: UserFiltersDto;
/**
 * Include archived users when true
 */
includeArchived?: boolean;
};

export type UsersControllerListSortBy = typeof UsersControllerListSortBy[keyof typeof UsersControllerListSortBy];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UsersControllerListSortBy = {
  firstname: 'firstname',
  lastname: 'lastname',
  email: 'email',
  employeeCode: 'employeeCode',
  jobTitle: 'jobTitle',
  jobCategory: 'jobCategory',
  division: 'division',
  supervisorName: 'supervisorName',
  hireDate: 'hireDate',
  titleStartDate: 'titleStartDate',
  createdAt: 'createdAt',
  streak: 'streak',
  overdue: 'overdue',
  completedModules: 'completedModules',
  timeSpentOnTraining: 'timeSpentOnTraining',
  customFieldValue1: 'customFieldValue1',
  customFieldValue2: 'customFieldValue2',
  customFieldValue3: 'customFieldValue3',
} as const;

export type UsersControllerListSortDirection = typeof UsersControllerListSortDirection[keyof typeof UsersControllerListSortDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UsersControllerListSortDirection = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type UsersControllerGetFeedParams = {
/**
 * Timezone for date calculations
 */
timezone?: string;
};

export type UsersControllerGetOverdueLessonsParams = {
/**
 * Reference date for overdue calculation
 */
date: string;
/**
 * Timezone for date calculations
 */
timezone?: string;
};

export type UsersControllerGetRecentActivityParams = {
/**
 * Page number (1-indexed)
 */
page?: number;
/**
 * Page size
 * @minimum 1
 * @maximum 200
 */
pageSize?: number;
};

export type CohortsControllerListParams = {
/**
 * Page number
 * @minimum 1
 */
page?: number;
/**
 * Items per page
 * @minimum 1
 * @maximum 200
 */
pageSize?: number;
/**
 * Search term for title
 */
search?: string;
/**
 * Order direction
 */
orderDirection?: CohortsControllerListOrderDirection;
};

export type CohortsControllerListOrderDirection = typeof CohortsControllerListOrderDirection[keyof typeof CohortsControllerListOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CohortsControllerListOrderDirection = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type TeamProgressControllerGetTilesParams = {
/**
 * Include archived users
 */
archivedUsers?: boolean;
/**
 * Start date (YYYY-MM-DD)
 */
dateFrom: string;
/**
 * End date (YYYY-MM-DD)
 */
dateTo: string;
};

export type TeamProgressControllerGetCompletedLessonsParams = {
/**
 * Include archived users
 */
archivedUsers?: boolean;
/**
 * Start date (YYYY-MM-DD)
 */
dateFrom: string;
/**
 * End date (YYYY-MM-DD)
 */
dateTo: string;
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 * @maximum 200
 */
pageSize?: number;
order?: TeamProgressControllerGetCompletedLessonsOrder;
orderBy?: string;
/**
 * JSON filter string
 */
filters?: string;
};

export type TeamProgressControllerGetCompletedLessonsOrder = typeof TeamProgressControllerGetCompletedLessonsOrder[keyof typeof TeamProgressControllerGetCompletedLessonsOrder];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TeamProgressControllerGetCompletedLessonsOrder = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type TeamProgressControllerGetChartParams = {
/**
 * Include archived users
 */
archivedUsers?: boolean;
/**
 * Start date (YYYY-MM-DD)
 */
dateFrom: string;
/**
 * End date (YYYY-MM-DD)
 */
dateTo: string;
};

export type TeamProgressControllerGetCompletedCoursesParams = {
/**
 * Include archived users
 */
archivedUsers?: boolean;
/**
 * Start date (YYYY-MM-DD)
 */
dateFrom: string;
/**
 * End date (YYYY-MM-DD)
 */
dateTo: string;
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 * @maximum 200
 */
pageSize?: number;
order?: TeamProgressControllerGetCompletedCoursesOrder;
orderBy?: string;
/**
 * JSON filter string
 */
filters?: string;
};

export type TeamProgressControllerGetCompletedCoursesOrder = typeof TeamProgressControllerGetCompletedCoursesOrder[keyof typeof TeamProgressControllerGetCompletedCoursesOrder];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TeamProgressControllerGetCompletedCoursesOrder = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type TeamProgressControllerGetActiveUsersParams = {
/**
 * Include archived users
 */
archivedUsers?: boolean;
/**
 * Start date (YYYY-MM-DD)
 */
dateFrom: string;
/**
 * End date (YYYY-MM-DD)
 */
dateTo: string;
/**
 * Page number (1-indexed)
 */
page?: number;
/**
 * Items per page
 * @minimum 1
 * @maximum 200
 */
pageSize?: number;
/**
 * Sort order
 */
order?: TeamProgressControllerGetActiveUsersOrder;
/**
 * Column to sort by
 */
orderBy?: string;
/**
 * JSON filter object
 */
filters?: string;
};

export type TeamProgressControllerGetActiveUsersOrder = typeof TeamProgressControllerGetActiveUsersOrder[keyof typeof TeamProgressControllerGetActiveUsersOrder];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TeamProgressControllerGetActiveUsersOrder = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type TeamProgressControllerGetInactiveUsersParams = {
/**
 * Include archived users
 */
archivedUsers?: boolean;
/**
 * Start date (YYYY-MM-DD)
 */
dateFrom: string;
/**
 * End date (YYYY-MM-DD)
 */
dateTo: string;
/**
 * Page number (1-indexed)
 */
page?: number;
/**
 * Items per page
 * @minimum 1
 * @maximum 200
 */
pageSize?: number;
/**
 * Sort order
 */
order?: TeamProgressControllerGetInactiveUsersOrder;
/**
 * Column to sort by
 */
orderBy?: string;
/**
 * JSON filter object
 */
filters?: string;
};

export type TeamProgressControllerGetInactiveUsersOrder = typeof TeamProgressControllerGetInactiveUsersOrder[keyof typeof TeamProgressControllerGetInactiveUsersOrder];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TeamProgressControllerGetInactiveUsersOrder = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type TeamProgressControllerGetTimeInTrainingParams = {
/**
 * Include archived users
 */
archivedUsers?: boolean;
/**
 * Start date (YYYY-MM-DD)
 */
dateFrom: string;
/**
 * End date (YYYY-MM-DD)
 */
dateTo: string;
/**
 * Page number (1-indexed)
 */
page?: number;
/**
 * Items per page
 * @minimum 1
 * @maximum 200
 */
pageSize?: number;
/**
 * Sort order
 */
order?: TeamProgressControllerGetTimeInTrainingOrder;
/**
 * Column to sort by
 */
orderBy?: string;
/**
 * JSON filter object
 */
filters?: string;
};

export type TeamProgressControllerGetTimeInTrainingOrder = typeof TeamProgressControllerGetTimeInTrainingOrder[keyof typeof TeamProgressControllerGetTimeInTrainingOrder];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TeamProgressControllerGetTimeInTrainingOrder = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type TeamProgressControllerGetOverdueLessonsParams = {
/**
 * Include archived users
 */
archivedUsers?: boolean;
/**
 * Start date (YYYY-MM-DD)
 */
dateFrom: string;
/**
 * End date (YYYY-MM-DD)
 */
dateTo: string;
/**
 * Page number (1-indexed)
 */
page?: number;
/**
 * Items per page
 * @minimum 1
 * @maximum 200
 */
pageSize?: number;
/**
 * Sort order
 */
order?: TeamProgressControllerGetOverdueLessonsOrder;
/**
 * Column to sort by
 */
orderBy?: string;
/**
 * JSON filter object
 */
filters?: string;
};

export type TeamProgressControllerGetOverdueLessonsOrder = typeof TeamProgressControllerGetOverdueLessonsOrder[keyof typeof TeamProgressControllerGetOverdueLessonsOrder];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TeamProgressControllerGetOverdueLessonsOrder = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type LessonEnrollmentsControllerGetInlineQuizQuestionsParams = {
/**
 * Content locale (question text, options). Defaults to "en".
 */
locale?: LessonEnrollmentsControllerGetInlineQuizQuestionsLocale;
};

export type LessonEnrollmentsControllerGetInlineQuizQuestionsLocale = typeof LessonEnrollmentsControllerGetInlineQuizQuestionsLocale[keyof typeof LessonEnrollmentsControllerGetInlineQuizQuestionsLocale];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LessonEnrollmentsControllerGetInlineQuizQuestionsLocale = {
  en: 'en',
  'es-419': 'es-419',
} as const;

export type NotesControllerSearchNotesParams = {
/**
 * Lesson enrollment ID (from lesson page)
 */
lessonEnrollmentId?: number;
/**
 * Search term to filter notes
 */
searchTerm?: string;
/**
 * Filter by course slug (fallback when lessonEnrollmentId not provided)
 */
courseSlug?: string;
/**
 * Course category on the linked course (Job Training, Safety, …) or module kind filter for target_type (lesson, quiz, survey).
 */
contentType?: NotesControllerSearchNotesContentType;
/**
 * Filter by module slug within course
 */
moduleSlug?: string;
};

export type NotesControllerSearchNotesContentType = typeof NotesControllerSearchNotesContentType[keyof typeof NotesControllerSearchNotesContentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NotesControllerSearchNotesContentType = {
  Job_Training: 'Job Training',
  Personal_Development: 'Personal Development',
  Professional_Development: 'Professional Development',
  Safety: 'Safety',
  lesson: 'lesson',
  quiz: 'quiz',
  survey: 'survey',
} as const;

export type CommentsControllerSearchCommentsParams = {
/**
 * Lesson enrollment ID (from lesson page)
 */
lessonEnrollmentId: number;
/**
 * Page number (1-based)
 */
page?: number;
/**
 * Page size
 */
pageSize?: number;
/**
 * Parent comment ID for replies
 */
parentId?: number;
};

export type BlobControllerGetBlobParams = {
/**
 * Azure container name
 */
containerName: string;
/**
 * Blob file name
 */
blobName: string;
/**
 * MIME type (default: application/octet-stream)
 */
mimeType?: string;
};

export type ScheduledReportsControllerGetOverviewParams = {
dateStart: string;
dateEnd: string;
};

export type ScheduledReportsControllerGetTopPerformersParams = {
dateStart: string;
dateEnd: string;
};

export type ScheduledReportsControllerGetUsersWithoutCompletionsParams = {
dateStart: string;
dateEnd: string;
page: string;
pageSize: string;
};

export type ScheduledReportsControllerGetDivisionsParams = {
dateStart: string;
dateEnd: string;
page: string;
pageSize: string;
};

export type ScheduledReportsControllerGetSupervisorsParams = {
dateStart: string;
dateEnd: string;
page: string;
pageSize: string;
};

export type AnnouncementsControllerGetListParams = {
page?: number;
/**
 * @minimum 1
 * @maximum 200
 */
pageSize?: number;
/**
 * Sort field (author, admin display status: _status or adminDisplayStatus, or scalar columns)
 */
orderBy?: AnnouncementsControllerGetListOrderBy;
/**
 * Sort direction
 */
order?: AnnouncementsControllerGetListOrder;
/**
 * Search in title
 */
searchTerm?: string;
/**
 * Substring match on author display name or username
 */
authorSearch?: string;
/**
 * Match mode for authorSearch (default contains). Use startsWith / endsWith for prefix/suffix.
 */
authorSearchMode?: AnnouncementsControllerGetListAuthorSearchMode;
/**
 * Filter by admin display status (same buckets as manager UI)
 */
displayStatus?: AnnouncementsControllerGetListDisplayStatus;
/**
 * Exclude rows in this admin display status bucket (e.g. “is not Live” in the grid)
 */
displayStatusNot?: AnnouncementsControllerGetListDisplayStatusNot;
/**
 * Effective delivery datetime lower bound (ISO 8601)
 */
deliveryDateFrom?: string;
/**
 * Effective delivery datetime upper bound (ISO 8601)
 */
deliveryDateTo?: string;
/**
 * Read distribution percent (0–100), inclusive lower bound
 */
readPercentMin?: number;
/**
 * Read distribution percent (0–100), inclusive upper bound
 */
readPercentMax?: number;
/**
 * Title column: only null/blank vs non-blank (title field only)
 */
titlePresence?: AnnouncementsControllerGetListTitlePresence;
/**
 * Author column: no author link vs at least one
 */
authorPresence?: AnnouncementsControllerGetListAuthorPresence;
/**
 * Delivery column: no scheduled/publish time vs at least one (effective date)
 */
deliveryPresence?: AnnouncementsControllerGetListDeliveryPresence;
/**
 * Read % column: no audience enrollments vs at least one
 */
readPresence?: AnnouncementsControllerGetListReadPresence;
};

export type AnnouncementsControllerGetListOrderBy = typeof AnnouncementsControllerGetListOrderBy[keyof typeof AnnouncementsControllerGetListOrderBy];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnnouncementsControllerGetListOrderBy = {
  id: 'id',
  title: 'title',
  slug: 'slug',
  publishedAt: 'publishedAt',
  scheduledDeliveryDate: 'scheduledDeliveryDate',
  delivered: 'delivered',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  audienceType: 'audienceType',
  deliveryType: 'deliveryType',
  author: 'author',
  _status: '_status',
  adminDisplayStatus: 'adminDisplayStatus',
  _read: '_read',
  readDistribution: 'readDistribution',
  published_at: 'published_at',
  scheduled_delivery_date: 'scheduled_delivery_date',
  created_at: 'created_at',
  updated_at: 'updated_at',
} as const;

export type AnnouncementsControllerGetListOrder = typeof AnnouncementsControllerGetListOrder[keyof typeof AnnouncementsControllerGetListOrder];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnnouncementsControllerGetListOrder = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type AnnouncementsControllerGetListAuthorSearchMode = typeof AnnouncementsControllerGetListAuthorSearchMode[keyof typeof AnnouncementsControllerGetListAuthorSearchMode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnnouncementsControllerGetListAuthorSearchMode = {
  contains: 'contains',
  startsWith: 'startsWith',
  endsWith: 'endsWith',
} as const;

export type AnnouncementsControllerGetListDisplayStatus = typeof AnnouncementsControllerGetListDisplayStatus[keyof typeof AnnouncementsControllerGetListDisplayStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnnouncementsControllerGetListDisplayStatus = {
  inactive: 'inactive',
  draft: 'draft',
  scheduled: 'scheduled',
  processing: 'processing',
  live: 'live',
} as const;

export type AnnouncementsControllerGetListDisplayStatusNot = typeof AnnouncementsControllerGetListDisplayStatusNot[keyof typeof AnnouncementsControllerGetListDisplayStatusNot];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnnouncementsControllerGetListDisplayStatusNot = {
  inactive: 'inactive',
  draft: 'draft',
  scheduled: 'scheduled',
  processing: 'processing',
  live: 'live',
} as const;

export type AnnouncementsControllerGetListTitlePresence = typeof AnnouncementsControllerGetListTitlePresence[keyof typeof AnnouncementsControllerGetListTitlePresence];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnnouncementsControllerGetListTitlePresence = {
  empty: 'empty',
  notEmpty: 'notEmpty',
} as const;

export type AnnouncementsControllerGetListAuthorPresence = typeof AnnouncementsControllerGetListAuthorPresence[keyof typeof AnnouncementsControllerGetListAuthorPresence];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnnouncementsControllerGetListAuthorPresence = {
  empty: 'empty',
  notEmpty: 'notEmpty',
} as const;

export type AnnouncementsControllerGetListDeliveryPresence = typeof AnnouncementsControllerGetListDeliveryPresence[keyof typeof AnnouncementsControllerGetListDeliveryPresence];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnnouncementsControllerGetListDeliveryPresence = {
  empty: 'empty',
  notEmpty: 'notEmpty',
} as const;

export type AnnouncementsControllerGetListReadPresence = typeof AnnouncementsControllerGetListReadPresence[keyof typeof AnnouncementsControllerGetListReadPresence];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnnouncementsControllerGetListReadPresence = {
  empty: 'empty',
  notEmpty: 'notEmpty',
} as const;

export type AnnouncementsControllerCreate201 = {
  id: number;
};

export type AnnouncementsControllerGetEnrollmentsParams = {
/**
 * When true, only completed enrollments; when false, only incomplete; when omitted, all enrollments
 */
complete?: boolean;
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 * @maximum 200
 */
pageSize?: number;
order?: AnnouncementsControllerGetEnrollmentsOrder;
/**
 * Sort field: id = learner enrollment row id (previous default ordering)
 */
orderBy?: AnnouncementsControllerGetEnrollmentsOrderBy;
sortBy?: AnnouncementsControllerGetEnrollmentsSortBy;
sortDirection?: AnnouncementsControllerGetEnrollmentsSortDirection;
/**
 * Filter: job title contains this substring (case-insensitive)
 */
jobTitle?: string;
/**
 * Filter: first name contains this substring (case-insensitive)
 */
firstname?: string;
/**
 * Filter: last name contains this substring (case-insensitive)
 */
lastname?: string;
/**
 * Filter: email contains this substring (case-insensitive)
 */
email?: string;
/**
 * Filter: announcement published_at from (ISO 8601), inclusive
 */
publishedAtFrom?: string;
/**
 * Filter: announcement published_at through (ISO 8601), inclusive
 */
publishedAtTo?: string;
/**
 * Filter: enrollment completed_at from (ISO 8601), inclusive
 */
completedAtFrom?: string;
/**
 * Filter: enrollment completed_at through (ISO 8601), inclusive
 */
completedAtTo?: string;
};

export type AnnouncementsControllerGetEnrollmentsOrder = typeof AnnouncementsControllerGetEnrollmentsOrder[keyof typeof AnnouncementsControllerGetEnrollmentsOrder];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnnouncementsControllerGetEnrollmentsOrder = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type AnnouncementsControllerGetEnrollmentsOrderBy = typeof AnnouncementsControllerGetEnrollmentsOrderBy[keyof typeof AnnouncementsControllerGetEnrollmentsOrderBy];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnnouncementsControllerGetEnrollmentsOrderBy = {
  id: 'id',
  jobTitle: 'jobTitle',
  publishedAt: 'publishedAt',
  completedAt: 'completedAt',
  firstname: 'firstname',
  lastname: 'lastname',
  email: 'email',
  userId: 'userId',
} as const;

export type AnnouncementsControllerGetEnrollmentsSortBy = typeof AnnouncementsControllerGetEnrollmentsSortBy[keyof typeof AnnouncementsControllerGetEnrollmentsSortBy];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnnouncementsControllerGetEnrollmentsSortBy = {
  id: 'id',
  jobTitle: 'jobTitle',
  publishedAt: 'publishedAt',
  completedAt: 'completedAt',
  firstname: 'firstname',
  lastname: 'lastname',
  email: 'email',
  userId: 'userId',
} as const;

export type AnnouncementsControllerGetEnrollmentsSortDirection = typeof AnnouncementsControllerGetEnrollmentsSortDirection[keyof typeof AnnouncementsControllerGetEnrollmentsSortDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnnouncementsControllerGetEnrollmentsSortDirection = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type LeaderboardsReadInternalControllerGetUserLeaderboardParams = {
/**
 * Cohort scope for the leaderboard period (defaults to the authenticated admin’s cohort)
 */
cohortId?: number;
};

export type LeaderboardsReadInternalControllerListCohortLeaderboardParams = {
/**
 * Page number (1-based)
 * @minimum 1
 */
page?: number;
/**
 * Items per page
 * @minimum 1
 * @maximum 200
 */
pageSize?: number;
/**
 * When either `dateFrom` or `dateTo` is set, ranks are computed from `user_award_events` in that range; all active cohort members are included (zeros for users with no awards in range). YYYY-MM-DD (UTC day boundaries).
 */
dateFrom?: string;
/**
 * Inclusive end date (UTC end of day). See `dateFrom`.
 */
dateTo?: string;
};

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getImproveAPI = () => {
/**
 * @summary Identity webhook receiver
 */
const identityWebhooksControllerWebhook = (
    
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/identity-webhook`, method: 'POST'
    },
      options);
    }
  
/**
 * Returns course and ordered module list. Used by Content Controller RXD viewer. Supply ?locale=es-419 to receive Spanish content.
 * @summary Get course curriculum (public)
 */
const rxdControllerGetCourseCurriculum = (
    slug: string,
    params?: RxdControllerGetCourseCurriculumParams,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/rxd/courses/${slug}/curriculum`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Create a new course
 */
const coursesControllerCreate = (
    coursesControllerCreateBody: CoursesControllerCreateBodyOne | CoursesControllerCreateBodyTwo,
 options?: SecondParameter<typeof customInstance<CreateCourseResponse>>,) => {
      return customInstance<CreateCourseResponse>(
      {url: `/api/_internal/courses`, method: 'POST',
      data: coursesControllerCreateBody
    },
      options);
    }
  
/**
 * @summary List courses with pagination
 */
const coursesControllerList = (
    params?: CoursesControllerListParams,
 options?: SecondParameter<typeof customInstance<ListCoursesResponse>>,) => {
      return customInstance<ListCoursesResponse>(
      {url: `/api/_internal/courses`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Search courses
 */
const coursesControllerSearch = (
    params?: CoursesControllerSearchParams,
 options?: SecondParameter<typeof customInstance<SearchCoursesResponse>>,) => {
      return customInstance<SearchCoursesResponse>(
      {url: `/api/_internal/courses/search`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Get course curriculum items
 */
const coursesControllerGetCurriculumItems = (
    courseId: number,
 options?: SecondParameter<typeof customInstance<GetCurriculumItemsResponse>>,) => {
      return customInstance<GetCurriculumItemsResponse>(
      {url: `/api/_internal/courses/${courseId}/curriculum-items`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Get course curriculum modules
 */
const coursesControllerGetCourseModules = (
    courseId: number,
 options?: SecondParameter<typeof customInstance<GetCourseModulesResponse>>,) => {
      return customInstance<GetCourseModulesResponse>(
      {url: `/api/_internal/courses/${courseId}/modules`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary List course lessons
 */
const coursesControllerListLessons = (
    courseId: number,
    params?: CoursesControllerListLessonsParams,
 options?: SecondParameter<typeof customInstance<ListCourseLessonsResponse>>,) => {
      return customInstance<ListCourseLessonsResponse>(
      {url: `/api/_internal/courses/${courseId}/lessons`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary List course quizzes
 */
const coursesControllerListQuizzes = (
    courseId: number,
    params?: CoursesControllerListQuizzesParams,
 options?: SecondParameter<typeof customInstance<ListCourseQuizzesResponse>>,) => {
      return customInstance<ListCourseQuizzesResponse>(
      {url: `/api/_internal/courses/${courseId}/quizzes`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary List course enrollments for cohort
 */
const coursesControllerListEnrollments = (
    courseId: number,
    cohortId: number,
    params?: CoursesControllerListEnrollmentsParams,
 options?: SecondParameter<typeof customInstance<ListCourseEnrollmentsResponse>>,) => {
      return customInstance<ListCourseEnrollmentsResponse>(
      {url: `/api/_internal/courses/${courseId}/cohort/${cohortId}/enrollments`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Get course by ID
 */
const coursesControllerGetById = (
    id: number,
 options?: SecondParameter<typeof customInstance<CourseResponse>>,) => {
      return customInstance<CourseResponse>(
      {url: `/api/_internal/courses/${id}`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Update a course
 */
const coursesControllerUpdate = (
    id: number,
    coursesControllerUpdateBody: CoursesControllerUpdateBodyOne | CoursesControllerUpdateBodyTwo,
 options?: SecondParameter<typeof customInstance<CourseResponse>>,) => {
      return customInstance<CourseResponse>(
      {url: `/api/_internal/courses/${id}`, method: 'PUT',
      data: coursesControllerUpdateBody
    },
      options);
    }
  
/**
 * @summary Delete a course
 */
const coursesControllerDelete = (
    id: number,
    params: CoursesControllerDeleteParams,
 options?: SecondParameter<typeof customInstance<DeleteCourseResponse>>,) => {
      return customInstance<DeleteCourseResponse>(
      {url: `/api/_internal/courses/${id}`, method: 'DELETE',
        params
    },
      options);
    }
  
/**
 * @summary Get course by slug
 */
const coursesControllerGetBySlug = (
    slug: string,
 options?: SecondParameter<typeof customInstance<CourseResponse>>,) => {
      return customInstance<CourseResponse>(
      {url: `/api/_internal/courses/slug/${slug}`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Get course details with enrollment
 */
const coursesControllerGetDetails = (
    slug: string,
    params?: CoursesControllerGetDetailsParams,
 options?: SecondParameter<typeof customInstance<GetCourseDetailsResponse>>,) => {
      return customInstance<GetCourseDetailsResponse>(
      {url: `/api/_internal/courses/${slug}/details`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Get course curriculum with progress
 */
const coursesControllerGetCurriculum = (
    slug: string,
    params?: CoursesControllerGetCurriculumParams,
 options?: SecondParameter<typeof customInstance<GetCourseCurriculumResponse>>,) => {
      return customInstance<GetCourseCurriculumResponse>(
      {url: `/api/_internal/courses/${slug}/curriculum`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Get lesson for course (with enrollment context)
 */
const coursesControllerGetLessonForCourse = (
    courseSlug: string,
    lessonSlug: string,
    params?: CoursesControllerGetLessonForCourseParams,
 options?: SecondParameter<typeof customInstance<GetLessonForCourseResponse>>,) => {
      return customInstance<GetLessonForCourseResponse>(
      {url: `/api/_internal/courses/${courseSlug}/lessons/${lessonSlug}`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Get quiz for course (with enrollment context)
 */
const coursesControllerGetQuizForCourse = (
    courseSlug: string,
    quizSlug: string,
    params?: CoursesControllerGetQuizForCourseParams,
 options?: SecondParameter<typeof customInstance<GetQuizForCourseResponse>>,) => {
      return customInstance<GetQuizForCourseResponse>(
      {url: `/api/_internal/courses/${courseSlug}/quizzes/${quizSlug}`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Toggle course blacklist for cohort
 */
const coursesControllerToggleBlacklist = (
    id: number,
    toggleCourseBlacklistRequest: ToggleCourseBlacklistRequest,
 options?: SecondParameter<typeof customInstance<ToggleCourseBlacklistResponse>>,) => {
      return customInstance<ToggleCourseBlacklistResponse>(
      {url: `/api/_internal/courses/${id}/blacklist`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: toggleCourseBlacklistRequest
    },
      options);
    }
  
/**
 * @summary Bulk enroll users in a course
 */
const courseEnrollmentsControllerBulkEnroll = (
    courseId: number,
    bulkEnrollBody: BulkEnrollBody,
 options?: SecondParameter<typeof customInstance<PostEnrollUsersInCourseResponse>>,) => {
      return customInstance<PostEnrollUsersInCourseResponse>(
      {url: `/api/_internal/courses/${courseId}/enrollments/bulk`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bulkEnrollBody
    },
      options);
    }
  
/**
 * @summary Bulk unenroll users from a course
 */
const courseEnrollmentsControllerBulkUnenroll = (
    courseId: number,
    bulkUnenrollBody: BulkUnenrollBody,
 options?: SecondParameter<typeof customInstance<PostUnenrollUsersInCourseResponse>>,) => {
      return customInstance<PostUnenrollUsersInCourseResponse>(
      {url: `/api/_internal/courses/${courseId}/enrollments/bulk`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: bulkUnenrollBody
    },
      options);
    }
  
/**
 * @summary Enroll cohort in course
 */
const courseEnrollmentsControllerEnrollCohort = (
    courseId: number,
    enrollCohortInCourseBody: EnrollCohortInCourseBody,
 options?: SecondParameter<typeof customInstance<EnrollCohortInCourseResponse>>,) => {
      return customInstance<EnrollCohortInCourseResponse>(
      {url: `/api/_internal/courses/${courseId}/enrollments/enroll-cohort`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: enrollCohortInCourseBody
    },
      options);
    }
  
/**
 * @summary Set, change, or clear course due dates for users
 */
const courseEnrollmentsControllerManageDueDates = (
    courseId: number,
    manageDueDatesBody: ManageDueDatesBody,
 options?: SecondParameter<typeof customInstance<PostEnrollUsersInCourseResponse>>,) => {
      return customInstance<PostEnrollUsersInCourseResponse>(
      {url: `/api/_internal/courses/${courseId}/enrollments/manage-due-dates`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: manageDueDatesBody
    },
      options);
    }
  
/**
 * @summary Bulk complete all lessons in a course for specified users (async)
 */
const courseEnrollmentsControllerBulkComplete = (
    courseId: number,
    bulkCompleteCourseBody: BulkCompleteCourseBody,
 options?: SecondParameter<typeof customInstance<BulkCompleteCourseResponse>>,) => {
      return customInstance<BulkCompleteCourseResponse>(
      {url: `/api/_internal/courses/${courseId}/enrollments/bulk-complete`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: bulkCompleteCourseBody
    },
      options);
    }
  
/**
 * @summary List playlists
 */
const playlistsControllerListPlaylists = (
    params?: PlaylistsControllerListPlaylistsParams,
 options?: SecondParameter<typeof customInstance<ListPlaylistsResponse>>,) => {
      return customInstance<ListPlaylistsResponse>(
      {url: `/api/_internal/playlists`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Create playlist
 */
const playlistsControllerCreatePlaylist = (
    createPlaylistBody: CreatePlaylistBody,
 options?: SecondParameter<typeof customInstance<CreatePlaylistResponse>>,) => {
      return customInstance<CreatePlaylistResponse>(
      {url: `/api/_internal/playlists`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createPlaylistBody
    },
      options);
    }
  
/**
 * @summary Get playlist details
 */
const playlistsControllerGetPlaylist = (
    playlistId: number,
 options?: SecondParameter<typeof customInstance<PlaylistDetailDto>>,) => {
      return customInstance<PlaylistDetailDto>(
      {url: `/api/_internal/playlists/${playlistId}`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Update playlist
 */
const playlistsControllerUpdatePlaylist = (
    playlistId: number,
    updatePlaylistBody: UpdatePlaylistBody,
 options?: SecondParameter<typeof customInstance<UpdatePlaylistResponse>>,) => {
      return customInstance<UpdatePlaylistResponse>(
      {url: `/api/_internal/playlists/${playlistId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updatePlaylistBody
    },
      options);
    }
  
/**
 * @summary Delete playlist
 */
const playlistsControllerDeletePlaylist = (
    playlistId: number,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/_internal/playlists/${playlistId}`, method: 'DELETE'
    },
      options);
    }
  
/**
 * @summary Get playlist certification
 */
const playlistsControllerGetPlaylistCertification = (
    playlistId: number,
 options?: SecondParameter<typeof customInstance<PlaylistCertificationDto>>,) => {
      return customInstance<PlaylistCertificationDto>(
      {url: `/api/_internal/playlists/${playlistId}/certification`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary List playlist enrollments for cohort
 */
const playlistsControllerListEnrollments = (
    playlistId: number,
    cohortId: number,
    params?: PlaylistsControllerListEnrollmentsParams,
 options?: SecondParameter<typeof customInstance<ListPlaylistEnrollmentsResponse>>,) => {
      return customInstance<ListPlaylistEnrollmentsResponse>(
      {url: `/api/_internal/playlists/${playlistId}/cohort/${cohortId}/enrollments`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Bulk enroll users in a playlist
 */
const playlistEnrollmentsControllerBulkEnroll = (
    playlistId: number,
    bulkEnrollPlaylistBody: BulkEnrollPlaylistBody,
 options?: SecondParameter<typeof customInstance<PostEnrollUsersInPlaylistInProgressResponse>>,) => {
      return customInstance<PostEnrollUsersInPlaylistInProgressResponse>(
      {url: `/api/_internal/playlists/${playlistId}/enrollments/bulk`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bulkEnrollPlaylistBody
    },
      options);
    }
  
/**
 * @summary Bulk unenroll users from a playlist
 */
const playlistEnrollmentsControllerBulkUnenroll = (
    playlistId: number,
    bulkUnenrollPlaylistBody: BulkUnenrollPlaylistBody,
 options?: SecondParameter<typeof customInstance<PostUnenrollUsersInPlaylistInProgressResponse>>,) => {
      return customInstance<PostUnenrollUsersInPlaylistInProgressResponse>(
      {url: `/api/_internal/playlists/${playlistId}/enrollments/bulk`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: bulkUnenrollPlaylistBody
    },
      options);
    }
  
/**
 * @summary Enroll cohort in playlist
 */
const playlistEnrollmentsControllerEnrollCohort = (
    playlistId: number,
    enrollCohortInPlaylistBody: EnrollCohortInPlaylistBody,
 options?: SecondParameter<typeof customInstance<EnrollCohortInPlaylistResponse>>,) => {
      return customInstance<EnrollCohortInPlaylistResponse>(
      {url: `/api/_internal/playlists/${playlistId}/enrollments/enroll-cohort`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: enrollCohortInPlaylistBody
    },
      options);
    }
  
/**
 * @summary Bulk complete all lessons in a playlist for specified users (async)
 */
const playlistEnrollmentsControllerBulkComplete = (
    playlistId: number,
    bulkCompletePlaylistBody: BulkCompletePlaylistBody,
 options?: SecondParameter<typeof customInstance<BulkCompletePlaylistResponse>>,) => {
      return customInstance<BulkCompletePlaylistResponse>(
      {url: `/api/_internal/playlists/${playlistId}/enrollments/bulk-complete`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: bulkCompletePlaylistBody
    },
      options);
    }
  
/**
 * @summary List quizzes (admin, cohort)
 */
const quizzesControllerList = (
    params?: QuizzesControllerListParams,
 options?: SecondParameter<typeof customInstance<ListQuizzesResponse>>,) => {
      return customInstance<ListQuizzesResponse>(
      {url: `/api/_internal/quizzes`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Create a quiz
 */
const quizzesControllerCreate = (
    createQuizBody: CreateQuizBody,
 options?: SecondParameter<typeof customInstance<CreateQuizResponse>>,) => {
      return customInstance<CreateQuizResponse>(
      {url: `/api/_internal/quizzes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createQuizBody
    },
      options);
    }
  
/**
 * @summary Get quiz questions
 */
const quizzesControllerGetQuestions = (
    enrollmentId: number,
 options?: SecondParameter<typeof customInstance<GetQuizQuestionsResponse>>,) => {
      return customInstance<GetQuizQuestionsResponse>(
      {url: `/api/_internal/quizzes/enrollments/${enrollmentId}/questions`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Submit quiz answers
 */
const quizzesControllerSubmitQuiz = (
    enrollmentId: number,
    submitQuizBody: SubmitQuizBody,
 options?: SecondParameter<typeof customInstance<SubmitQuizResponse>>,) => {
      return customInstance<SubmitQuizResponse>(
      {url: `/api/_internal/quizzes/enrollments/${enrollmentId}/submit`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: submitQuizBody
    },
      options);
    }
  
/**
 * @summary Get quiz by ID (admin)
 */
const quizzesControllerGet = (
    id: number,
 options?: SecondParameter<typeof customInstance<QuizDetailDto>>,) => {
      return customInstance<QuizDetailDto>(
      {url: `/api/_internal/quizzes/${id}`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Update a quiz
 */
const quizzesControllerUpdate = (
    id: number,
    updateQuizBody: UpdateQuizBody,
 options?: SecondParameter<typeof customInstance<UpdateQuizResponse>>,) => {
      return customInstance<UpdateQuizResponse>(
      {url: `/api/_internal/quizzes/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateQuizBody
    },
      options);
    }
  
/**
 * @summary Delete a quiz
 */
const quizzesControllerDelete = (
    id: number,
    params: QuizzesControllerDeleteParams,
 options?: SecondParameter<typeof customInstance<DeleteQuizResponse>>,) => {
      return customInstance<DeleteQuizResponse>(
      {url: `/api/_internal/quizzes/${id}`, method: 'DELETE',
        params
    },
      options);
    }
  
/**
 * @summary Get quiz with questions for builder (admin)
 */
const quizzesControllerGetWithQuestions = (
    id: number,
 options?: SecondParameter<typeof customInstance<QuizWithQuestionsDto>>,) => {
      return customInstance<QuizWithQuestionsDto>(
      {url: `/api/_internal/quizzes/${id}/builder`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Search questions (admin)
 */
const quizzesControllerSearchQuestions = (
    searchQuestionsBody: SearchQuestionsBody,
 options?: SecondParameter<typeof customInstance<SearchQuestionsResponse>>,) => {
      return customInstance<SearchQuestionsResponse>(
      {url: `/api/_internal/quizzes/search-questions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: searchQuestionsBody
    },
      options);
    }
  
/**
 * @summary Create quiz question (admin)
 */
const quizzesControllerCreateQuestion = (
    createQuestionBody: CreateQuestionBody,
 options?: SecondParameter<typeof customInstance<CreateQuestionResponse>>,) => {
      return customInstance<CreateQuestionResponse>(
      {url: `/api/_internal/quizzes/questions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createQuestionBody
    },
      options);
    }
  
/**
 * @summary List lessons (admin, paginated)
 */
const lessonsControllerList = (
    params?: LessonsControllerListParams,
 options?: SecondParameter<typeof customInstance<ListLessonsResponse>>,) => {
      return customInstance<ListLessonsResponse>(
      {url: `/api/_internal/lessons`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Create a new lesson
 */
const lessonsControllerCreate = (
    postLessonBody: PostLessonBody,
 options?: SecondParameter<typeof customInstance<LessonResponse>>,) => {
      return customInstance<LessonResponse>(
      {url: `/api/_internal/lessons`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postLessonBody
    },
      options);
    }
  
/**
 * @summary Search lessons for admin curriculum builder
 */
const lessonsControllerSearch = (
    params?: LessonsControllerSearchParams,
 options?: SecondParameter<typeof customInstance<SearchLessonsResponse>>,) => {
      return customInstance<SearchLessonsResponse>(
      {url: `/api/_internal/lessons/search`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Upload a single lesson file to Azure Storage
 */
const lessonsControllerUploadFile = (
    lessonsControllerUploadFileBody: LessonsControllerUploadFileBody,
 options?: SecondParameter<typeof customInstance<UploadFilesResponse>>,) => {const formData = new FormData();
if(lessonsControllerUploadFileBody.file !== undefined) {
 formData.append(`file`, lessonsControllerUploadFileBody.file)
 }

      return customInstance<UploadFilesResponse>(
      {url: `/api/_internal/lessons/upload-file`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  
/**
 * @summary Get lesson by ID
 */
const lessonsControllerGetById = (
    id: number,
 options?: SecondParameter<typeof customInstance<LessonResponse>>,) => {
      return customInstance<LessonResponse>(
      {url: `/api/_internal/lessons/${id}`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Update a lesson
 */
const lessonsControllerUpdate = (
    id: number,
    putLessonBody: PutLessonBody,
 options?: SecondParameter<typeof customInstance<LessonResponse>>,) => {
      return customInstance<LessonResponse>(
      {url: `/api/_internal/lessons/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putLessonBody
    },
      options);
    }
  
/**
 * @summary Delete a lesson
 */
const lessonsControllerDelete = (
    id: number,
    params: LessonsControllerDeleteParams,
 options?: SecondParameter<typeof customInstance<DeleteLessonResponse>>,) => {
      return customInstance<DeleteLessonResponse>(
      {url: `/api/_internal/lessons/${id}`, method: 'DELETE',
        params
    },
      options);
    }
  
/**
 * @summary Get lesson by slug
 */
const lessonsControllerGetBySlug = (
    slug: string,
 options?: SecondParameter<typeof customInstance<LessonResponse>>,) => {
      return customInstance<LessonResponse>(
      {url: `/api/_internal/lessons/slug/${slug}`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Mark a lesson enrollment as complete
 */
const lessonsControllerCompleteLesson = (
    enrollmentId: number,
    completeLessonBody: CompleteLessonBody,
 options?: SecondParameter<typeof customInstance<CompleteLessonResponse>>,) => {
      return customInstance<CompleteLessonResponse>(
      {url: `/api/_internal/lessons/enrollments/${enrollmentId}/complete`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: completeLessonBody
    },
      options);
    }
  
/**
 * @summary Save video playback position
 */
const lessonsControllerSaveVideoTime = (
    enrollmentId: number,
    saveVideoTimeBody: SaveVideoTimeBody,
 options?: SecondParameter<typeof customInstance<SaveVideoTimeResponse>>,) => {
      return customInstance<SaveVideoTimeResponse>(
      {url: `/api/_internal/lessons/enrollments/${enrollmentId}/video-time`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: saveVideoTimeBody
    },
      options);
    }
  
/**
 * @summary Bulk complete lesson enrollments
 */
const lessonsControllerBulkComplete = (
    bulkCompleteBody: BulkCompleteBody,
 options?: SecondParameter<typeof customInstance<BulkCompleteResponse>>,) => {
      return customInstance<BulkCompleteResponse>(
      {url: `/api/_internal/lessons/enrollments/bulk-complete`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: bulkCompleteBody
    },
      options);
    }
  
/**
 * @summary Initialize Brightcove upload (get credentials)
 */
const videoBrightcoveControllerInit = (
    initBrightcoveBody: InitBrightcoveBody,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/_internal/video/brightcove/init`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: initBrightcoveBody
    },
      options);
    }
  
/**
 * @summary Complete Brightcove upload (trigger ingest)
 */
const videoBrightcoveControllerComplete = (
    completeBrightcoveBody: CompleteBrightcoveBody,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/_internal/video/brightcove/complete`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: completeBrightcoveBody
    },
      options);
    }
  
/**
 * @summary Query Brightcove video data (thumbnail, duration)
 */
const videoBrightcoveControllerQuery = (
    queryBrightcoveBody: QueryBrightcoveBody,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/_internal/video/brightcove/query`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: queryBrightcoveBody
    },
      options);
    }
  
/**
 * @summary Brightcove ingest callback (webhook)
 */
const videoBrightcoveControllerCb = (
    
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/_internal/video/brightcove/cb`, method: 'POST'
    },
      options);
    }
  
/**
 * @summary Ensure account exists
 */
const userControllerEnsureAccount = (
    ensureAccountBody: EnsureAccountBody,
 options?: SecondParameter<typeof customInstance<void | void>>,) => {
      return customInstance<void | void>(
      {url: `/api/_internal/user/ensure-account`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: ensureAccountBody
    },
      options);
    }
  
const userControllerGetMe = (
    
 options?: SecondParameter<typeof customInstance<GetMeResponse>>,) => {
      return customInstance<GetMeResponse>(
      {url: `/api/_internal/user/me`, method: 'GET'
    },
      options);
    }
  
const userControllerWhoAmI = (
    
 options?: SecondParameter<typeof customInstance<WhoAmIResponseDto>>,) => {
      return customInstance<WhoAmIResponseDto>(
      {url: `/api/_internal/user/whoami`, method: 'GET'
    },
      options);
    }
  
const userControllerGetFeed = (
    params: UserControllerGetFeedParams,
 options?: SecondParameter<typeof customInstance<GetFeedResponse>>,) => {
      return customInstance<GetFeedResponse>(
      {url: `/api/_internal/user/feed`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * Returns incomplete lesson enrollments that have a due date, with due instant in [startDate, endDate] inclusive in the given timezone. Locked lessons are included.
 * @summary Scheduled lessons (due-dated) in an inclusive calendar range
 */
const userControllerGetScheduledLessons = (
    params: UserControllerGetScheduledLessonsParams,
 options?: SecondParameter<typeof customInstance<GetFeedResponse>>,) => {
      return customInstance<GetFeedResponse>(
      {url: `/api/_internal/user/feed/scheduled`, method: 'GET',
        params
    },
      options);
    }
  
const userControllerGetUpcomingLessons = (
    params: UserControllerGetUpcomingLessonsParams,
 options?: SecondParameter<typeof customInstance<GetFeedResponse>>,) => {
      return customInstance<GetFeedResponse>(
      {url: `/api/_internal/user/feed/upcoming`, method: 'GET',
        params
    },
      options);
    }
  
const userControllerGetEnrolledCourses = (
    params?: UserControllerGetEnrolledCoursesParams,
 options?: SecondParameter<typeof customInstance<GetEnrolledCoursesResponse>>,) => {
      return customInstance<GetEnrolledCoursesResponse>(
      {url: `/api/_internal/user/enrolled-courses`, method: 'GET',
        params
    },
      options);
    }
  
const userControllerGetOverdueLessons = (
    params: UserControllerGetOverdueLessonsParams,
 options?: SecondParameter<typeof customInstance<GetFeedResponse>>,) => {
      return customInstance<GetFeedResponse>(
      {url: `/api/_internal/user/overdue-lessons`, method: 'GET',
        params
    },
      options);
    }
  
const userControllerGetRecentActivity = (
    params?: UserControllerGetRecentActivityParams,
 options?: SecondParameter<typeof customInstance<GetUserRecentActivityResponse>>,) => {
      return customInstance<GetUserRecentActivityResponse>(
      {url: `/api/_internal/user/recent-activity`, method: 'GET',
        params
    },
      options);
    }
  
const userControllerGetActiveCourses = (
    params?: UserControllerGetActiveCoursesParams,
 options?: SecondParameter<typeof customInstance<GetUserActiveCoursesResponse>>,) => {
      return customInstance<GetUserActiveCoursesResponse>(
      {url: `/api/_internal/user/courses/active`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Active playlist enrollments for current user
 */
const userControllerGetActivePlaylists = (
    
 options?: SecondParameter<typeof customInstance<GetUserActivePlaylistsResponse>>,) => {
      return customInstance<GetUserActivePlaylistsResponse>(
      {url: `/api/_internal/user/playlists/active`, method: 'GET'
    },
      options);
    }
  
const userControllerGetFinishedCourses = (
    params?: UserControllerGetFinishedCoursesParams,
 options?: SecondParameter<typeof customInstance<GetUserFinishedCoursesResponse>>,) => {
      return customInstance<GetUserFinishedCoursesResponse>(
      {url: `/api/_internal/user/courses/finished`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Update user settings
 */
const userControllerUpdateSettings = (
    updateSettingsBody: UpdateSettingsBody,
 options?: SecondParameter<typeof customInstance<UpdateSettingsResponse>>,) => {
      return customInstance<UpdateSettingsResponse>(
      {url: `/api/_internal/user/settings`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateSettingsBody
    },
      options);
    }
  
const userControllerGetNotifications = (
    params?: UserControllerGetNotificationsParams,
 options?: SecondParameter<typeof customInstance<GetNotificationsResponse>>,) => {
      return customInstance<GetNotificationsResponse>(
      {url: `/api/_internal/user/notifications`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Register push notification token
 */
const userControllerRegisterNotificationToken = (
    registerNotificationTokenBody: RegisterNotificationTokenBody,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/_internal/user/notification-token`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: registerNotificationTokenBody
    },
      options);
    }
  
/**
 * @summary Mark all notifications as read
 */
const userControllerMarkNotificationsRead = (
    
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/_internal/user/notifications/read`, method: 'POST'
    },
      options);
    }
  
/**
 * @summary Mark one notification as read
 */
const userControllerMarkNotificationRead = (
    id: number,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/_internal/user/notifications/${id}/read`, method: 'PUT'
    },
      options);
    }
  
/**
 * @summary Enqueue refresh my stats
 */
const userControllerRefreshStats = (
    
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/_internal/user/refresh-stats`, method: 'POST'
    },
      options);
    }
  
/**
 * @summary Request auto-enrollment
 */
const userControllerRequestAutoEnrollment = (
    
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/_internal/user/request-auto-enrollment`, method: 'POST'
    },
      options);
    }
  
const userControllerGetAnnouncementsAssigned = (
    params?: UserControllerGetAnnouncementsAssignedParams,
 options?: SecondParameter<typeof customInstance<GetLearnerAssignedResponse>>,) => {
      return customInstance<GetLearnerAssignedResponse>(
      {url: `/api/_internal/user/announcements/assigned`, method: 'GET',
        params
    },
      options);
    }
  
const userControllerGetAnnouncementsNotifications = (
    params?: UserControllerGetAnnouncementsNotificationsParams,
 options?: SecondParameter<typeof customInstance<GetLearnerNotificationsResponse>>,) => {
      return customInstance<GetLearnerNotificationsResponse>(
      {url: `/api/_internal/user/announcements/notifications`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Complete announcement
 */
const userControllerCompleteAnnouncement = (
    announcementSlug: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/_internal/user/announcements/${announcementSlug}/complete`, method: 'PUT'
    },
      options);
    }
  
/**
 * @summary Get user streak information
 */
const userStreaksControllerGetStreakInfo = (
    
 options?: SecondParameter<typeof customInstance<GetStreakInfoResponse>>,) => {
      return customInstance<GetStreakInfoResponse>(
      {url: `/api/_internal/user/streak-info`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Update streak pause state
 */
const userStreaksControllerUpdateStreakState = (
    updateStreakStateBody: UpdateStreakStateBody,
 options?: SecondParameter<typeof customInstance<UpdateStreakStateResponse>>,) => {
      return customInstance<UpdateStreakStateResponse>(
      {url: `/api/_internal/user/update-streak-state`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateStreakStateBody
    },
      options);
    }
  
/**
 * @summary List users in cohort
 */
const usersControllerList = (
    params?: UsersControllerListParams,
 options?: SecondParameter<typeof customInstance<ListUsersResponse>>,) => {
      return customInstance<ListUsersResponse>(
      {url: `/api/_internal/users`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Get user by id
 */
const usersControllerGetUserById = (
    userId: number,
 options?: SecondParameter<typeof customInstance<GetUserByIdResponse>>,) => {
      return customInstance<GetUserByIdResponse>(
      {url: `/api/_internal/users/${userId}`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Get user training feed
 */
const usersControllerGetFeed = (
    userId: number,
    params?: UsersControllerGetFeedParams,
 options?: SecondParameter<typeof customInstance<AdminFeedResponse>>,) => {
      return customInstance<AdminFeedResponse>(
      {url: `/api/_internal/users/${userId}/feed`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Get user overdue lessons
 */
const usersControllerGetOverdueLessons = (
    userId: number,
    params: UsersControllerGetOverdueLessonsParams,
 options?: SecondParameter<typeof customInstance<AdminFeedResponse>>,) => {
      return customInstance<AdminFeedResponse>(
      {url: `/api/_internal/users/${userId}/overdue-lessons`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Get user recent activity
 */
const usersControllerGetRecentActivity = (
    userId: number,
    params?: UsersControllerGetRecentActivityParams,
 options?: SecondParameter<typeof customInstance<GetRecentActivityResponse>>,) => {
      return customInstance<GetRecentActivityResponse>(
      {url: `/api/_internal/users/${userId}/recent-activity`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Get user active courses
 */
const usersControllerGetActiveCourses = (
    userId: number,
 options?: SecondParameter<typeof customInstance<GetActiveCoursesResponse>>,) => {
      return customInstance<GetActiveCoursesResponse>(
      {url: `/api/_internal/users/${userId}/courses/active`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Get user active playlists
 */
const usersControllerGetActivePlaylists = (
    userId: number,
 options?: SecondParameter<typeof customInstance<GetUserActivePlaylistsResponse>>,) => {
      return customInstance<GetUserActivePlaylistsResponse>(
      {url: `/api/_internal/users/${userId}/playlists/active`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Get user finished courses
 */
const usersControllerGetFinishedCourses = (
    userId: number,
 options?: SecondParameter<typeof customInstance<GetFinishedCoursesResponse>>,) => {
      return customInstance<GetFinishedCoursesResponse>(
      {url: `/api/_internal/users/${userId}/courses/finished`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Get user recommended courses
 */
const usersControllerGetRecommendedCourses = (
    userId: number,
 options?: SecondParameter<typeof customInstance<GetRecommendedCoursesResponse>>,) => {
      return customInstance<GetRecommendedCoursesResponse>(
      {url: `/api/_internal/users/${userId}/courses/recommended`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Bulk unenroll user from courses
 */
const usersControllerBulkUnenrollFromCourses = (
    userId: number,
    bulkUnenrollCoursesBody: BulkUnenrollCoursesBody,
 options?: SecondParameter<typeof customInstance<BulkUnenrollCoursesResponse>>,) => {
      return customInstance<BulkUnenrollCoursesResponse>(
      {url: `/api/_internal/users/${userId}/courses`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: bulkUnenrollCoursesBody
    },
      options);
    }
  
/**
 * @summary List cohorts with pagination
 */
const cohortsControllerList = (
    params?: CohortsControllerListParams,
 options?: SecondParameter<typeof customInstance<ListCohortsResponse>>,) => {
      return customInstance<ListCohortsResponse>(
      {url: `/api/_internal/cohorts`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Get cohort settings
 */
const cohortsControllerGetSettings = (
    cohortId: number,
 options?: SecondParameter<typeof customInstance<GetCohortSettingsResponse>>,) => {
      return customInstance<GetCohortSettingsResponse>(
      {url: `/api/_internal/cohorts/${cohortId}/settings`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Update cohort settings
 */
const cohortsControllerUpdateSettings = (
    cohortId: number,
    updateCohortSettingsBody: UpdateCohortSettingsBody,
 options?: SecondParameter<typeof customInstance<UpdateCohortSettingsResponse>>,) => {
      return customInstance<UpdateCohortSettingsResponse>(
      {url: `/api/_internal/cohorts/${cohortId}/settings`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateCohortSettingsBody
    },
      options);
    }
  
/**
 * @summary Get dashboard KPI tiles
 */
const teamProgressControllerGetTiles = (
    params: TeamProgressControllerGetTilesParams,
 options?: SecondParameter<typeof customInstance<GetTilesResponse>>,) => {
      return customInstance<GetTilesResponse>(
      {url: `/api/_internal/manager/team-progress/tiles`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Get paginated completed lessons
 */
const teamProgressControllerGetCompletedLessons = (
    params: TeamProgressControllerGetCompletedLessonsParams,
 options?: SecondParameter<typeof customInstance<GetCompletedLessonsResponse>>,) => {
      return customInstance<GetCompletedLessonsResponse>(
      {url: `/api/_internal/manager/team-progress/completed-lessons`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Get lessons completed chart data
 */
const teamProgressControllerGetChart = (
    params: TeamProgressControllerGetChartParams,
 options?: SecondParameter<typeof customInstance<GetChartResponse>>,) => {
      return customInstance<GetChartResponse>(
      {url: `/api/_internal/manager/team-progress/chart`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Get paginated completed courses
 */
const teamProgressControllerGetCompletedCourses = (
    params: TeamProgressControllerGetCompletedCoursesParams,
 options?: SecondParameter<typeof customInstance<GetCompletedCoursesResponse>>,) => {
      return customInstance<GetCompletedCoursesResponse>(
      {url: `/api/_internal/manager/team-progress/completed-courses`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Get paginated active users
 */
const teamProgressControllerGetActiveUsers = (
    params: TeamProgressControllerGetActiveUsersParams,
 options?: SecondParameter<typeof customInstance<GetActiveUsersResponse>>,) => {
      return customInstance<GetActiveUsersResponse>(
      {url: `/api/_internal/manager/team-progress/active-users`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Get paginated inactive users
 */
const teamProgressControllerGetInactiveUsers = (
    params: TeamProgressControllerGetInactiveUsersParams,
 options?: SecondParameter<typeof customInstance<GetInactiveUsersResponse>>,) => {
      return customInstance<GetInactiveUsersResponse>(
      {url: `/api/_internal/manager/team-progress/inactive-users`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Get paginated time in training
 */
const teamProgressControllerGetTimeInTraining = (
    params: TeamProgressControllerGetTimeInTrainingParams,
 options?: SecondParameter<typeof customInstance<GetTimeInTrainingResponse>>,) => {
      return customInstance<GetTimeInTrainingResponse>(
      {url: `/api/_internal/manager/team-progress/time-in-training`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Get paginated users with overdue lessons
 */
const teamProgressControllerGetOverdueLessons = (
    params: TeamProgressControllerGetOverdueLessonsParams,
 options?: SecondParameter<typeof customInstance<GetOverdueLessonsResponse>>,) => {
      return customInstance<GetOverdueLessonsResponse>(
      {url: `/api/_internal/manager/team-progress/overdue-lessons`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Start background CSV export job
 */
const teamProgressControllerStartExport = (
    startExportRequest: StartExportRequest,
 options?: SecondParameter<typeof customInstance<StartExportResponse>>,) => {
      return customInstance<StartExportResponse>(
      {url: `/api/_internal/manager/team-progress/export`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: startExportRequest
    },
      options);
    }
  
/**
 * Returns quiz questions without answers for the user to attempt
 * @summary Get inline quiz questions for a lesson enrollment
 */
const lessonEnrollmentsControllerGetInlineQuizQuestions = (
    lessonEnrollmentId: number,
    params?: LessonEnrollmentsControllerGetInlineQuizQuestionsParams,
 options?: SecondParameter<typeof customInstance<GetInlineQuizQuestionsResponse>>,) => {
      return customInstance<GetInlineQuizQuestionsResponse>(
      {url: `/api/_internal/lesson-enrollments/${lessonEnrollmentId}/inline-quiz/questions`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * Returns the most recent quiz attempt with score and marked answers
 * @summary Get latest quiz result for a lesson enrollment
 */
const lessonEnrollmentsControllerGetInlineQuizLatestResult = (
    lessonEnrollmentId: number,
 options?: SecondParameter<typeof customInstance<GetInlineQuizLatestResultResponse>>,) => {
      return customInstance<GetInlineQuizLatestResultResponse>(
      {url: `/api/_internal/lesson-enrollments/${lessonEnrollmentId}/inline-quiz/latest-result`, method: 'GET'
    },
      options);
    }
  
/**
 * Submits quiz answers, grades them, and returns results
 * @summary Submit inline quiz answers
 */
const lessonEnrollmentsControllerSubmitInlineQuiz = (
    lessonEnrollmentId: number,
    submitInlineQuizRequest: SubmitInlineQuizRequest,
 options?: SecondParameter<typeof customInstance<SubmitInlineQuizResponse>>,) => {
      return customInstance<SubmitInlineQuizResponse>(
      {url: `/api/_internal/lesson-enrollments/${lessonEnrollmentId}/inline-quiz`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: submitInlineQuizRequest
    },
      options);
    }
  
/**
 * @summary Create a note
 */
const notesControllerCreateNote = (
    createNoteBodyDto: CreateNoteBodyDto,
 options?: SecondParameter<typeof customInstance<CreateNoteResponseDto>>,) => {
      return customInstance<CreateNoteResponseDto>(
      {url: `/api/_internal/notes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createNoteBodyDto
    },
      options);
    }
  
/**
 * @summary Search user notes
 */
const notesControllerSearchNotes = (
    params?: NotesControllerSearchNotesParams,
 options?: SecondParameter<typeof customInstance<SearchNotesResponseDto>>,) => {
      return customInstance<SearchNotesResponseDto>(
      {url: `/api/_internal/notes`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Update a note
 */
const notesControllerUpdateNote = (
    id: number,
    updateNoteBodyDto: UpdateNoteBodyDto,
 options?: SecondParameter<typeof customInstance<UpdateNoteResponseDto>>,) => {
      return customInstance<UpdateNoteResponseDto>(
      {url: `/api/_internal/notes/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateNoteBodyDto
    },
      options);
    }
  
/**
 * @summary Delete a note
 */
const notesControllerDeleteNote = (
    id: number,
 options?: SecondParameter<typeof customInstance<DeleteNoteResponseDto>>,) => {
      return customInstance<DeleteNoteResponseDto>(
      {url: `/api/_internal/notes/${id}`, method: 'DELETE'
    },
      options);
    }
  
/**
 * @summary Search comments for a module
 */
const commentsControllerSearchComments = (
    params: CommentsControllerSearchCommentsParams,
 options?: SecondParameter<typeof customInstance<SearchCommentsResponseDto>>,) => {
      return customInstance<SearchCommentsResponseDto>(
      {url: `/api/_internal/comments`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Create a comment
 */
const commentsControllerCreateComment = (
    createCommentBodyDto: CreateCommentBodyDto,
 options?: SecondParameter<typeof customInstance<CreateCommentResponseDto>>,) => {
      return customInstance<CreateCommentResponseDto>(
      {url: `/api/_internal/comments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createCommentBodyDto
    },
      options);
    }
  
/**
 * @summary Get i18n locales
 */
const settingsControllerGetI18nLocales = (
    
 options?: SecondParameter<typeof customInstance<GetI18nLocalesResponse>>,) => {
      return customInstance<GetI18nLocalesResponse>(
      {url: `/api/_internal/settings/i18n`, method: 'GET'
    },
      options);
    }
  
const authControllerWhoAmI = (
    
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/_internal/auth/whoami`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Download blob from Azure Storage
 */
const blobControllerGetBlob = (
    params: BlobControllerGetBlobParams,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/_internal/blob`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Get overview metrics for date range
 */
const scheduledReportsControllerGetOverview = (
    params: ScheduledReportsControllerGetOverviewParams,
 options?: SecondParameter<typeof customInstance<ScheduledReportOverviewDto>>,) => {
      return customInstance<ScheduledReportOverviewDto>(
      {url: `/api/_internal/scheduled-reports/overview`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Get top 10 performers for date range
 */
const scheduledReportsControllerGetTopPerformers = (
    params: ScheduledReportsControllerGetTopPerformersParams,
 options?: SecondParameter<typeof customInstance<ScheduledReportTopPerformerDto[]>>,) => {
      return customInstance<ScheduledReportTopPerformerDto[]>(
      {url: `/api/_internal/scheduled-reports/top-performers`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Get users without completions (paginated)
 */
const scheduledReportsControllerGetUsersWithoutCompletions = (
    params: ScheduledReportsControllerGetUsersWithoutCompletionsParams,
 options?: SecondParameter<typeof customInstance<GetUsersWithoutCompletionsResponseDto>>,) => {
      return customInstance<GetUsersWithoutCompletionsResponseDto>(
      {url: `/api/_internal/scheduled-reports/users-without-completions`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Get division insights (paginated)
 */
const scheduledReportsControllerGetDivisions = (
    params: ScheduledReportsControllerGetDivisionsParams,
 options?: SecondParameter<typeof customInstance<GetDivisionsResponseDto>>,) => {
      return customInstance<GetDivisionsResponseDto>(
      {url: `/api/_internal/scheduled-reports/divisions`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Get supervisor insights (paginated)
 */
const scheduledReportsControllerGetSupervisors = (
    params: ScheduledReportsControllerGetSupervisorsParams,
 options?: SecondParameter<typeof customInstance<GetSupervisorsResponseDto>>,) => {
      return customInstance<GetSupervisorsResponseDto>(
      {url: `/api/_internal/scheduled-reports/supervisors`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Generate and save a report for a month/year
 */
const scheduledReportsControllerGenerateReport = (
    generateReportBody: GenerateReportBody,
 options?: SecondParameter<typeof customInstance<SavedReportMetaDto>>,) => {
      return customInstance<SavedReportMetaDto>(
      {url: `/api/_internal/scheduled-reports/generate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: generateReportBody
    },
      options);
    }
  
/**
 * @summary List saved reports for the user cohort
 */
const scheduledReportsControllerGetSavedReports = (
    
 options?: SecondParameter<typeof customInstance<SavedReportMetaDto[]>>,) => {
      return customInstance<SavedReportMetaDto[]>(
      {url: `/api/_internal/scheduled-reports/saved`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Get a saved report by ID (full data for PDF)
 */
const scheduledReportsControllerGetSavedReportById = (
    id: number,
 options?: SecondParameter<typeof customInstance<GetSavedReportByIdResponseDto>>,) => {
      return customInstance<GetSavedReportByIdResponseDto>(
      {url: `/api/_internal/scheduled-reports/saved/${id}`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Delete a saved report
 */
const scheduledReportsControllerDeleteSavedReport = (
    id: number,
 options?: SecondParameter<typeof customInstance<DeleteSavedReportResponseDto>>,) => {
      return customInstance<DeleteSavedReportResponseDto>(
      {url: `/api/_internal/scheduled-reports/saved/${id}`, method: 'DELETE'
    },
      options);
    }
  
/**
 * @summary Download saved report as PDF
 */
const scheduledReportsControllerGetSavedReportPdf = (
    id: number,
 options?: SecondParameter<typeof customInstance<unknown>>,) => {
      return customInstance<unknown>(
      {url: `/api/_internal/scheduled-reports/saved/${id}/pdf`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Get distribution recipients for scheduled reports
 */
const scheduledReportsControllerGetDistributionRecipients = (
    
 options?: SecondParameter<typeof customInstance<GetDistributionRecipientsResponseDto>>,) => {
      return customInstance<GetDistributionRecipientsResponseDto>(
      {url: `/api/_internal/scheduled-reports/distribution-recipients`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Add recipients to the distribution list
 */
const scheduledReportsControllerAddDistributionRecipients = (
    addDistributionRecipientsBody: AddDistributionRecipientsBody,
 options?: SecondParameter<typeof customInstance<AddDistributionRecipientsResponseDto>>,) => {
      return customInstance<AddDistributionRecipientsResponseDto>(
      {url: `/api/_internal/scheduled-reports/distribution-recipients`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addDistributionRecipientsBody
    },
      options);
    }
  
/**
 * @summary Remove a recipient from the distribution list
 */
const scheduledReportsControllerRemoveDistributionRecipient = (
    id: number,
 options?: SecondParameter<typeof customInstance<RemoveDistributionRecipientResponseDto>>,) => {
      return customInstance<RemoveDistributionRecipientResponseDto>(
      {url: `/api/_internal/scheduled-reports/distribution-recipients/${id}`, method: 'DELETE'
    },
      options);
    }
  
/**
 * @summary Regenerate a report for a month/year
 */
const scheduledReportsControllerRegenerateReport = (
    generateReportBody: GenerateReportBody,
 options?: SecondParameter<typeof customInstance<SavedReportMetaDto>>,) => {
      return customInstance<SavedReportMetaDto>(
      {url: `/api/_internal/scheduled-reports/regenerate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: generateReportBody
    },
      options);
    }
  
/**
 * @summary List cohort announcements (admin)
 */
const announcementsControllerGetList = (
    params?: AnnouncementsControllerGetListParams,
 options?: SecondParameter<typeof customInstance<ListCohortAnnouncementsResponse>>,) => {
      return customInstance<ListCohortAnnouncementsResponse>(
      {url: `/api/_internal/announcements`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Create announcement (admin)
 */
const announcementsControllerCreate = (
    createAnnouncementBody: CreateAnnouncementBody,
 options?: SecondParameter<typeof customInstance<AnnouncementsControllerCreate201>>,) => {
      return customInstance<AnnouncementsControllerCreate201>(
      {url: `/api/_internal/announcements`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAnnouncementBody
    },
      options);
    }
  
/**
 * @summary List enrolled users for an announcement (seen or unseen)
 */
const announcementsControllerGetEnrollments = (
    id: number,
    params?: AnnouncementsControllerGetEnrollmentsParams,
 options?: SecondParameter<typeof customInstance<GetAnnouncementEnrollmentsResponse>>,) => {
      return customInstance<GetAnnouncementEnrollmentsResponse>(
      {url: `/api/_internal/announcements/${id}/enrollments`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Get one announcement (admin)
 */
const announcementsControllerGetOne = (
    id: number,
 options?: SecondParameter<typeof customInstance<GetAnnouncementResponseDto>>,) => {
      return customInstance<GetAnnouncementResponseDto>(
      {url: `/api/_internal/announcements/${id}`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Update announcement (admin)
 */
const announcementsControllerUpdate = (
    id: number,
    updateAnnouncementBody: UpdateAnnouncementBody,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/_internal/announcements/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateAnnouncementBody
    },
      options);
    }
  
/**
 * @summary Soft-delete announcement (admin)
 */
const announcementsControllerDelete = (
    id: number,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/_internal/announcements/${id}`, method: 'DELETE'
    },
      options);
    }
  
/**
 * @summary Publish announcement
 */
const announcementsControllerPublish = (
    id: number,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/_internal/announcements/${id}/publish`, method: 'PUT'
    },
      options);
    }
  
/**
 * @summary Set announcement to draft
 */
const announcementsControllerDraft = (
    id: number,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/_internal/announcements/${id}/draft`, method: 'PUT'
    },
      options);
    }
  
/**
 * @summary Get course library banner
 */
const courseLibraryBannerControllerGetBanner = (
    
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/_internal/course-library-banner`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary List active (non-deleted) award event definitions
 */
const awardEventsInternalControllerList = (
    
 options?: SecondParameter<typeof customInstance<ListAwardEventsResponseDto>>,) => {
      return customInstance<ListAwardEventsResponseDto>(
      {url: `/api/_internal/leaderboards/award-events`, method: 'GET'
    },
      options);
    }
  
/**
 * @summary Get leaderboard row for a user (current month period for the cohort)
 */
const leaderboardsReadInternalControllerGetUserLeaderboard = (
    userId: number,
    params?: LeaderboardsReadInternalControllerGetUserLeaderboardParams,
 options?: SecondParameter<typeof customInstance<UserLeaderboardResponseDto>>,) => {
      return customInstance<UserLeaderboardResponseDto>(
      {url: `/api/_internal/leaderboards/${userId}/user`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Paginated cohort leaderboard (rank, then first name). Without date filters uses `leaderboard` rows for the current period; with `dateFrom` and/or `dateTo` uses summed `user_award_events` and includes every active cohort member.
 */
const leaderboardsReadInternalControllerListCohortLeaderboard = (
    cohortId: number,
    params?: LeaderboardsReadInternalControllerListCohortLeaderboardParams,
 options?: SecondParameter<typeof customInstance<ListCohortLeaderboardResponseDto>>,) => {
      return customInstance<ListCohortLeaderboardResponseDto>(
      {url: `/api/_internal/leaderboards/${cohortId}/cohort`, method: 'GET',
        params
    },
      options);
    }
  
return {identityWebhooksControllerWebhook,rxdControllerGetCourseCurriculum,coursesControllerCreate,coursesControllerList,coursesControllerSearch,coursesControllerGetCurriculumItems,coursesControllerGetCourseModules,coursesControllerListLessons,coursesControllerListQuizzes,coursesControllerListEnrollments,coursesControllerGetById,coursesControllerUpdate,coursesControllerDelete,coursesControllerGetBySlug,coursesControllerGetDetails,coursesControllerGetCurriculum,coursesControllerGetLessonForCourse,coursesControllerGetQuizForCourse,coursesControllerToggleBlacklist,courseEnrollmentsControllerBulkEnroll,courseEnrollmentsControllerBulkUnenroll,courseEnrollmentsControllerEnrollCohort,courseEnrollmentsControllerManageDueDates,courseEnrollmentsControllerBulkComplete,playlistsControllerListPlaylists,playlistsControllerCreatePlaylist,playlistsControllerGetPlaylist,playlistsControllerUpdatePlaylist,playlistsControllerDeletePlaylist,playlistsControllerGetPlaylistCertification,playlistsControllerListEnrollments,playlistEnrollmentsControllerBulkEnroll,playlistEnrollmentsControllerBulkUnenroll,playlistEnrollmentsControllerEnrollCohort,playlistEnrollmentsControllerBulkComplete,quizzesControllerList,quizzesControllerCreate,quizzesControllerGetQuestions,quizzesControllerSubmitQuiz,quizzesControllerGet,quizzesControllerUpdate,quizzesControllerDelete,quizzesControllerGetWithQuestions,quizzesControllerSearchQuestions,quizzesControllerCreateQuestion,lessonsControllerList,lessonsControllerCreate,lessonsControllerSearch,lessonsControllerUploadFile,lessonsControllerGetById,lessonsControllerUpdate,lessonsControllerDelete,lessonsControllerGetBySlug,lessonsControllerCompleteLesson,lessonsControllerSaveVideoTime,lessonsControllerBulkComplete,videoBrightcoveControllerInit,videoBrightcoveControllerComplete,videoBrightcoveControllerQuery,videoBrightcoveControllerCb,userControllerEnsureAccount,userControllerGetMe,userControllerWhoAmI,userControllerGetFeed,userControllerGetScheduledLessons,userControllerGetUpcomingLessons,userControllerGetEnrolledCourses,userControllerGetOverdueLessons,userControllerGetRecentActivity,userControllerGetActiveCourses,userControllerGetActivePlaylists,userControllerGetFinishedCourses,userControllerUpdateSettings,userControllerGetNotifications,userControllerRegisterNotificationToken,userControllerMarkNotificationsRead,userControllerMarkNotificationRead,userControllerRefreshStats,userControllerRequestAutoEnrollment,userControllerGetAnnouncementsAssigned,userControllerGetAnnouncementsNotifications,userControllerCompleteAnnouncement,userStreaksControllerGetStreakInfo,userStreaksControllerUpdateStreakState,usersControllerList,usersControllerGetUserById,usersControllerGetFeed,usersControllerGetOverdueLessons,usersControllerGetRecentActivity,usersControllerGetActiveCourses,usersControllerGetActivePlaylists,usersControllerGetFinishedCourses,usersControllerGetRecommendedCourses,usersControllerBulkUnenrollFromCourses,cohortsControllerList,cohortsControllerGetSettings,cohortsControllerUpdateSettings,teamProgressControllerGetTiles,teamProgressControllerGetCompletedLessons,teamProgressControllerGetChart,teamProgressControllerGetCompletedCourses,teamProgressControllerGetActiveUsers,teamProgressControllerGetInactiveUsers,teamProgressControllerGetTimeInTraining,teamProgressControllerGetOverdueLessons,teamProgressControllerStartExport,lessonEnrollmentsControllerGetInlineQuizQuestions,lessonEnrollmentsControllerGetInlineQuizLatestResult,lessonEnrollmentsControllerSubmitInlineQuiz,notesControllerCreateNote,notesControllerSearchNotes,notesControllerUpdateNote,notesControllerDeleteNote,commentsControllerSearchComments,commentsControllerCreateComment,settingsControllerGetI18nLocales,authControllerWhoAmI,blobControllerGetBlob,scheduledReportsControllerGetOverview,scheduledReportsControllerGetTopPerformers,scheduledReportsControllerGetUsersWithoutCompletions,scheduledReportsControllerGetDivisions,scheduledReportsControllerGetSupervisors,scheduledReportsControllerGenerateReport,scheduledReportsControllerGetSavedReports,scheduledReportsControllerGetSavedReportById,scheduledReportsControllerDeleteSavedReport,scheduledReportsControllerGetSavedReportPdf,scheduledReportsControllerGetDistributionRecipients,scheduledReportsControllerAddDistributionRecipients,scheduledReportsControllerRemoveDistributionRecipient,scheduledReportsControllerRegenerateReport,announcementsControllerGetList,announcementsControllerCreate,announcementsControllerGetEnrollments,announcementsControllerGetOne,announcementsControllerUpdate,announcementsControllerDelete,announcementsControllerPublish,announcementsControllerDraft,courseLibraryBannerControllerGetBanner,awardEventsInternalControllerList,leaderboardsReadInternalControllerGetUserLeaderboard,leaderboardsReadInternalControllerListCohortLeaderboard}};
export type IdentityWebhooksControllerWebhookResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['identityWebhooksControllerWebhook']>>>
export type RxdControllerGetCourseCurriculumResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['rxdControllerGetCourseCurriculum']>>>
export type CoursesControllerCreateResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['coursesControllerCreate']>>>
export type CoursesControllerListResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['coursesControllerList']>>>
export type CoursesControllerSearchResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['coursesControllerSearch']>>>
export type CoursesControllerGetCurriculumItemsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['coursesControllerGetCurriculumItems']>>>
export type CoursesControllerGetCourseModulesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['coursesControllerGetCourseModules']>>>
export type CoursesControllerListLessonsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['coursesControllerListLessons']>>>
export type CoursesControllerListQuizzesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['coursesControllerListQuizzes']>>>
export type CoursesControllerListEnrollmentsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['coursesControllerListEnrollments']>>>
export type CoursesControllerGetByIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['coursesControllerGetById']>>>
export type CoursesControllerUpdateResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['coursesControllerUpdate']>>>
export type CoursesControllerDeleteResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['coursesControllerDelete']>>>
export type CoursesControllerGetBySlugResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['coursesControllerGetBySlug']>>>
export type CoursesControllerGetDetailsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['coursesControllerGetDetails']>>>
export type CoursesControllerGetCurriculumResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['coursesControllerGetCurriculum']>>>
export type CoursesControllerGetLessonForCourseResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['coursesControllerGetLessonForCourse']>>>
export type CoursesControllerGetQuizForCourseResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['coursesControllerGetQuizForCourse']>>>
export type CoursesControllerToggleBlacklistResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['coursesControllerToggleBlacklist']>>>
export type CourseEnrollmentsControllerBulkEnrollResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['courseEnrollmentsControllerBulkEnroll']>>>
export type CourseEnrollmentsControllerBulkUnenrollResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['courseEnrollmentsControllerBulkUnenroll']>>>
export type CourseEnrollmentsControllerEnrollCohortResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['courseEnrollmentsControllerEnrollCohort']>>>
export type CourseEnrollmentsControllerManageDueDatesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['courseEnrollmentsControllerManageDueDates']>>>
export type CourseEnrollmentsControllerBulkCompleteResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['courseEnrollmentsControllerBulkComplete']>>>
export type PlaylistsControllerListPlaylistsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['playlistsControllerListPlaylists']>>>
export type PlaylistsControllerCreatePlaylistResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['playlistsControllerCreatePlaylist']>>>
export type PlaylistsControllerGetPlaylistResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['playlistsControllerGetPlaylist']>>>
export type PlaylistsControllerUpdatePlaylistResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['playlistsControllerUpdatePlaylist']>>>
export type PlaylistsControllerDeletePlaylistResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['playlistsControllerDeletePlaylist']>>>
export type PlaylistsControllerGetPlaylistCertificationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['playlistsControllerGetPlaylistCertification']>>>
export type PlaylistsControllerListEnrollmentsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['playlistsControllerListEnrollments']>>>
export type PlaylistEnrollmentsControllerBulkEnrollResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['playlistEnrollmentsControllerBulkEnroll']>>>
export type PlaylistEnrollmentsControllerBulkUnenrollResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['playlistEnrollmentsControllerBulkUnenroll']>>>
export type PlaylistEnrollmentsControllerEnrollCohortResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['playlistEnrollmentsControllerEnrollCohort']>>>
export type PlaylistEnrollmentsControllerBulkCompleteResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['playlistEnrollmentsControllerBulkComplete']>>>
export type QuizzesControllerListResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['quizzesControllerList']>>>
export type QuizzesControllerCreateResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['quizzesControllerCreate']>>>
export type QuizzesControllerGetQuestionsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['quizzesControllerGetQuestions']>>>
export type QuizzesControllerSubmitQuizResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['quizzesControllerSubmitQuiz']>>>
export type QuizzesControllerGetResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['quizzesControllerGet']>>>
export type QuizzesControllerUpdateResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['quizzesControllerUpdate']>>>
export type QuizzesControllerDeleteResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['quizzesControllerDelete']>>>
export type QuizzesControllerGetWithQuestionsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['quizzesControllerGetWithQuestions']>>>
export type QuizzesControllerSearchQuestionsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['quizzesControllerSearchQuestions']>>>
export type QuizzesControllerCreateQuestionResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['quizzesControllerCreateQuestion']>>>
export type LessonsControllerListResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['lessonsControllerList']>>>
export type LessonsControllerCreateResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['lessonsControllerCreate']>>>
export type LessonsControllerSearchResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['lessonsControllerSearch']>>>
export type LessonsControllerUploadFileResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['lessonsControllerUploadFile']>>>
export type LessonsControllerGetByIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['lessonsControllerGetById']>>>
export type LessonsControllerUpdateResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['lessonsControllerUpdate']>>>
export type LessonsControllerDeleteResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['lessonsControllerDelete']>>>
export type LessonsControllerGetBySlugResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['lessonsControllerGetBySlug']>>>
export type LessonsControllerCompleteLessonResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['lessonsControllerCompleteLesson']>>>
export type LessonsControllerSaveVideoTimeResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['lessonsControllerSaveVideoTime']>>>
export type LessonsControllerBulkCompleteResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['lessonsControllerBulkComplete']>>>
export type VideoBrightcoveControllerInitResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['videoBrightcoveControllerInit']>>>
export type VideoBrightcoveControllerCompleteResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['videoBrightcoveControllerComplete']>>>
export type VideoBrightcoveControllerQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['videoBrightcoveControllerQuery']>>>
export type VideoBrightcoveControllerCbResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['videoBrightcoveControllerCb']>>>
export type UserControllerEnsureAccountResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['userControllerEnsureAccount']>>>
export type UserControllerGetMeResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['userControllerGetMe']>>>
export type UserControllerWhoAmIResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['userControllerWhoAmI']>>>
export type UserControllerGetFeedResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['userControllerGetFeed']>>>
export type UserControllerGetScheduledLessonsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['userControllerGetScheduledLessons']>>>
export type UserControllerGetUpcomingLessonsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['userControllerGetUpcomingLessons']>>>
export type UserControllerGetEnrolledCoursesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['userControllerGetEnrolledCourses']>>>
export type UserControllerGetOverdueLessonsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['userControllerGetOverdueLessons']>>>
export type UserControllerGetRecentActivityResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['userControllerGetRecentActivity']>>>
export type UserControllerGetActiveCoursesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['userControllerGetActiveCourses']>>>
export type UserControllerGetActivePlaylistsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['userControllerGetActivePlaylists']>>>
export type UserControllerGetFinishedCoursesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['userControllerGetFinishedCourses']>>>
export type UserControllerUpdateSettingsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['userControllerUpdateSettings']>>>
export type UserControllerGetNotificationsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['userControllerGetNotifications']>>>
export type UserControllerRegisterNotificationTokenResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['userControllerRegisterNotificationToken']>>>
export type UserControllerMarkNotificationsReadResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['userControllerMarkNotificationsRead']>>>
export type UserControllerMarkNotificationReadResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['userControllerMarkNotificationRead']>>>
export type UserControllerRefreshStatsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['userControllerRefreshStats']>>>
export type UserControllerRequestAutoEnrollmentResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['userControllerRequestAutoEnrollment']>>>
export type UserControllerGetAnnouncementsAssignedResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['userControllerGetAnnouncementsAssigned']>>>
export type UserControllerGetAnnouncementsNotificationsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['userControllerGetAnnouncementsNotifications']>>>
export type UserControllerCompleteAnnouncementResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['userControllerCompleteAnnouncement']>>>
export type UserStreaksControllerGetStreakInfoResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['userStreaksControllerGetStreakInfo']>>>
export type UserStreaksControllerUpdateStreakStateResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['userStreaksControllerUpdateStreakState']>>>
export type UsersControllerListResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['usersControllerList']>>>
export type UsersControllerGetUserByIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['usersControllerGetUserById']>>>
export type UsersControllerGetFeedResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['usersControllerGetFeed']>>>
export type UsersControllerGetOverdueLessonsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['usersControllerGetOverdueLessons']>>>
export type UsersControllerGetRecentActivityResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['usersControllerGetRecentActivity']>>>
export type UsersControllerGetActiveCoursesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['usersControllerGetActiveCourses']>>>
export type UsersControllerGetActivePlaylistsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['usersControllerGetActivePlaylists']>>>
export type UsersControllerGetFinishedCoursesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['usersControllerGetFinishedCourses']>>>
export type UsersControllerGetRecommendedCoursesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['usersControllerGetRecommendedCourses']>>>
export type UsersControllerBulkUnenrollFromCoursesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['usersControllerBulkUnenrollFromCourses']>>>
export type CohortsControllerListResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['cohortsControllerList']>>>
export type CohortsControllerGetSettingsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['cohortsControllerGetSettings']>>>
export type CohortsControllerUpdateSettingsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['cohortsControllerUpdateSettings']>>>
export type TeamProgressControllerGetTilesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['teamProgressControllerGetTiles']>>>
export type TeamProgressControllerGetCompletedLessonsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['teamProgressControllerGetCompletedLessons']>>>
export type TeamProgressControllerGetChartResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['teamProgressControllerGetChart']>>>
export type TeamProgressControllerGetCompletedCoursesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['teamProgressControllerGetCompletedCourses']>>>
export type TeamProgressControllerGetActiveUsersResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['teamProgressControllerGetActiveUsers']>>>
export type TeamProgressControllerGetInactiveUsersResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['teamProgressControllerGetInactiveUsers']>>>
export type TeamProgressControllerGetTimeInTrainingResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['teamProgressControllerGetTimeInTraining']>>>
export type TeamProgressControllerGetOverdueLessonsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['teamProgressControllerGetOverdueLessons']>>>
export type TeamProgressControllerStartExportResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['teamProgressControllerStartExport']>>>
export type LessonEnrollmentsControllerGetInlineQuizQuestionsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['lessonEnrollmentsControllerGetInlineQuizQuestions']>>>
export type LessonEnrollmentsControllerGetInlineQuizLatestResultResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['lessonEnrollmentsControllerGetInlineQuizLatestResult']>>>
export type LessonEnrollmentsControllerSubmitInlineQuizResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['lessonEnrollmentsControllerSubmitInlineQuiz']>>>
export type NotesControllerCreateNoteResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['notesControllerCreateNote']>>>
export type NotesControllerSearchNotesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['notesControllerSearchNotes']>>>
export type NotesControllerUpdateNoteResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['notesControllerUpdateNote']>>>
export type NotesControllerDeleteNoteResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['notesControllerDeleteNote']>>>
export type CommentsControllerSearchCommentsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['commentsControllerSearchComments']>>>
export type CommentsControllerCreateCommentResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['commentsControllerCreateComment']>>>
export type SettingsControllerGetI18nLocalesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['settingsControllerGetI18nLocales']>>>
export type AuthControllerWhoAmIResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['authControllerWhoAmI']>>>
export type BlobControllerGetBlobResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['blobControllerGetBlob']>>>
export type ScheduledReportsControllerGetOverviewResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['scheduledReportsControllerGetOverview']>>>
export type ScheduledReportsControllerGetTopPerformersResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['scheduledReportsControllerGetTopPerformers']>>>
export type ScheduledReportsControllerGetUsersWithoutCompletionsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['scheduledReportsControllerGetUsersWithoutCompletions']>>>
export type ScheduledReportsControllerGetDivisionsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['scheduledReportsControllerGetDivisions']>>>
export type ScheduledReportsControllerGetSupervisorsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['scheduledReportsControllerGetSupervisors']>>>
export type ScheduledReportsControllerGenerateReportResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['scheduledReportsControllerGenerateReport']>>>
export type ScheduledReportsControllerGetSavedReportsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['scheduledReportsControllerGetSavedReports']>>>
export type ScheduledReportsControllerGetSavedReportByIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['scheduledReportsControllerGetSavedReportById']>>>
export type ScheduledReportsControllerDeleteSavedReportResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['scheduledReportsControllerDeleteSavedReport']>>>
export type ScheduledReportsControllerGetSavedReportPdfResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['scheduledReportsControllerGetSavedReportPdf']>>>
export type ScheduledReportsControllerGetDistributionRecipientsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['scheduledReportsControllerGetDistributionRecipients']>>>
export type ScheduledReportsControllerAddDistributionRecipientsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['scheduledReportsControllerAddDistributionRecipients']>>>
export type ScheduledReportsControllerRemoveDistributionRecipientResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['scheduledReportsControllerRemoveDistributionRecipient']>>>
export type ScheduledReportsControllerRegenerateReportResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['scheduledReportsControllerRegenerateReport']>>>
export type AnnouncementsControllerGetListResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['announcementsControllerGetList']>>>
export type AnnouncementsControllerCreateResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['announcementsControllerCreate']>>>
export type AnnouncementsControllerGetEnrollmentsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['announcementsControllerGetEnrollments']>>>
export type AnnouncementsControllerGetOneResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['announcementsControllerGetOne']>>>
export type AnnouncementsControllerUpdateResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['announcementsControllerUpdate']>>>
export type AnnouncementsControllerDeleteResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['announcementsControllerDelete']>>>
export type AnnouncementsControllerPublishResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['announcementsControllerPublish']>>>
export type AnnouncementsControllerDraftResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['announcementsControllerDraft']>>>
export type CourseLibraryBannerControllerGetBannerResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['courseLibraryBannerControllerGetBanner']>>>
export type AwardEventsInternalControllerListResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['awardEventsInternalControllerList']>>>
export type LeaderboardsReadInternalControllerGetUserLeaderboardResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['leaderboardsReadInternalControllerGetUserLeaderboard']>>>
export type LeaderboardsReadInternalControllerListCohortLeaderboardResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getImproveAPI>['leaderboardsReadInternalControllerListCohortLeaderboard']>>>
